import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const ClipboardLetterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.59a1.5 1.5 0 0 1 .04-1.1l3.5-8a1.5 1.5 0 0 1 2.74 0l.63 1.44V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3Zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Zm2.95 6.3a.5.5 0 0 0-.91 0l-3.5 8a.5.5 0 1 0 .92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 0 0 .92-.4l-3.5-8Zm.97 4.7h-2.84L14 10.75 15.42 14Z",
    fill: primaryFill
  }));
};

export const ClipboardLetterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLetterFilledIcon, 'ClipboardLetterFilled');

const ClipboardLetterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v5.84l-.63-1.44a1.5 1.5 0 0 0-.37-.51V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h3.59a1.5 1.5 0 0 0 0 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm5.95 6.3a.5.5 0 0 0-.91 0l-3.5 8a.5.5 0 0 0 .92.4l1.18-2.7h3.72l1.18 2.7a.5.5 0 0 0 .92-.4l-3.5-8Zm.97 4.7h-2.85L14 10.75 15.42 14Z",
    fill: primaryFill
  }));
};

export const ClipboardLetterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLetterRegularIcon, 'ClipboardLetterRegular');

const ClipboardLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-3.5a4.5 4.5 0 0 0-3.74 7H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM19 15.5a3.5 3.5 0 0 0-3.5-3.5h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5Zm-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5Zm2.5 2.5h-3.09a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1Z",
    fill: primaryFill
  }));
};

export const ClipboardLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLinkFilledIcon, 'ClipboardLinkFilled');

const ClipboardLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V11h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h2.76c.12.36.3.7.5 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM19 15.5a3.5 3.5 0 0 0-3.5-3.5h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5Zm-6-3a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5Zm2.5 2.5h-3.09a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1Z",
    fill: primaryFill
  }));
};

export const ClipboardLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardLinkRegularIcon, 'ClipboardLinkRegular');

const ClipboardMonthFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM7 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ClipboardMonthFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardMonthFilledIcon, 'ClipboardMonthFilled');

const ClipboardMonthRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardMonthRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardMonthRegularIcon, 'ClipboardMonthRegular');

const ClipboardMoreFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48c-.43.22-.78.56-1 .99a2.25 2.25 0 0 0-4 0A2.25 2.25 0 0 0 6.98 18H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm1.75 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const ClipboardMoreFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardMoreFilledIcon, 'ClipboardMoreFilled');

const ClipboardMoreRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v10.48c-.43.22-.78.56-1 .99V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h1.25c0 .36.08.7.23 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm1.75 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM13 18.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const ClipboardMoreRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardMoreRegularIcon, 'ClipboardMoreRegular');

const ClipboardNoteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-4a3 3 0 0 0-3 3v4a3 3 0 0 0 .17 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm3.5 8a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-5Zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0-3c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardNoteFilledIcon, 'ClipboardNoteFilled');

const ClipboardNoteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h3.84a3.48 3.48 0 0 1-.3-1H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5V10h1V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm4 7.5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-5Zm0 5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Zm0-3c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardNoteRegularIcon, 'ClipboardNoteRegular');

const ClipboardPasteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5Zm3 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-5Z",
    fill: primaryFill
  }));
};

export const ClipboardPasteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPasteFilledIcon, 'ClipboardPasteFilled');

const ClipboardPasteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v1a.5.5 0 0 0 1 0v-1c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H4.5C3.67 3 3 3.67 3 4.5v12c0 .83.67 1.5 1.5 1.5h3a.5.5 0 0 0 0-1h-3a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5Zm3 0a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3Zm3 3C9.67 7 9 7.67 9 8.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-5ZM10 8.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-8Z",
    fill: primaryFill
  }));
};

export const ClipboardPasteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPasteRegularIcon, 'ClipboardPasteRegular');

const ClipboardPulseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1.57l-.59-1.17a1.5 1.5 0 0 0-2.68 0l-.33.65-.9-2.92a1.5 1.5 0 0 0-2.8-.17L5.53 10H4V4.5C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm5 10H16v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h2.5c.6 0 1.13-.35 1.37-.9l.37-.83.83 2.67a1.5 1.5 0 0 0 2.77.23l.74-1.48c.26.2.58.31.92.31ZM8.98 6.85a.5.5 0 0 0-.94-.05L6.18 11H2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .46-.3L8.4 8.42l1.61 5.23a.5.5 0 0 0 .93.07l1.55-3.1.55 1.1a.5.5 0 0 0 .45.28h4a.5.5 0 0 0 0-1h-3.7l-.85-1.72a.5.5 0 0 0-.9 0l-1.44 2.88-1.63-5.3Z",
    fill: primaryFill
  }));
};

export const ClipboardPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPulseFilledIcon, 'ClipboardPulseFilled');

const ClipboardPulseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5V10h-1V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5V10H4V4.5C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM15 13h1v3.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h1v3.5c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5V13ZM8.98 6.85a.5.5 0 0 0-.94-.05L6.18 11H2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 .46-.3L8.4 8.42l1.61 5.23a.5.5 0 0 0 .93.07l1.55-3.1.55 1.1a.5.5 0 0 0 .45.28h4a.5.5 0 0 0 0-1h-3.7l-.85-1.72a.5.5 0 0 0-.9 0l-1.44 2.88-1.63-5.3Z",
    fill: primaryFill
  }));
};

export const ClipboardPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardPulseRegularIcon, 'ClipboardPulseRegular');

const ClipboardSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76a4.5 4.5 0 0 1 5.56 6.18l2 2c.42.42.54 1.03.35 1.56h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3Zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3ZM8.3 14.6a3.5 3.5 0 1 0-.7.7l2.55 2.55a.5.5 0 0 0 .7-.7L8.3 14.6Zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const ClipboardSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSearchFilledIcon, 'ClipboardSearchFilled');

const ClipboardSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v3.76c.32-.12.65-.2 1-.23V4.5c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-2.59c.12.32.12.68 0 1h2.59c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3Zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3ZM8.3 14.6a3.5 3.5 0 1 0-.7.7l2.55 2.55a.5.5 0 0 0 .7-.7L8.3 14.6Zm-2.8.4a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const ClipboardSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSearchRegularIcon, 'ClipboardSearchRegular');

const ClipboardSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7a5.5 5.5 0 0 0-5.74 8.8H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm3.57 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ClipboardSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSettingsFilledIcon, 'ClipboardSettingsFilled');

const ClipboardSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.7c-.32-.08-.66-.15-1-.18V4.5a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h4.1c.18.36.4.7.66 1H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm3.57 8.44a2 2 0 0 1-1.44 2.48l-.46.12a4.74 4.74 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ClipboardSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardSettingsRegularIcon, 'ClipboardSettingsRegular');

const ClipboardTaskFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm4.85 6.35-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L9 12.29l3.15-3.14a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskFilledIcon, 'ClipboardTaskFilled');

const ClipboardTaskRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.85 9.85a.5.5 0 0 0-.7-.7L9 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5ZM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskRegularIcon, 'ClipboardTaskRegular');

const ClipboardTaskAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76A5.5 5.5 0 0 1 14 9.02V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm4.85 6.35-3.5 3.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7L7 12.29l3.15-3.14a.5.5 0 0 1 .7.7ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskAddFilledIcon, 'ClipboardTaskAddFilled');

const ClipboardTaskAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2c-.65 0-1.2.42-1.41 1H3.5C2.67 3 2 3.67 2 4.5v12c0 .83.67 1.5 1.5 1.5h6.76a5.5 5.5 0 0 1-.66-1H3.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v4.7c.32-.08.66-.15 1-.18V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM6 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm4.85 6.35a.5.5 0 0 0-.7-.7L7 12.29l-1.15-1.14a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l3.5-3.5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskAddRegularIcon, 'ClipboardTaskAddRegular');

const ClipboardTaskListLtrFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm1.35 4.35L7.6 9.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 1 1 .68-.73l.4.36 1.4-1.41a.5.5 0 1 1 .71.7Zm0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0Zm1.65.6h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1 0-1Zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListLtrFilledIcon, 'ClipboardTaskListLtrFilled');

const ClipboardTaskListLtrRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.35 7.85a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75Zm0 4.3c.2.2.2.5 0 .7L7.6 14.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0Zm1.65.6a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1H11Zm-.5-4.5c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 0 1H11a.5.5 0 0 1-.5-.5ZM8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3ZM8 3.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM5.5 4h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListLtrRegularIcon, 'ClipboardTaskListLtrRegular');

const ClipboardTaskListRtlFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm5.35 4.15a.5.5 0 0 0-.7 0l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75a.5.5 0 0 0 0-.7Zm0 5.7a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75ZM6.5 8a.5.5 0 0 0 0 1H9a.5.5 0 0 0 0-1H6.5ZM6 13.5c0 .28.22.5.5.5H9a.5.5 0 0 0 0-1H6.5a.5.5 0 0 0-.5.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListRtlFilledIcon, 'ClipboardTaskListRtlFilled');

const ClipboardTaskListRtlRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.85 7.15c.2.2.2.5 0 .7L12.1 9.6a.5.5 0 0 1-.69.02l-.75-.69a.5.5 0 0 1 .68-.73l.4.36 1.4-1.41c.2-.2.52-.2.71 0Zm0 5.7a.5.5 0 0 0-.7-.7l-1.42 1.4-.4-.35a.5.5 0 0 0-.67.73l.75.69c.2.18.5.17.7-.02l1.74-1.75ZM6.5 8a.5.5 0 0 0 0 1H9a.5.5 0 0 0 0-1H6.5ZM6 13.5c0-.28.22-.5.5-.5H9a.5.5 0 0 1 0 1H6.5a.5.5 0 0 1-.5-.5ZM7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59ZM8.5 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1Z",
    fill: primaryFill
  }));
};

export const ClipboardTaskListRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTaskListRtlRegularIcon, 'ClipboardTaskListRtlRegular');

const ClipboardTextEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v4.73c-.33.14-.63.34-.9.61L10.94 14H6.5a.5.5 0 0 0 0 1h3.49a3.2 3.2 0 0 0-.56 1.16l-.37 1.5c-.03.11-.05.23-.06.34H5.5A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59Zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5ZM13.5 8h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1ZM10 11.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5Zm.98 3.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const ClipboardTextEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextEditFilledIcon, 'ClipboardTextEditFilled');

const ClipboardTextEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM6 14.5c0-.28.22-.5.5-.5h4.44l-.67.67c-.1.1-.2.21-.28.33H6.5a.5.5 0 0 1-.5-.5ZM9.22 17H5.5a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v5.44l.1-.1c.27-.27.57-.47.9-.6V4.5c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H9l.06-.35.16-.65ZM12 3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3c.28 0 .5.22.5.5Zm-1.02 11.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const ClipboardTextEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextEditRegularIcon, 'ClipboardTextEditRegular');

const ClipboardTextLtrFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 2c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3Zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Zm-5 5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm0 3h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM6 14.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTextLtrFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLtrFilledIcon, 'ClipboardTextLtrFilled');

const ClipboardTextLtrRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 8a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM6 11.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm2-12c-.65 0-1.2.42-1.41 1H5.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-12c0-.83-.67-1.5-1.5-1.5h-1.59c-.2-.58-.76-1-1.41-1h-3Zm3 1a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Zm-6 1h1.59c.2.58.76 1 1.41 1h3c.65 0 1.2-.42 1.41-1h1.59c.28 0 .5.22.5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-12c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ClipboardTextLtrRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextLtrRegularIcon, 'ClipboardTextLtrRegular');

const ClipboardTextRtlFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59Zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5ZM10.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM6 8.5c0 .28.22.5.5.5h7a.5.5 0 0 0 0-1h-7a.5.5 0 0 0-.5.5ZM8.5 14a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: primaryFill
  }));
};

export const ClipboardTextRtlFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextRtlFilledIcon, 'ClipboardTextRtlFilled');

const ClipboardTextRtlRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M10.5 11a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8.5 14a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7.09 3c.2-.58.76-1 1.41-1h3c.65 0 1.2.42 1.41 1h1.59c.83 0 1.5.67 1.5 1.5v12c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-12C4 3.67 4.67 3 5.5 3h1.59Zm4.91.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5ZM7.09 4H5.5a.5.5 0 0 0-.5.5v12c0 .28.22.5.5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-1.59c-.2.58-.76 1-1.41 1h-3a1.5 1.5 0 0 1-1.41-1Z",
    fill: primaryFill
  }));
};

export const ClipboardTextRtlRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClipboardTextRtlRegularIcon, 'ClipboardTextRtlRegular');

const ClockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H10V5.41A.5.5 0 0 0 9.5 5Z",
    fill: primaryFill
  }));
};

export const ClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockFilledIcon, 'ClockFilled');

const ClockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14Zm-.5 2a.5.5 0 0 1 .5.41V10h2.5a.5.5 0 0 1 .09 1H9.5a.5.5 0 0 1-.5-.41V5.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockRegularIcon, 'ClockRegular');

const ClockAlarmFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.76 3.37A3.16 3.16 0 0 0 2 5.19c0 1.08.53 2.03 1.35 2.61a7 7 0 0 0 1.36 6.78l-1.56 1.57a.5.5 0 0 0 .7.7l1.57-1.56a6.97 6.97 0 0 0 9.16 0l1.57 1.56a.5.5 0 0 0 .7-.7l-1.56-1.57a6.97 6.97 0 0 0 1.35-6.8 3.17 3.17 0 1 0-4.41-4.42 7 7 0 0 0-4.47 0ZM5.16 3c.66 0 1.25.3 1.65.77a7.03 7.03 0 0 0-3.06 3.07A2.2 2.2 0 0 1 5.17 3Zm8.02.76A2.16 2.16 0 0 1 17 5.18c0 .66-.3 1.25-.76 1.65a7.03 7.03 0 0 0-3.06-3.07ZM9.5 6c.28 0 .5.22.5.5V10h2.5a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5v-4c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const ClockAlarmFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockAlarmFilledIcon, 'ClockAlarmFilled');

const ClockAlarmRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h3a.5.5 0 1 0 0-1H10V6.5ZM3.35 7.8A3.19 3.19 0 0 1 5.17 2c1.07 0 2.02.54 2.6 1.37a7 7 0 0 1 4.46 0A3.16 3.16 0 0 1 18 5.16c0 1.08-.54 2.04-1.36 2.61a7 7 0 0 1-1.35 6.8l1.56 1.57a.5.5 0 0 1-.7.7l-1.57-1.56a6.97 6.97 0 0 1-9.16 0l-1.57 1.56a.5.5 0 1 1-.7-.7l1.56-1.57A6.97 6.97 0 0 1 3.35 7.8ZM3 5.19c0 .66.3 1.25.75 1.65a7.03 7.03 0 0 1 3.06-3.07C6.41 3.3 5.82 3 5.17 3 3.97 3 3 3.98 3 5.19Zm13.24 1.64a2.17 2.17 0 1 0-3.06-3.07 7.03 7.03 0 0 1 3.06 3.07ZM4 10a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z",
    fill: primaryFill
  }));
};

export const ClockAlarmRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockAlarmRegularIcon, 'ClockAlarmRegular');

const ClockArrowDownloadFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1-.59 15.98 5.5 5.5 0 0 0-7.39-7.39L3 9a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H11V4.41a.5.5 0 0 0-.5-.41ZM1 14.5a4.5 4.5 0 0 1 4-4.47v3.76l-.65-.64a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 1 0-.7-.7l-.65.64v-3.76a4.5 4.5 0 1 1-5 4.47Zm7 2a.5.5 0 0 0-.5-.5h-4a.5.5 0 1 0 0 1h4a.5.5 0 0 0 .5-.5Z",
    fill: primaryFill
  }));
};

export const ClockArrowDownloadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockArrowDownloadFilledIcon, 'ClockArrowDownloadFilled');

const ClockArrowDownloadRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1-.59 15.98c.16-.31.29-.64.38-.98H11a7 7 0 1 0-7-6.8c-.34.1-.67.23-.98.39L3 9a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 1 .5.41V9h2.5a.5.5 0 0 1 .09 1H10.5a.5.5 0 0 1-.5-.41V4.5c0-.28.22-.5.5-.5ZM1 14.5a4.5 4.5 0 0 1 4-4.47v3.76l-.65-.64a.5.5 0 0 0-.7.7l1.5 1.5c.2.2.5.2.7 0l1.5-1.5a.5.5 0 1 0-.7-.7l-.65.64v-3.76a4.5 4.5 0 1 1-5 4.47Zm7 2a.5.5 0 0 0-.5-.5h-4a.5.5 0 1 0 0 1h4a.5.5 0 0 0 .5-.5Z",
    fill: primaryFill
  }));
};

export const ClockArrowDownloadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockArrowDownloadRegularIcon, 'ClockArrowDownloadRegular');

const ClockDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1-.59 15.98 5.5 5.5 0 0 0-7.39-7.39L3 9a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H11V4.41a.5.5 0 0 0-.5-.41ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7L5.5 13.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L6.21 14.5l1.14-1.15Z",
    fill: primaryFill
  }));
};

export const ClockDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockDismissFilledIcon, 'ClockDismissFilled');

const ClockDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1-.59 15.98c.16-.31.29-.64.38-.98H11a7 7 0 1 0-7-6.8c-.34.1-.67.23-.98.39L3 9a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 1 .5.41V9h2.5a.5.5 0 0 1 .09 1H10.5a.5.5 0 0 1-.5-.41V4.5c0-.28.22-.5.5-.5ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7L5.5 13.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L6.21 14.5l1.14-1.15Z",
    fill: primaryFill
  }));
};

export const ClockDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockDismissRegularIcon, 'ClockDismissRegular');

const ClockLockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 1-1 15.94V14a2 2 0 0 0-1.5-1.94V12A3 3 0 0 0 2 10.33V10a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H10V5.41A.5.5 0 0 0 9.5 5Zm-7 7v1H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const ClockLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockLockFilledIcon, 'ClockLockFilled');

const ClockLockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 1-1 15.94v-1.01a7 7 0 1 0-5.97-7.54c-.41.23-.76.55-1.02.94L2 10a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 1 .5.41V10h2.5a.5.5 0 0 1 .09 1H9.5a.5.5 0 0 1-.5-.41V5.5c0-.28.22-.5.5-.5Zm-7 7v1H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const ClockLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockLockRegularIcon, 'ClockLockRegular');

const ClockPauseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1-.59 15.98 5.5 5.5 0 0 0-7.39-7.39L3 9a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H11V4.41a.5.5 0 0 0-.5-.41ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM4 17a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5Zm3 0a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5Z",
    fill: primaryFill
  }));
};

export const ClockPauseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockPauseFilledIcon, 'ClockPauseFilled');

const ClockPauseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1-.59 15.98c.16-.31.29-.64.38-.98H11a7 7 0 1 0-7-6.8c-.34.1-.67.23-.98.39L3 9a8 8 0 0 1 8-8Zm-.5 3a.5.5 0 0 1 .5.41V9h2.5a.5.5 0 0 1 .09 1H10.5a.5.5 0 0 1-.5-.41V4.5c0-.28.22-.5.5-.5ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM4 17a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5Zm3 0a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5Z",
    fill: primaryFill
  }));
};

export const ClockPauseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockPauseRegularIcon, 'ClockPauseRegular');

const ClockToolboxFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1 0 16v-3.5a2.5 2.5 0 0 0-2.04-2.46A2.5 2.5 0 0 0 6.5 9h-2c-.56 0-1.07.18-1.49.49A8 8 0 0 1 11 1Zm-.5 3a.5.5 0 0 0-.5.5v5.09a.5.5 0 0 0 .5.41h3.09a.5.5 0 0 0-.09-1H11V4.41a.5.5 0 0 0-.5-.41ZM3 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15H8v-.5a.5.5 0 0 0-1 0v.5H4v-.5a.5.5 0 0 0-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H3Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5ZM8 16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 1 17.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0V16Z",
    fill: primaryFill
  }));
};

export const ClockToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockToolboxFilledIcon, 'ClockToolboxFilled');

const ClockToolboxRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 1a8 8 0 1 1 0 16v-1a7 7 0 1 0-7-7v.05c-.36.07-.7.23-.99.44A8 8 0 0 1 11 1Zm-.5 3a.5.5 0 0 1 .5.41V9h2.5a.5.5 0 0 1 .09 1H10.5a.5.5 0 0 1-.5-.41V4.5c0-.28.22-.5.5-.5ZM3 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15H8v-.5a.5.5 0 0 0-1 0v.5H4v-.5a.5.5 0 0 0-1 0v.5H1v-1.5c0-.83.67-1.5 1.5-1.5H3Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5ZM8 16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 1 17.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0V16Z",
    fill: primaryFill
  }));
};

export const ClockToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClockToolboxRegularIcon, 'ClockToolboxRegular');

const ClosedCaptionFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5Zm1.4 3.24c.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 1 1 .7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76Zm7.95.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22c-.41.21-.85.76-.85 1.87s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 0 1 .7.7c-.65.65-1.63.82-2.45.41-.84-.42-1.4-1.37-1.4-2.76 0-1.39.56-2.34 1.4-2.76.82-.41 1.8-.24 2.45.4Z",
    fill: primaryFill
  }));
};

export const ClosedCaptionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionFilledIcon, 'ClosedCaptionFilled');

const ClosedCaptionRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.4 7.24c.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 0 1 .7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76Zm7.95.4a2.12 2.12 0 0 0-2.45-.4c-.84.42-1.4 1.37-1.4 2.76 0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 0 0-.7-.71c-.35.35-.87.43-1.3.22-.41-.21-.85-.76-.85-1.87s.44-1.66.85-1.87c.43-.21.95-.13 1.3.22a.5.5 0 0 0 .7-.7ZM2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v6c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5Z",
    fill: primaryFill
  }));
};

export const ClosedCaptionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionRegularIcon, 'ClosedCaptionRegular');

const ClosedCaptionOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l1.48 1.48A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h10l.28-.01 1.87 1.86a.5.5 0 0 0 .7-.7l-1.48-1.48-3.7-3.7-1.05-1.05L10.5 9.8 8.94 8.23 7.77 7.06 4.72 4.01 2.85 2.15Zm4.46 5.87c-.16 0-.31.04-.46.11C6.44 8.34 6 8.9 6 10s.44 1.66.85 1.87c.43.21.95.13 1.3-.22a.5.5 0 1 1 .7.7c-.65.65-1.63.82-2.45.41C5.56 12.34 5 11.39 5 10c0-1.39.56-2.34 1.4-2.76l.1-.04.81.82Zm3.42.59L6.13 4H15a3 3 0 0 1 3 3v6c0 .8-.31 1.52-.82 2.06l-5.64-5.64c.13-.73.48-1.12.8-1.29.44-.21.96-.13 1.3.22a.5.5 0 0 0 .71-.7 2.12 2.12 0 0 0-2.45-.41c-.52.26-.93.72-1.17 1.37Z",
    fill: primaryFill
  }));
};

export const ClosedCaptionOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionOffFilledIcon, 'ClosedCaptionOffFilled');

const ClosedCaptionOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l1.48 1.48A3 3 0 0 0 2 7v6a3 3 0 0 0 3 3h10l.28-.01 1.87 1.86a.5.5 0 0 0 .7-.7l-1.48-1.48-.76-.77-2.93-2.93-1.06-1.05L10.5 9.8 8.94 8.23 7.77 7.06 4.72 4.01 2.85 2.15ZM14.3 15H5a2 2 0 0 1-2-2V7a2 2 0 0 1 1.39-1.9l2.1 2.1-.09.04C5.56 7.66 5 8.61 5 10c0 1.39.56 2.34 1.4 2.76.82.41 1.8.24 2.45-.4a.5.5 0 1 0-.7-.71c-.35.35-.87.43-1.3.22C6.44 11.66 6 11.1 6 10s.44-1.66.85-1.87c.15-.07.3-.1.46-.11L14.3 15Zm2.9.06-.72-.7A2 2 0 0 0 17 13V7a2 2 0 0 0-2-2H7.12l-1-1H15a3 3 0 0 1 3 3v6c0 .8-.31 1.52-.82 2.06Zm-5.65-5.64-.81-.81c.24-.65.65-1.11 1.17-1.37.82-.41 1.8-.24 2.45.4a.5.5 0 0 1-.7.71 1.12 1.12 0 0 0-1.3-.22c-.33.17-.68.56-.8 1.3Z",
    fill: primaryFill
  }));
};

export const ClosedCaptionOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ClosedCaptionOffRegularIcon, 'ClosedCaptionOffRegular');

const CloudFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0 1 18 11.62 3.33 3.33 0 0 1 14.72 15H5.28A3.33 3.33 0 0 1 2 11.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 5.9 7.18 4 10 4Z",
    fill: primaryFill
  }));
};

export const CloudFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudFilledIcon, 'CloudFilled');

const CloudRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0 1 18 11.62 3.33 3.33 0 0 1 14.72 15H5.28A3.33 3.33 0 0 1 2 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4Zm0 1C7.89 5 6.55 6.32 6.35 8.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 11.62 2.33 2.33 0 0 0 5.28 14h9.44A2.33 2.33 0 0 0 17 11.62a2.33 2.33 0 0 0-2.28-2.37h-.07a1 1 0 0 1-1-.9C13.45 6.32 12.11 5 10 5Z",
    fill: primaryFill
  }));
};

export const CloudRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudRegularIcon, 'CloudRegular');

const CloudAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66A5.74 5.74 0 0 0 7.77 13H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2Zm3.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V13h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V14h-1.5a.5.5 0 0 1 0-1H13v-1.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const CloudAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudAddFilledIcon, 'CloudAddFilled');

const CloudAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 0 0-2.15-1.6h-.07a1 1 0 0 1-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2Zm3.5 16a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V13h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V14h-1.5a.5.5 0 0 1 0-1H13v-1.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const CloudAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudAddRegularIcon, 'CloudAddRegular');

const CloudArchiveFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07c1.24 0 2.32.7 2.88 1.75H11a2 2 0 0 0-1 3.73V15H5.28A3.33 3.33 0 0 1 2 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4Zm0 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm8 2h-7v3c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-3Zm-4.5 1h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const CloudArchiveFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArchiveFilledIcon, 'CloudArchiveFilled');

const CloudArchiveRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07c1.24 0 2.32.7 2.88 1.75h-1.21a2.24 2.24 0 0 0-1.67-.75h-.07a1 1 0 0 1-1-.9C13.45 6.32 12.11 5 10 5S6.55 6.32 6.35 8.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 11.62 2.33 2.33 0 0 0 5.28 14H10v1H5.28A3.33 3.33 0 0 1 2 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4Zm0 8a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-7a1 1 0 0 1-1-1Zm8 2h-7v3c0 1.1.9 2 2 2h3a2 2 0 0 0 2-2v-3Zm-4.5 1h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const CloudArchiveRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArchiveRegularIcon, 'CloudArchiveRegular');

const CloudArrowDownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66A5.74 5.74 0 0 0 7.77 13H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2Zm3.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm1.6-4.9L14 14.2v-2.7a.5.5 0 0 0-1 0v2.7l-1.1-1.1a.56.56 0 1 0-.8.8l2 2c.22.22.58.22.8 0l2-2a.56.56 0 1 0-.8-.8Z",
    fill: primaryFill
  }));
};

export const CloudArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowDownFilledIcon, 'CloudArrowDownFilled');

const CloudArrowDownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 0 0-2.15-1.6h-.07a1 1 0 0 1-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2Zm3.5 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm1.6-4.9L14 14.2v-2.7a.5.5 0 0 0-1 0v2.7l-1.1-1.1a.56.56 0 1 0-.8.8l2 2c.22.22.58.22.8 0l2-2a.56.56 0 1 0-.8-.8Z",
    fill: primaryFill
  }));
};

export const CloudArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowDownRegularIcon, 'CloudArrowDownRegular');

const CloudArrowUpFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66A5.74 5.74 0 0 0 7.77 13H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2Zm3.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm1.6 4.9a.56.56 0 1 0 .8-.8l-2-2a.56.56 0 0 0-.8 0l-2 2a.56.56 0 1 0 .8.8l1.1-1.1v2.7a.5.5 0 0 0 1 0v-2.7l1.1 1.1Z",
    fill: primaryFill
  }));
};

export const CloudArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowUpFilledIcon, 'CloudArrowUpFilled');

const CloudArrowUpRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 0 0-2.15-1.6h-.07a1 1 0 0 1-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2Zm3.5 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm1.6 4.9a.56.56 0 1 0 .8-.8l-2-2a.56.56 0 0 0-.8 0l-2 2a.56.56 0 1 0 .8.8l1.1-1.1v2.7a.5.5 0 0 0 1 0v-2.7l1.1 1.1Z",
    fill: primaryFill
  }));
};

export const CloudArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudArrowUpRegularIcon, 'CloudArrowUpRegular');

const CloudCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66A5.74 5.74 0 0 0 7.77 13H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2Zm8 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const CloudCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudCheckmarkFilledIcon, 'CloudCheckmarkFilled');

const CloudCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 0 0-2.15-1.6h-.07a1 1 0 0 1-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2Zm8 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.85-1.85-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7Z",
    fill: primaryFill
  }));
};

export const CloudCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudCheckmarkRegularIcon, 'CloudCheckmarkRegular');

const CloudDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66A5.74 5.74 0 0 0 7.77 13H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2Zm8 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const CloudDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudDismissFilledIcon, 'CloudDismissFilled');

const CloudDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 0 0-2.15-1.6h-.07a1 1 0 0 1-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2Zm8 11.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15Z",
    fill: primaryFill
  }));
};

export const CloudDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudDismissRegularIcon, 'CloudDismissRegular');

const CloudEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25h-.07A3.33 3.33 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h3.2c.15-.5.42-.96.8-1.33l4.82-4.83c.25-.25.54-.45.85-.59H14.65Zm.16 1.3-4.83 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const CloudEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudEditFilledIcon, 'CloudEditFilled');

const CloudEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h3.2c.1-.36.28-.7.5-1h-3.7A2.33 2.33 0 0 1 3 11.62a2.33 2.33 0 0 1 2.28-2.37h.07a1 1 0 0 0 1-.9C6.55 6.32 7.89 5 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 0 0 .32.63l.13-.14c.25-.25.54-.45.85-.59H14.65Zm.16 1.3-4.83 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 0 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const CloudEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudEditRegularIcon, 'CloudEditRegular');

const CloudErrorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 6.25C14.4 3.92 12.82 2 10 2 7.18 2 5.59 3.9 5.35 6.25h-.07A3.33 3.33 0 0 0 2 9.62 3.33 3.33 0 0 0 5.28 13h2.5a5.75 5.75 0 0 1 10.2-3.1c.02-.09.02-.18.02-.28a3.33 3.33 0 0 0-3.28-3.37h-.07ZM18 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM13.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24Z",
    fill: primaryFill
  }));
};

export const CloudErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudErrorFilledIcon, 'CloudErrorFilled');

const CloudErrorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 6.25C14.4 3.92 12.82 2 10 2 7.18 2 5.59 3.9 5.35 6.25H5.1A3.34 3.34 0 0 0 2 9.62 3.33 3.33 0 0 0 5.28 13h2.5c.02-.34.08-.68.17-1H5.28A2.33 2.33 0 0 1 3 9.62a2.33 2.33 0 0 1 2.28-2.37h.07a1 1 0 0 0 1-.9C6.55 4.32 7.89 3 10 3c2.1 0 3.45 1.32 3.65 3.35a1 1 0 0 0 1 .9h.07c1 0 1.84.66 2.15 1.6.42.3.8.65 1.12 1.06l.01-.29a3.33 3.33 0 0 0-3.28-3.37h-.07ZM18 13.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM13.5 11a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24Z",
    fill: primaryFill
  }));
};

export const CloudErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudErrorRegularIcon, 'CloudErrorRegular');

const CloudFlowFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0 1 18 9.76 2.99 2.99 0 0 0 13.17 11a2.5 2.5 0 0 0-2.32 1.7l-.1.3H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2Zm6 12a2 2 0 1 0-2-2h-.78a1.5 1.5 0 0 0-1.42 1.03l-.55 1.63a.5.5 0 0 1-.47.34H9.73a2 2 0 1 0 .27 1h.78a1.5 1.5 0 0 0 1.42-1.03l.55-1.63a.5.5 0 0 1 .47-.34h1.05c.34.6.99 1 1.73 1Zm0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-7 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: primaryFill
  }));
};

export const CloudFlowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudFlowFilledIcon, 'CloudFlowFilled');

const CloudFlowRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0 1 18 9.76a3 3 0 0 0-1.04-.6 2.3 2.3 0 0 0-2.24-1.91h-.07a1 1 0 0 1-1-.9C13.45 4.32 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h5.94a2.5 2.5 0 0 0-.37.7l-.1.3H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2Zm6.93 8.23A2.01 2.01 0 0 1 18 12a2 2 0 0 1-3.73 1h-1.05a.5.5 0 0 0-.47.34l-.55 1.63A1.5 1.5 0 0 1 10.78 16H10a2 2 0 1 1-.27-1h1.05a.5.5 0 0 0 .47-.34l.55-1.63a1.94 1.94 0 0 1 .1-.22c.25-.5.76-.81 1.32-.81H14a2 2 0 0 1 2.93-1.77Zm-.44.9a1 1 0 0 0-1.49.86V12a1 1 0 0 0 2 .01V12a1 1 0 0 0-.51-.87ZM9 16a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
    fill: primaryFill
  }));
};

export const CloudFlowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudFlowRegularIcon, 'CloudFlowRegular');

const CloudLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25h-.07A3.33 3.33 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h3.76a3.5 3.5 0 0 1 3.46-4h4c.53 0 1.04.12 1.49.33a3.32 3.32 0 0 0-3.27-3.08h-.07ZM12.5 12a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-3.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const CloudLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudLinkFilledIcon, 'CloudLinkFilled');

const CloudLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h4.06a3.48 3.48 0 0 1-.3-1H5.28A2.33 2.33 0 0 1 3 11.62a2.33 2.33 0 0 1 2.28-2.37h.07a1 1 0 0 0 1-.9C6.55 6.32 7.89 5 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 0 0 1 .9h.07c.65 0 1.25.29 1.67.75h.11c.42 0 .83.07 1.2.21a3.28 3.28 0 0 0-2.98-1.96h-.07ZM12.5 11a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-3.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const CloudLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudLinkRegularIcon, 'CloudLinkRegular');

const CloudOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l3.67 3.67c-.25.53-.4 1.11-.47 1.73h-.07A3.33 3.33 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h9.01l2.86 2.85a.5.5 0 0 0 .7-.7l-15-15ZM18 11.62a3.4 3.4 0 0 1-1.45 2.8l-9.5-9.48A4.66 4.66 0 0 1 10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0 1 18 11.62Z",
    fill: primaryFill
  }));
};

export const CloudOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudOffFilledIcon, 'CloudOffFilled');

const CloudOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l3.67 3.67c-.25.53-.4 1.11-.47 1.73H5.1A3.34 3.34 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h9.01l2.86 2.85a.5.5 0 0 0 .7-.7l-15-15ZM13.3 14h-8A2.33 2.33 0 0 1 3 11.62a2.33 2.33 0 0 1 2.28-2.37h.07a1 1 0 0 0 1-.9c.04-.38.11-.74.23-1.06L13.29 14ZM17 11.62c0 .9-.48 1.68-1.18 2.08l.73.73a3.4 3.4 0 0 0 1.45-2.8 3.33 3.33 0 0 0-3.28-3.38h-.07C14.4 5.92 12.82 4 10 4c-1.2 0-2.2.35-2.94.94l.71.71A3.76 3.76 0 0 1 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 0 0 1 .9h.07A2.33 2.33 0 0 1 17 11.62Z",
    fill: primaryFill
  }));
};

export const CloudOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudOffRegularIcon, 'CloudOffRegular');

const CloudSwapFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h2.8a1.5 1.5 0 0 1 .36-1.56l2-2A1.5 1.5 0 0 1 12.9 13h1.18a1.5 1.5 0 0 1 2.47-1.56l1.27 1.27c.1-.34.17-.7.17-1.09a3.33 3.33 0 0 0-3.28-3.37h-.07Zm-2.8 4.6a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L10.71 15h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.29 14h-5.58l1.14-1.15Z",
    fill: primaryFill
  }));
};

export const CloudSwapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSwapFilledIcon, 'CloudSwapFilled');

const CloudSwapRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4c2.82 0 4.41 1.92 4.65 4.25h.07A3.33 3.33 0 0 1 18 11.62c0 .38-.06.75-.17 1.09l-.84-.84.01-.25a2.33 2.33 0 0 0-2.28-2.37h-.07a1 1 0 0 1-1-.9C13.45 6.32 12.11 5 10 5S6.55 6.32 6.35 8.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 11.62 2.33 2.33 0 0 0 5.28 14h2.8a1.5 1.5 0 0 0 0 1h-2.8A3.33 3.33 0 0 1 2 11.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 5.9 7.18 4 10 4Zm1.85 8.85a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L10.71 15h5.58l-1.14 1.15a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7L16.29 14h-5.58l1.14-1.15Z",
    fill: primaryFill
  }));
};

export const CloudSwapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSwapRegularIcon, 'CloudSwapRegular');

const CloudSyncFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66A5.74 5.74 0 0 0 7.77 13H5.28A3.33 3.33 0 0 1 2 9.62a3.33 3.33 0 0 1 3.28-3.37h.07C5.6 3.9 7.18 2 10 2ZM9 13.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H14a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V11c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V16a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z",
    fill: primaryFill
  }));
};

export const CloudSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSyncFilledIcon, 'CloudSyncFilled');

const CloudSyncRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c2.82 0 4.41 1.92 4.65 4.25h.07a3.33 3.33 0 0 1 3.27 3.66c-.32-.4-.7-.76-1.12-1.07a2.3 2.3 0 0 0-2.15-1.6h-.07a1 1 0 0 1-1-.9C13.45 4.33 12.11 3 10 3S6.55 4.32 6.35 6.35a1 1 0 0 1-1 .9h-.07A2.33 2.33 0 0 0 3 9.62 2.33 2.33 0 0 0 5.28 12h2.67c-.09.32-.15.66-.18 1H5.28A3.33 3.33 0 0 1 2 9.62c0-1.8 1.37-3.27 3.1-3.37h.25C5.6 3.9 7.18 2 10 2ZM9 13.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H14a.5.5 0 0 1 0-1h.47a1.97 1.97 0 0 0-.94-.25 2 2 0 0 0-1.44.59.5.5 0 0 1-.71-.71 3 3 0 0 1 3.62-.48V11c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V16a.5.5 0 0 1-1 0v-1.5c0-.28.22-.5.5-.5H13a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 .94.25 2 2 0 0 0 1.44-.59.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z",
    fill: primaryFill
  }));
};

export const CloudSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudSyncRegularIcon, 'CloudSyncRegular');

const CloudWordsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.65 8.25C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h9.44A3.33 3.33 0 0 0 18 11.62a3.33 3.33 0 0 0-3.28-3.37h-.07ZM8.5 7h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM4 11.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const CloudWordsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudWordsFilledIcon, 'CloudWordsFilled');

const CloudWordsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 7a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM4 11.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm7.5-.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm3.15-2.75C14.4 5.92 12.82 4 10 4 7.18 4 5.59 5.9 5.35 8.25H5.1A3.34 3.34 0 0 0 2 11.62 3.33 3.33 0 0 0 5.28 15h9.44A3.33 3.33 0 0 0 18 11.62a3.33 3.33 0 0 0-3.28-3.37h-.07Zm-8.3.1C6.55 6.32 7.89 5 10 5c2.1 0 3.45 1.32 3.65 3.35a1 1 0 0 0 1 .9h.07A2.33 2.33 0 0 1 17 11.62 2.33 2.33 0 0 1 14.72 14H5.28A2.33 2.33 0 0 1 3 11.62a2.33 2.33 0 0 1 2.28-2.37h.07a1 1 0 0 0 1-.9Z",
    fill: primaryFill
  }));
};

export const CloudWordsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloudWordsRegularIcon, 'CloudWordsRegular');

const CloverFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2a3.5 3.5 0 1 0 0 7h3a.5.5 0 0 0 .5-.5v-3A3.5 3.5 0 0 0 5.5 2Zm0 15a3.5 3.5 0 1 1 0-7h3c.28 0 .5.22.5.5v3A3.5 3.5 0 0 1 5.5 17Zm8-15a3.5 3.5 0 1 1 0 7h-3a.5.5 0 0 1-.5-.5v-3A3.5 3.5 0 0 1 13.5 2Zm0 15a3.5 3.5 0 1 0 0-7h-3a.5.5 0 0 0-.5.5v3a3.5 3.5 0 0 0 3.5 3.5Z",
    fill: primaryFill
  }));
};

export const CloverFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloverFilledIcon, 'CloverFilled');

const CloverRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2a3.5 3.5 0 1 0 0 7h3a.5.5 0 0 0 .5-.5v-3A3.5 3.5 0 0 0 5.5 2ZM3 5.5a2.5 2.5 0 0 1 5 0V8H5.5A2.5 2.5 0 0 1 3 5.5ZM5.5 17a3.5 3.5 0 1 1 0-7h3c.28 0 .5.22.5.5v3A3.5 3.5 0 0 1 5.5 17ZM3 13.5a2.5 2.5 0 0 0 5 0V11H5.5A2.5 2.5 0 0 0 3 13.5Zm14-8a3.5 3.5 0 1 0-7 0v3c0 .28.22.5.5.5h3A3.5 3.5 0 0 0 17 5.5ZM13.5 3a2.5 2.5 0 0 1 0 5H11V5.5A2.5 2.5 0 0 1 13.5 3Zm0 14a3.5 3.5 0 1 0 0-7h-3a.5.5 0 0 0-.5.5v3a3.5 3.5 0 0 0 3.5 3.5Zm2.5-3.5a2.5 2.5 0 0 1-5 0V11h2.5a2.5 2.5 0 0 1 2.5 2.5Z",
    fill: primaryFill
  }));
};

export const CloverRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CloverRegularIcon, 'CloverRegular');

const CodeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.94 4.05a.75.75 0 0 0-1.38-.6l-5.5 12.5a.75.75 0 1 0 1.38.6l5.5-12.5Zm1.35 9.8a.75.75 0 0 1-.13-1.06L16.3 10l-2.14-2.8a.75.75 0 0 1 1.18-.9l2.5 3.24c.21.27.21.65 0 .92l-2.5 3.25a.75.75 0 0 1-1.05.13Zm-8.58-7.7c.33.26.39.73.13 1.06L3.7 10l2.14 2.8a.75.75 0 1 1-1.18.9l-2.5-3.24a.75.75 0 0 1 0-.92l2.5-3.25a.75.75 0 0 1 1.05-.13Z",
    fill: primaryFill
  }));
};

export const CodeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeFilledIcon, 'CodeFilled');

const CodeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.97 3.68a.5.5 0 0 0-.94-.36l-5 13a.5.5 0 1 0 .94.36l5-13ZM5.83 6.12c.2.18.23.5.05.7L3.16 10l2.72 3.17a.5.5 0 0 1-.76.66l-3-3.5a.5.5 0 0 1 0-.66l3-3.5a.5.5 0 0 1 .7-.05Zm8.34 8.26a.5.5 0 0 1-.05-.7l2.72-3.18-2.72-3.17a.5.5 0 1 1 .76-.66l3 3.5a.5.5 0 0 1 0 .66l-3 3.5a.5.5 0 0 1-.7.05Z",
    fill: primaryFill
  }));
};

export const CodeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeRegularIcon, 'CodeRegular');

const CodeBlockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm2.85 4.85L6.71 10l2.14 2.15a.5.5 0 0 1-.7.7l-2.5-2.5a.5.5 0 0 1 0-.7l2.5-2.5a.5.5 0 1 1 .7.7Zm3-.7 2.5 2.5c.2.2.2.5 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7L13.29 10l-2.14-2.15a.5.5 0 0 1 .7-.7Z",
    fill: primaryFill
  }));
};

export const CodeBlockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeBlockFilledIcon, 'CodeBlockFilled');

const CodeBlockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM4 6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Zm4.85 1.85a.5.5 0 1 0-.7-.7l-2.5 2.5a.5.5 0 0 0 0 .7l2.5 2.5a.5.5 0 0 0 .7-.7L6.71 10l2.14-2.15Zm3-.7a.5.5 0 0 0-.7.7L13.29 10l-2.14 2.15a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5Z",
    fill: primaryFill
  }));
};

export const CodeBlockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeBlockRegularIcon, 'CodeBlockRegular');

const CodeCircleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm9.96-3.8a.5.5 0 1 0-.92-.4l-3.5 8a.5.5 0 1 0 .92.4l3.5-8Zm-5.1 1.45a.5.5 0 0 0-.71 0l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L5.21 10l1.64-1.65a.5.5 0 0 0 0-.7Zm6.29.7L14.79 10l-1.64 1.65a.5.5 0 0 0 .7.7l2-2a.5.5 0 0 0 0-.7l-2-2a.5.5 0 0 0-.7.7Z",
    fill: primaryFill
  }));
};

export const CodeCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeCircleFilledIcon, 'CodeCircleFilled');

const CodeCircleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.96 6.2a.5.5 0 1 0-.92-.4l-3.5 8a.5.5 0 1 0 .92.4l3.5-8Zm-5.1 1.45c.19.2.19.5 0 .7L5.2 10l1.64 1.65a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2c.2-.2.5-.2.7 0Zm6.29.7a.5.5 0 0 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L14.79 10l-1.64-1.65ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z",
    fill: primaryFill
  }));
};

export const CodeCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeCircleRegularIcon, 'CodeCircleRegular');

const CodeTextFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Zm3 3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM4 11.25c0-.41.34-.75.75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75ZM2.75 13.5a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8Zm9.75-5.25c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM10.75 4.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z",
    fill: primaryFill
  }));
};

export const CodeTextFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextFilledIcon, 'CodeTextFilled');

const CodeTextRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 5a.5.5 0 0 0 0 1H8a.5.5 0 0 0 0-1H2.5Zm3 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM4 11.5c0-.28.22-.5.5-.5h10a.5.5 0 0 1 0 1h-10a.5.5 0 0 1-.5-.5ZM2.5 14a.5.5 0 0 0 0 1H11a.5.5 0 0 0 0-1H2.5Zm10-5.5c0-.28.22-.5.5-.5h3.5a.5.5 0 0 1 0 1H13a.5.5 0 0 1-.5-.5Zm-2-3.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
    fill: primaryFill
  }));
};

export const CodeTextRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextRegularIcon, 'CodeTextRegular');

const CodeTextEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Zm3 3a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5ZM4 11.25c0-.41.34-.75.75-.75h9.5c.06 0 .12 0 .17.02L12.94 12H4.75a.75.75 0 0 1-.75-.75Zm6.27 3.42.98-.98a.75.75 0 0 0-.5-.19h-8a.75.75 0 0 0 0 1.5h7.24c.08-.12.18-.23.28-.33Zm2.23-6.42c0-.41.34-.75.75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM10.75 4.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Zm.23 10.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const CodeTextEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextEditFilledIcon, 'CodeTextEditFilled');

const CodeTextEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 5a.5.5 0 0 0 0 1H8a.5.5 0 0 0 0-1H2.5Zm3 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM4 11.5c0-.28.22-.5.5-.5h9.44l-1 1H4.5a.5.5 0 0 1-.5-.5Zm6.27 3.17.67-.67H2.5a.5.5 0 0 0 0 1h7.49c.08-.12.18-.23.28-.33ZM12.5 8.5c0-.28.22-.5.5-.5h3.5a.5.5 0 0 1 0 1H13a.5.5 0 0 1-.5-.5Zm-2-3.5a.5.5 0 0 0 0 1H17a.5.5 0 0 0 0-1h-6.5Zm.48 10.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const CodeTextEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CodeTextEditRegularIcon, 'CodeTextEditRegular');

const CollectionsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0 1 18 9.33v6.17a2.5 2.5 0 0 1-2.33 2.5H9.5A2.5 2.5 0 0 1 7 15.66V9.5A2.5 2.5 0 0 1 9.34 7h6.16Zm-3 2a.5.5 0 0 0-.5.4V12H9.41a.5.5 0 0 0 0 1H12v2.59a.5.5 0 0 0 1 0v-2.6h2.6a.5.5 0 0 0 0-.98l-.1-.01H13V9.4a.5.5 0 0 0-.5-.4Zm.16-5.3.05.15L13.3 6H9a3 3 0 0 0-3 2.82V14.35a2.5 2.5 0 0 1-2.3-1.69l-.06-.17-1.55-5.8a2.5 2.5 0 0 1 1.6-3l.16-.05 5.8-1.56a2.5 2.5 0 0 1 2.96 1.46l.05.15Z",
    fill: primaryFill
  }));
};

export const CollectionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsFilledIcon, 'CollectionsFilled');

const CollectionsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0 1 18 9.33v6.17a2.5 2.5 0 0 1-2.33 2.5H9.5A2.5 2.5 0 0 1 7 15.66V9.5A2.5 2.5 0 0 1 9.34 7h6.16Zm0 1h-6c-.78 0-1.42.6-1.5 1.35v6.15c0 .78.6 1.42 1.36 1.5h6.14c.78 0 1.42-.6 1.5-1.36V9.5c0-.78-.6-1.42-1.35-1.5h-.15Zm-3 1a.5.5 0 0 1 .5.4V12h2.5a.5.5 0 0 1 .1 1H13v2.5a.5.5 0 0 1-1 .09v-2.6H9.5a.5.5 0 0 1-.09-.98l.1-.01H12V9.5c0-.28.22-.5.5-.5Zm.16-5.3.05.15L13.3 6h-1.04l-.5-1.89a1.5 1.5 0 0 0-1.7-1.1l-.14.04L4.1 4.6a1.5 1.5 0 0 0-1.09 1.7l.03.14 1.55 5.8a1.5 1.5 0 0 0 1.4 1.1v1a2.5 2.5 0 0 1-2.3-1.68l-.06-.17-1.55-5.8a2.5 2.5 0 0 1 1.6-3l.16-.05 5.8-1.56a2.5 2.5 0 0 1 2.96 1.46l.05.15Z",
    fill: primaryFill
  }));
};

export const CollectionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsRegularIcon, 'CollectionsRegular');

const CollectionsAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0 1 18 9.33v.93A5.5 5.5 0 0 0 10.26 18H9.5A2.5 2.5 0 0 1 7 15.66V9.5A2.5 2.5 0 0 1 9.34 7h6.16Zm-2.84-3.3.05.15L13.3 6H9a3 3 0 0 0-3 2.82V14.35a2.5 2.5 0 0 1-2.3-1.69l-.06-.17-1.55-5.8a2.5 2.5 0 0 1 1.6-3l.16-.05 5.8-1.56a2.5 2.5 0 0 1 2.96 1.46l.05.15ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 1 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 1 0 1 0V15h1.5a.5.5 0 1 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const CollectionsAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsAddFilledIcon, 'CollectionsAddFilled');

const CollectionsAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 7A2.5 2.5 0 0 1 18 9.33v.93a5.5 5.5 0 0 0-1-.66v-.1c0-.78-.6-1.42-1.35-1.5H9.5c-.78 0-1.42.6-1.5 1.35v6.15c0 .78.6 1.42 1.36 1.5H9.6c.18.36.4.7.66 1H9.5A2.5 2.5 0 0 1 7 15.66V9.5A2.5 2.5 0 0 1 9.34 7h6.16Zm-2.84-3.3.05.15L13.3 6h-1.04l-.5-1.89a1.5 1.5 0 0 0-1.7-1.1l-.14.04L4.1 4.6a1.5 1.5 0 0 0-1.09 1.7l.03.14 1.55 5.8a1.5 1.5 0 0 0 1.4 1.1v1a2.5 2.5 0 0 1-2.3-1.68l-.06-.17-1.55-5.8a2.5 2.5 0 0 1 1.6-3l.16-.05 5.8-1.56a2.5 2.5 0 0 1 2.96 1.46l.05.15ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 1 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 1 0 1 0V15h1.5a.5.5 0 1 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const CollectionsAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CollectionsAddRegularIcon, 'CollectionsAddRegular');

const ColorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.77 3.17a7.82 7.82 0 0 1 7.93-.18c3.97 2.04 5.5 6.16 4.18 10.44a7.46 7.46 0 0 1-2.37 3.59 4.32 4.32 0 0 1-4.2.8 3.84 3.84 0 0 1-2.2-1.68c-.41-.7-.53-1.47-.58-2.14l-.04-.58-.02-.37c-.02-.3-.05-.55-.1-.76a1.16 1.16 0 0 0-.2-.47.75.75 0 0 0-.4-.24 1.86 1.86 0 0 0-1.15-.04c-.25.08-.45.2-.69.35l-.2.12c-.31.18-.72.4-1.23.37a2.91 2.91 0 0 1-1.66-.77 2.63 2.63 0 0 1-.94-2.12c0-.79.25-1.63.62-2.43a9.6 9.6 0 0 1 3.25-3.9Zm3.98 3.58a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM15.5 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-1 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z",
    fill: primaryFill
  }));
};

export const ColorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFilledIcon, 'ColorFilled');

const ColorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm3 1a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm2.5 1.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm-.75 3.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM13.25 14a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm.45-11a7.82 7.82 0 0 0-7.93.17 9.6 9.6 0 0 0-3.25 3.89 5.9 5.9 0 0 0-.62 2.43c0 .8.27 1.57.94 2.12.61.5 1.14.74 1.66.77.51.02.92-.19 1.23-.37l.2-.12c.24-.15.44-.27.69-.35.28-.09.64-.12 1.16.04.19.06.3.14.38.24.09.1.16.26.2.47.06.21.09.46.1.76.02.1.02.24.03.37l.04.58c.05.67.17 1.44.57 2.14.42.7 1.1 1.3 2.2 1.68 1.6.54 3.07.1 4.21-.8a7.46 7.46 0 0 0 2.37-3.6C19.2 9.16 17.68 5.04 13.7 3ZM6.3 4.01a6.82 6.82 0 0 1 6.94-.14c3.5 1.8 4.87 5.4 3.69 9.25a6.46 6.46 0 0 1-2.04 3.1 3.33 3.33 0 0 1-3.26.64c-.9-.3-1.38-.76-1.66-1.24a4 4 0 0 1-.44-1.7l-.04-.54-.02-.41c-.03-.31-.06-.63-.13-.93-.07-.3-.2-.6-.4-.86-.22-.26-.5-.46-.87-.57a2.85 2.85 0 0 0-1.75-.03c-.38.12-.7.32-.95.47l-.14.09c-.29.16-.48.24-.68.23-.22-.01-.55-.12-1.08-.55-.38-.31-.57-.76-.57-1.34 0-.6.19-1.29.52-2.01A8.63 8.63 0 0 1 6.3 4.02Z",
    fill: primaryFill
  }));
};

export const ColorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorRegularIcon, 'ColorRegular');

const ColorBackgroundFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m2 10.66 1.08 1.08a3 3 0 0 0 4.24 0l.68-.68c.03 1.34.96 2.94 2.75 2.94 1.82 0 2.75-1.65 2.75-3 0-1.01-.53-1.96-.86-2.47-.2-.3-.38-.55-.52-.72l-.01-.02-.22-.26-.02-.03a1.5 1.5 0 0 0-.85-.48 3 3 0 0 0-.87-2.35L9.48 4h6.02A2.5 2.5 0 0 1 18 6.5v7a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 13.5v-2.84ZM5 1.5a.5.5 0 0 1 1 0v1.17a2 2 0 0 1 1.32.59l2.12 2.12a2 2 0 0 1 0 2.83l-2.83 2.83a2 2 0 0 1-2.82 0L1.66 8.9a2 2 0 0 1 0-2.82L4.5 3.26A2 2 0 0 1 5 2.89V1.5Zm0 4V4.16L2.66 6.5h6.32a1 1 0 0 0-.25-.41L6.61 3.96A1 1 0 0 0 6 3.68V5.5a.5.5 0 0 1-1 0Zm-2.92 2c0 .26.1.51.3.7l2.11 2.13a1 1 0 0 0 1.42 0L8.73 7.5H2.08Zm8.3.67-.22.26c-.12.15-.29.38-.46.64C9.4 9.57 9 10.3 9 11c0 1 .67 2 1.75 2s1.75-1 1.75-2c0-.7-.39-1.44-.7-1.93a8.13 8.13 0 0 0-.46-.64l-.22-.26a.5.5 0 0 0-.74 0Zm.17 1.44c.06-.11.13-.21.2-.3l.2.3c.31.47.55 1 .55 1.39 0 .3-.1.57-.25.75a.62.62 0 0 1-.5.25.62.62 0 0 1-.5-.25A1.21 1.21 0 0 1 10 11c0-.4.24-.92.55-1.4Z",
    fill: primaryFill
  }));
};

export const ColorBackgroundFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorBackgroundFilledIcon, 'ColorBackgroundFilled');

const ColorBackgroundRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10.66v2.84A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4H9.48l.67.67c.1.1.2.22.28.33h5.07c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-1.84l-1-1ZM5 1.5a.5.5 0 0 1 1 0v1.17a2 2 0 0 1 1.32.59l2.12 2.12a2 2 0 0 1 0 2.83l-2.83 2.83a2 2 0 0 1-2.82 0L1.66 8.9a2 2 0 0 1 0-2.82L4.5 3.26A2 2 0 0 1 5 2.89V1.5Zm0 4V4.16L2.66 6.5h6.32a1 1 0 0 0-.25-.41L6.61 3.96A1 1 0 0 0 6 3.68V5.5a.5.5 0 0 1-1 0Zm-2.92 2c0 .26.1.51.3.7l2.11 2.13a1 1 0 0 0 1.42 0L8.73 7.5H2.08Zm8.08.93.22-.26a.5.5 0 0 1 .74 0l.22.26c.12.15.29.38.46.64.31.5.7 1.23.7 1.93 0 1-.67 2-1.75 2S9 12 9 11c0-.7.39-1.44.7-1.93.17-.26.34-.49.46-.64Zm.59.88c-.07.09-.14.19-.2.3-.31.47-.55 1-.55 1.39 0 .3.1.57.25.75.13.17.3.25.5.25s.37-.08.5-.25c.15-.18.25-.46.25-.75 0-.4-.24-.92-.55-1.4l-.2-.3Z",
    fill: primaryFill
  }));
};

export const ColorBackgroundRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorBackgroundRegularIcon, 'ColorBackgroundRegular');

const ColorBackgroundAccentRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m2.75 11.41.33.33a3 3 0 0 0 4.24 0l.68-.68c.03 1.34.96 2.94 2.75 2.94 1.82 0 2.75-1.65 2.75-3 0-1.01-.53-1.96-.86-2.47-.2-.3-.38-.55-.52-.72V7.8l-.24-.29h-.01a1.5 1.5 0 0 0-.85-.49 3 3 0 0 0-.8-2.27h5.28c.97 0 1.75.78 1.75 1.75v7c0 .97-.78 1.75-1.75 1.75h-11c-.97 0-1.75-.78-1.75-1.75v-2.09Z",
    fill: primaryFill
  }));
};

export const ColorBackgroundAccentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorBackgroundAccentRegularIcon, 'ColorBackgroundAccentRegular');

const ColorFillFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 12c0 1.35.93 3 2.75 3 1.55 0 2.46-1.2 2.69-2.39A2 2 0 0 1 18 14v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h.34l1.45 1.45a3 3 0 0 0 4.24 0L11.48 12H12Zm2.38-2.83-.22.26c-.12.15-.29.38-.46.64-.31.5-.7 1.23-.7 1.93 0 1 .67 2 1.75 2s1.75-1 1.75-2c0-.7-.39-1.44-.7-1.93a8.13 8.13 0 0 0-.46-.64l-.21-.25-.02-.02a.47.47 0 0 0-.36-.16.5.5 0 0 0-.37.17Zm.37 1.14.2.3c.31.47.55 1 .55 1.39 0 .3-.1.57-.25.75a.62.62 0 0 1-.5.25.62.62 0 0 1-.5-.25A1.21 1.21 0 0 1 14 12c0-.4.24-.92.55-1.4l.2-.3ZM8.5 1a.5.5 0 0 0-.5.5v1.56a2 2 0 0 0-.8.49L3.66 7.09a2 2 0 0 0 0 2.82l2.83 2.83a2 2 0 0 0 2.83 0l3.54-3.53a2 2 0 0 0 0-2.83l-2.83-2.83A2 2 0 0 0 9 3V1.5a.5.5 0 0 0-.5-.5ZM8 4.17V5.5a.5.5 0 0 0 1 0V4.04a1 1 0 0 1 .32.22l2.83 2.83a1 1 0 0 1 .25.41H4.66l3.25-3.24.09-.08ZM4.37 9.21a1 1 0 0 1-.3-.71h8.08l-3.54 3.54a1 1 0 0 1-1.41 0L4.37 9.2Zm10-.04Z",
    fill: primaryFill
  }));
};

export const ColorFillFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFillFilledIcon, 'ColorFillFilled');

const ColorFillRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.34 12H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-2a2 2 0 0 0-.56-1.39c-.08.4-.23.8-.47 1.16A1 1 0 0 1 17 14v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1.34l-1-1Zm10.04-2.83-.22.26c-.12.15-.29.38-.46.64-.31.5-.7 1.23-.7 1.93 0 1 .67 2 1.75 2s1.75-1 1.75-2c0-.7-.39-1.44-.7-1.93a8.13 8.13 0 0 0-.46-.64l-.21-.25-.02-.02a.47.47 0 0 0-.36-.16.5.5 0 0 0-.37.17Zm.37 1.14.2.3c.31.47.55 1 .55 1.39 0 .3-.1.57-.25.75a.62.62 0 0 1-.5.25.62.62 0 0 1-.5-.25A1.21 1.21 0 0 1 14 12c0-.4.24-.92.55-1.4l.2-.3ZM8.5 1a.5.5 0 0 0-.5.5v1.56a2 2 0 0 0-.8.49L3.66 7.09a2 2 0 0 0 0 2.82l2.83 2.83a2 2 0 0 0 2.83 0l3.54-3.53a2 2 0 0 0 0-2.83l-2.83-2.83A2 2 0 0 0 9 3V1.5a.5.5 0 0 0-.5-.5ZM8 4.17V5.5a.5.5 0 0 0 1 0V4.04a1 1 0 0 1 .32.22l2.83 2.83a1 1 0 0 1 .25.41H4.66l3.25-3.24.09-.08ZM4.37 9.21a1 1 0 0 1-.3-.71h8.08l-3.54 3.54a1 1 0 0 1-1.41 0L4.37 9.2Zm10-.04Z",
    fill: primaryFill
  }));
};

export const ColorFillRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFillRegularIcon, 'ColorFillRegular');

const ColorFillAccentRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.84 12.5H4c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5v-2c0-.3-.09-.57-.23-.8a2.67 2.67 0 0 1-2.52 1.8c-1.6 0-2.51-1.27-2.7-2.5h-1.07l-.95.95a3 3 0 0 1-4.24 0l-.95-.95Z",
    fill: primaryFill
  }));
};

export const ColorFillAccentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorFillAccentRegularIcon, 'ColorFillAccentRegular');

const ColorLineFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.24 2.54a2.26 2.26 0 0 0-3.07.13L6.21 8.66l-.11.12a1.5 1.5 0 0 0-.28.56l-.8 3.08-.01.08a.5.5 0 0 0 .62.53l3.08-.76.16-.05c.2-.08.4-.2.55-.35l5.96-6 .12-.12c.72-.85.72-2.1 0-2.95l-.13-.14-.13-.12ZM4.1 12H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5.3l-.57.57a2.5 2.5 0 0 1-.92.59H9.2l-.21.07-3.11.77A1.5 1.5 0 0 1 4 12.4v-.04l.04-.16.05-.21Z",
    fill: primaryFill
  }));
};

export const ColorLineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorLineFilledIcon, 'ColorLineFilled');

const ColorLineRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.1 12H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5.3l-.57.57a2.5 2.5 0 0 1-.57.43H16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h.08A1.48 1.48 0 0 1 4 12.4v-.04l.04-.17.05-.2Zm8.07-9.38a2.26 2.26 0 0 1 3.07-.13l.13.12.13.14c.72.85.72 2.1 0 2.95l-.12.13-5.96 6a1.5 1.5 0 0 1-.55.34l-.16.05-3.08.76a.5.5 0 0 1-.62-.53l.01-.08.8-3.07c.05-.2.15-.4.28-.57l.1-.11 5.97-6Zm2.5.7a1.26 1.26 0 0 0-1.69-.09l-.1.1-5.97 6a.5.5 0 0 0-.1.14l-.03.08-.58 2.26 2.27-.56a.5.5 0 0 0 .12-.04l.05-.03.07-.06 5.96-6c.5-.49.5-1.3 0-1.8Z",
    fill: primaryFill
  }));
};

export const ColorLineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorLineRegularIcon, 'ColorLineRegular');

const ColorLineAccentRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.1 13a1.5 1.5 0 0 0 1.77.95l3.1-.76.22-.07h.02l.26-.12H16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h.1Z",
    fill: primaryFill
  }));
};

export const ColorLineAccentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColorLineAccentRegularIcon, 'ColorLineAccentRegular');

const ColumnFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 17a.5.5 0 0 0 0-1H16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H16a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h.5ZM7 5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5ZM4 17a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 1 1 1v10.1a1 1 0 0 1-1 .9h-.5a.5.5 0 1 0 0 1H4Z",
    fill: primaryFill
  }));
};

export const ColumnFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnFilledIcon, 'ColumnFilled');

const ColumnRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 17a.5.5 0 0 0 0-1H16a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H16a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h.5ZM7 5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V5Zm5 10V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1Zm-8 2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1H4a1 1 0 0 1 1 1v10.1a1 1 0 0 1-1 .9h-.5a.5.5 0 1 0 0 1H4Z",
    fill: primaryFill
  }));
};

export const ColumnRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnRegularIcon, 'ColumnRegular');

const ColumnArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h1a2 2 0 0 1 2 2v3.75H5.75a1.75 1.75 0 1 0 0 3.5H7V15a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm13-2a2 2 0 0 0-2 2v11c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1ZM8.97 6.97c.3-.3.77-.3 1.06 0l2 2c.3.3.3.77 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H5.5a.75.75 0 0 1 0-1.5h4.19l-.72-.72a.75.75 0 0 1 0-1.06Z",
    fill: primaryFill
  }));
};

export const ColumnArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnArrowRightFilledIcon, 'ColumnArrowRightFilled');

const ColumnArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3h1a1 1 0 0 1 1 1v4h1V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2v-4H6v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Zm11-1a2 2 0 0 0-2 2v11c0 1.1.9 2 2 2h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1Zm1 1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h1ZM9.15 7.15c.2-.2.5-.2.7 0l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 0 1-.7-.7L10.29 10H5.5a.5.5 0 0 1 0-1h4.8L9.14 7.85a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const ColumnArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnArrowRightRegularIcon, 'ColumnArrowRightRegular');

const ColumnDoubleCompareFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 3H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm1 4H2v-.96h6V7Zm9-4h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm1 10h-6v-3h6v3Z",
    fill: primaryFill
  }));
};

export const ColumnDoubleCompareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnDoubleCompareFilledIcon, 'ColumnDoubleCompareFilled');

const ColumnDoubleCompareRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 3H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2ZM3 4h4a1 1 0 0 1 1 1v1H2V5a1 1 0 0 1 1-1Zm4 12H3a1 1 0 0 1-1-1V7h6v8a1 1 0 0 1-1 1ZM17 3h-4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2Zm-4 1h4a1 1 0 0 1 1 1v5h-6V5a1 1 0 0 1 1-1Zm4 12h-4a1 1 0 0 1-1-1v-2h6v2a1 1 0 0 1-1 1Z",
    fill: primaryFill
  }));
};

export const ColumnDoubleCompareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnDoubleCompareRegularIcon, 'ColumnDoubleCompareRegular');

const ColumnEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5H4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-.5a.5.5 0 0 1 0-1H4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-.5a.5.5 0 0 1-.5-.5ZM9 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h.22l.21-.84a3.2 3.2 0 0 1 .84-1.49L13 11.94V5a2 2 0 0 0-2-2H9Zm6 2v4.94l-1 1V5c0-1.1.9-2 2-2h.5a.5.5 0 0 1 0 1H16a1 1 0 0 0-1 1Zm-4.02 10.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const ColumnEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnEditFilledIcon, 'ColumnEditFilled');

const ColumnEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5c0-.28.22-.5.5-.5H4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-.5a.5.5 0 0 1 0-1H4a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-.5a.5.5 0 0 1-.5-.5ZM9 4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h.47l-.04.16-.21.84H9a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v6.94l-1 1V5a1 1 0 0 0-1-1H9Zm6 1v4.94l-1 1V5c0-1.1.9-2 2-2h.5a.5.5 0 0 1 0 1H16a1 1 0 0 0-1 1Zm-4.02 10.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const ColumnEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnEditRegularIcon, 'ColumnEditRegular');

const ColumnTripleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm5 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H9Zm5 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Z",
    fill: primaryFill
  }));
};

export const ColumnTripleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleFilledIcon, 'ColumnTripleFilled');

const ColumnTripleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm3 0H4v12h2V4Zm2 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V4Zm3 0H9v12h2V4Zm3-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2Zm0 1h2v12h-2V4Z",
    fill: primaryFill
  }));
};

export const ColumnTripleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleRegularIcon, 'ColumnTripleRegular');

const ColumnTripleEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Zm5 0a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h.22l.21-.84a3.2 3.2 0 0 1 .84-1.49L12 12.94V4a1 1 0 0 0-1-1H9Zm8 1v5c-.69.03-1.37.31-1.9.84l-2.1 2.1V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm-6.02 11.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const ColumnTripleEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleEditFilledIcon, 'ColumnTripleEditFilled');

const ColumnTripleEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm3 0H4v12h2V4Zm2 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v8.94l-1 1V4H9v12h.47l-.04.16-.21.84H9a1 1 0 0 1-1-1V4Zm9 0v5c-.34.02-.68.1-1 .23V4h-2v6.94l-1 1V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Zm-6.02 11.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const ColumnTripleEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ColumnTripleEditRegularIcon, 'ColumnTripleEditRegular');

const CommaFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 7.5a3.5 3.5 0 1 0-1.88 3.1c-.23.87-.56 1.6-.95 2.18-.8 1.16-1.83 1.72-2.92 1.72a.75.75 0 0 0 0 1.5c1.67 0 3.14-.88 4.16-2.38 1-1.49 1.59-3.58 1.59-6.12Z",
    fill: primaryFill
  }));
};

export const CommaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommaFilledIcon, 'CommaFilled');

const CommaRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 7.5a3.5 3.5 0 1 0-1.28 2.7 7.78 7.78 0 0 1-1.24 2.89A4.26 4.26 0 0 1 7.5 15a.5.5 0 0 0 0 1c1.7 0 3.22-.84 4.3-2.32 1.07-1.48 1.7-3.6 1.7-6.18Z",
    fill: primaryFill
  }));
};

export const CommaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommaRegularIcon, 'CommaRegular');

const CommentFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h10.8C16.84 3 18 4.15 18 5.57v6.7a2.58 2.58 0 0 1-2.6 2.57h-4.59L6.8 17.8Z",
    fill: primaryFill
  }));
};

export const CommentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentFilledIcon, 'CommentFilled');

const CommentRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.48 13.84h4.92c.9 0 1.6-.71 1.6-1.56V5.57C17 4.7 16.3 4 15.4 4H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16ZM6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h10.8C16.84 3 18 4.15 18 5.57v6.7a2.58 2.58 0 0 1-2.6 2.57h-4.59L6.8 17.8Z",
    fill: primaryFill
  }));
};

export const CommentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentRegularIcon, 'CommentRegular');

const CommentAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5Zm-.5 7.5c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5a5.5 5.5 0 0 0 4.9 8Z",
    fill: primaryFill
  }));
};

export const CommentAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentAddFilledIcon, 'CommentAddFilled');

const CommentAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V5h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V6h1.5a.5.5 0 0 0 0-1H15V3.5Zm2 8.78V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56Z",
    fill: primaryFill
  }));
};

export const CommentAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentAddRegularIcon, 'CommentAddRegular');

const CommentArrowLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0ZM10.5 6a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L15.29 6H10.5Zm3 7c1.75 0 3.33-.69 4.5-1.81v1.09a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h3.42a6.5 6.5 0 0 0 5.48 10Z",
    fill: primaryFill
  }));
};

export const CommentArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowLeftFilledIcon, 'CommentArrowLeftFilled');

const CommentArrowLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0ZM10.5 6a.5.5 0 0 0 0 1h4.8l-1.65 1.65a.5.5 0 0 0 .7.7l2.5-2.5a.5.5 0 0 0 0-.7l-2.5-2.5a.5.5 0 0 0-.7.7L15.29 6H10.5Zm6.5 6.28v-.3c.36-.23.7-.5 1-.79v1.09a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h3.42c-.2.32-.38.65-.52 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56Z",
    fill: primaryFill
  }));
};

export const CommentArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowLeftRegularIcon, 'CommentArrowLeftRegular');

const CommentArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 6h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2ZM14.5 11c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5a5.5 5.5 0 0 0 4.9 8Z",
    fill: primaryFill
  }));
};

export const CommentArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowRightFilledIcon, 'CommentArrowRightFilled');

const CommentArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 6h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2ZM17 12.28V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56Z",
    fill: primaryFill
  }));
};

export const CommentArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentArrowRightRegularIcon, 'CommentArrowRightRegular');

const CommentCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L13.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7ZM14.5 11c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5a5.5 5.5 0 0 0 4.9 8Z",
    fill: primaryFill
  }));
};

export const CommentCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentCheckmarkFilledIcon, 'CommentCheckmarkFilled');

const CommentCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.85-1.85L13.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7Zm.85 8.63V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56Z",
    fill: primaryFill
  }));
};

export const CommentCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentCheckmarkRegularIcon, 'CommentCheckmarkRegular');

const CommentDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L15.21 5.5l1.14-1.15ZM14.5 11c1.33 0 2.55-.47 3.5-1.26v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5a5.5 5.5 0 0 0 4.9 8Z",
    fill: primaryFill
  }));
};

export const CommentDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentDismissFilledIcon, 'CommentDismissFilled');

const CommentDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L15.21 5.5Zm1.8 6.78V10.4c.36-.18.7-.4 1-.66v2.54a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5c-.16.32-.3.65-.4 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56Z",
    fill: primaryFill
  }));
};

export const CommentDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentDismissRegularIcon, 'CommentDismissRegular');

const CommentEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.4 17.6a1 1 0 0 0 1.4.2L8 16.9l.05-.25.37-1.5a3.2 3.2 0 0 1 .84-1.48l4.83-4.83A2.87 2.87 0 0 1 18 8.7V5.57A2.58 2.58 0 0 0 15.4 3H4.6A2.58 2.58 0 0 0 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6Zm9.4-8.05-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.07 1.07l1.5-.37c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 1 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const CommentEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentEditFilledIcon, 'CommentEditFilled');

const CommentEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 8.13V5.57C17 4.7 16.3 4 15.4 4H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l2.17-1.6-.31 1.25-.05.26-1.21.9a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.6v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h10.8C16.84 3 18 4.15 18 5.57v3.12c-.3-.26-.64-.44-1-.56Zm-2.2 1.42-4.82 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.07 1.07l1.5-.37c.39-.1.74-.3 1.02-.58l4.83-4.83a1.87 1.87 0 1 0-2.64-2.64Z",
    fill: primaryFill
  }));
};

export const CommentEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentEditRegularIcon, 'CommentEditRegular');

const CommentErrorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25ZM18 9.73A5.5 5.5 0 0 1 9.6 3h-5A2.58 2.58 0 0 0 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 0 0 1.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56V9.74Z",
    fill: primaryFill
  }));
};

export const CommentErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentErrorFilledIcon, 'CommentErrorFilled');

const CommentErrorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.25ZM17 10.4v1.88c0 .85-.7 1.56-1.6 1.56h-4.92L6.21 17H6.2v-3.16H4.6c-.9 0-1.6-.71-1.6-1.56V5.57C3 4.7 3.7 4 4.6 4h4.6c.1-.35.24-.68.4-1h-5A2.58 2.58 0 0 0 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 0 0 1.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56V9.74c-.3.26-.64.48-1 .66Z",
    fill: primaryFill
  }));
};

export const CommentErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentErrorRegularIcon, 'CommentErrorRegular');

const CommentLightningFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.61 7c.33 0 .56.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-.4a.5.5 0 0 1-.48-.66l.56-1.68a.5.5 0 0 0-.47-.66h-3.48a.5.5 0 0 0-.46.3l-2.08 5c-.14.34.1.7.46.7h1.11Zm-.64 1h-.47a1.5 1.5 0 0 1-1.38-2.08L11.33 3H4.6A2.58 2.58 0 0 0 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 0 0 1.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56V7l-3.83 3.58c-1.1 1.02-2.84-.01-2.48-1.46L11.97 8Z",
    fill: primaryFill
  }));
};

export const CommentLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentLightningFilledIcon, 'CommentLightningFilled');

const CommentLightningRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.61 7c.33 0 .56.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-.4a.5.5 0 0 1-.48-.66l.56-1.68a.5.5 0 0 0-.47-.66h-3.48a.5.5 0 0 0-.46.3l-2.08 5c-.14.34.1.7.46.7h1.11Zm-1.28-4-.41 1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56V7.94L18 7v5.28a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h6.73Z",
    fill: primaryFill
  }));
};

export const CommentLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentLightningRegularIcon, 'CommentLightningRegular');

const CommentMentionFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 2a3 3 0 1 0 1.28 5.71.5.5 0 0 1 .44.9A4 4 0 1 1 19 5v.51a1.5 1.5 0 0 1-2.65.97A2 2 0 0 1 13 5a2 2 0 0 1 3.04-1.7.5.5 0 0 1 .96.2v2a.5.5 0 1 0 1 0V5a3 3 0 0 0-3-3Zm-1 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm1 5c1.13 0 2.16-.37 3-1v3.28a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3h5.82A4.98 4.98 0 0 0 15 10Z",
    fill: primaryFill
  }));
};

export const CommentMentionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMentionFilledIcon, 'CommentMentionFilled');

const CommentMentionRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 2a3 3 0 1 0 1.28 5.71.5.5 0 0 1 .44.9A4 4 0 1 1 19 5v.51a1.5 1.5 0 0 1-2.65.97A2 2 0 0 1 13 5a2 2 0 0 1 3.04-1.7.5.5 0 0 1 .96.2v2a.5.5 0 1 0 1 0V5a3 3 0 0 0-3-3Zm-1 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm4 7.28V9a5 5 0 0 1-1 .58v2.7c0 .85-.7 1.56-1.6 1.56h-4.92L6.21 17H6.2v-3.16H4.6c-.9 0-1.6-.71-1.6-1.56V5.57C3 4.7 3.7 4 4.6 4h5.5c.07-.35.18-.68.32-1H4.6A2.58 2.58 0 0 0 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 0 0 1.4.2l4.01-2.97h4.59c1.44 0 2.6-1.15 2.6-2.56Z",
    fill: primaryFill
  }));
};

export const CommentMentionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMentionRegularIcon, 'CommentMentionRegular');

const CommentMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 0 0-2.46 2.03C4.2 4 4.34 4 4.5 4h8A3.5 3.5 0 0 1 16 7.5v5.45a2.5 2.5 0 0 0 2-2.45V6a4 4 0 0 0-4-4H6.5Zm-2 3A2.5 2.5 0 0 0 2 7.5v6A2.5 2.5 0 0 0 4.5 16H5v1.03a1 1 0 0 0 1.58.81L9.16 16h3.34a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 5h-8Z",
    fill: primaryFill
  }));
};

export const CommentMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleFilledIcon, 'CommentMultipleFilled');

const CommentMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 0 0-2.46 2.04A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16H5v1.03a1 1 0 0 0 1.58.81L9.16 16h4.34a2.5 2.5 0 0 0 2.5-2.5v-.55a2.5 2.5 0 0 0 2-2.45v-5A3.5 3.5 0 0 0 14.5 2h-8Zm7 13H8.84L6 17.03V15H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h9c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5Zm0-11H5.09c.2-.58.76-1 1.41-1h8A2.5 2.5 0 0 1 17 5.5v5c0 .65-.42 1.2-1 1.41V6.5A2.5 2.5 0 0 0 13.5 4Z",
    fill: primaryFill
  }));
};

export const CommentMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleRegularIcon, 'CommentMultipleRegular');

const CommentMultipleCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 0 0-2.46 2.03C4.2 4 4.34 4 4.5 4h8A3.5 3.5 0 0 1 16 7.5v1.7c.74.22 1.42.58 2 1.06V6a4 4 0 0 0-4-4H6.5ZM15 7.5v1.52A5.5 5.5 0 0 0 9.2 16h-.04l-2.58 1.84A1 1 0 0 1 5 17.03V16h-.5A2.5 2.5 0 0 1 2 13.5v-6A2.5 2.5 0 0 1 4.5 5h8A2.5 2.5 0 0 1 15 7.5Zm4 7a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-2.15-1.85c.2.2.2.5 0 .7l-3 3a.5.5 0 0 1-.7 0l-1-1a.5.5 0 0 1 .7-.7l.65.64 2.65-2.64c.2-.2.5-.2.7 0Z",
    fill: primaryFill
  }));
};

export const CommentMultipleCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleCheckmarkFilledIcon, 'CommentMultipleCheckmarkFilled');

const CommentMultipleCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 0 0-2.46 2.04A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16H5v1.03a1 1 0 0 0 1.58.81L9.16 16h.05c-.1-.32-.16-.66-.19-1h-.18L6 17.03V15H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h9c.83 0 1.5.67 1.5 1.5v2.52c.34.03.68.1 1 .19V6.5A2.5 2.5 0 0 0 13.5 4H5.09c.2-.58.76-1 1.41-1h8A2.5 2.5 0 0 1 17 5.5v4.1c.36.18.7.4 1 .66V5.5A3.5 3.5 0 0 0 14.5 2h-8ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0l-2.65 2.64-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const CommentMultipleCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleCheckmarkRegularIcon, 'CommentMultipleCheckmarkRegular');

const CommentMultipleLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 0 0-2.46 2.03C4.2 4 4.34 4 4.5 4h8A3.5 3.5 0 0 1 16 7.5V11h.5c.49 0 .95.1 1.38.28.08-.24.12-.5.12-.78V6a4 4 0 0 0-4-4H6.5ZM15 7.5V11h-2.5a3.5 3.5 0 0 0-3.16 5h-.18l-2.58 1.84A1 1 0 0 1 5 17.03V16h-.5A2.5 2.5 0 0 1 2 13.5v-6A2.5 2.5 0 0 1 4.5 5h8A2.5 2.5 0 0 1 15 7.5ZM12.5 12a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const CommentMultipleLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleLinkFilledIcon, 'CommentMultipleLinkFilled');

const CommentMultipleLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2a2.5 2.5 0 0 0-2.46 2.04A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16H5v1.03a1 1 0 0 0 1.58.81L9.16 16h.18a3.48 3.48 0 0 1-.3-1h-.2L6 17.03V15H4.5A1.5 1.5 0 0 1 3 13.5v-7C3 5.67 3.67 5 4.5 5h9c.83 0 1.5.67 1.5 1.5V11h1V6.5A2.5 2.5 0 0 0 13.5 4H5.09c.2-.58.76-1 1.41-1h8A2.5 2.5 0 0 1 17 5.5v5c0 .18-.03.36-.1.52.35.04.67.13.98.26.08-.24.12-.5.12-.78v-5A3.5 3.5 0 0 0 14.5 2h-8Zm6 10a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const CommentMultipleLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentMultipleLinkRegularIcon, 'CommentMultipleLinkRegular');

const CommentNoteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 1c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-6Zm1 5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1ZM12 3.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM4.6 3H9v4.5a2.5 2.5 0 0 0 2.5 2.5h6c.17 0 .34-.02.5-.05v2.33a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3Z",
    fill: primaryFill
  }));
};

export const CommentNoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentNoteFilledIcon, 'CommentNoteFilled');

const CommentNoteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 1c-.83 0-1.5.67-1.5 1.5v5c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-6Zm1 5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1ZM12 3.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM4.6 3H9v1H4.6C3.7 4 3 4.71 3 5.57v6.7c0 .86.7 1.57 1.6 1.57h1.6V17l4.28-3.16h4.92c.9 0 1.6-.71 1.6-1.56V10h.5c.17 0 .34-.02.5-.05v2.33a2.58 2.58 0 0 1-2.6 2.56h-4.59L6.8 17.8a1 1 0 0 1-1.4-.2.98.98 0 0 1-.2-.59v-2.17h-.6A2.58 2.58 0 0 1 2 12.28V5.57A2.58 2.58 0 0 1 4.6 3Z",
    fill: primaryFill
  }));
};

export const CommentNoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentNoteRegularIcon, 'CommentNoteRegular');

const CommentOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l.76.77C2.35 4.09 2 4.79 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 0 0 1.4.2l4.01-2.97h3.33l3 3.01a.5.5 0 0 0 .71-.7l-2.3-2.31L3.82 3.12l-.97-.97ZM18 12.28c0 .97-.55 1.81-1.35 2.25L5.12 3H15.4C16.84 3 18 4.15 18 5.57v6.7Z",
    fill: primaryFill
  }));
};

export const CommentOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentOffFilledIcon, 'CommentOffFilled');

const CommentOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l.76.77C2.35 4.09 2 4.79 2 5.57v6.7a2.58 2.58 0 0 0 2.6 2.57h.6v2.17c0 .22.07.42.2.6a1 1 0 0 0 1.4.2l4.01-2.97h3.33l3 3.01a.5.5 0 0 0 .71-.7l-2.3-2.31L3.82 3.12l-.97-.97Zm10.29 11.7h-2.66L6.21 17H6.2v-3.16H4.6c-.9 0-1.6-.71-1.6-1.56V5.57c0-.5.24-.95.62-1.24l9.52 9.51ZM17 12.27c0 .69-.46 1.28-1.11 1.49l.76.76A2.56 2.56 0 0 0 18 12.28V5.57A2.58 2.58 0 0 0 15.4 3H5.12l1 1h9.28c.9 0 1.6.71 1.6 1.57v6.7Z",
    fill: primaryFill
  }));
};

export const CommentOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommentOffRegularIcon, 'CommentOffRegular');

const CommunicationFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 11a6.5 6.5 0 1 1 11.1 4.6.75.75 0 1 0 1.06 1.05 8 8 0 1 0-11.33 0A.75.75 0 0 0 5.4 15.6 6.48 6.48 0 0 1 3.5 11Zm3 0a3.5 3.5 0 1 1 5.98 2.47.75.75 0 1 0 1.06 1.06A4.99 4.99 0 0 0 10 6a5 5 0 0 0-3.54 8.53.75.75 0 0 0 1.06-1.06A3.49 3.49 0 0 1 6.5 11ZM10 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
    fill: primaryFill
  }));
};

export const CommunicationFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationFilledIcon, 'CommunicationFilled');

const CommunicationRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4a7 7 0 0 0-4.95 11.95.5.5 0 0 1-.7.7 8 8 0 1 1 11.32 0 .5.5 0 0 1-.72-.7A7 7 0 0 0 10 4Zm0 3a4 4 0 0 0-2.83 6.82.5.5 0 1 1-.71.71A4.99 4.99 0 0 1 10 6a5 5 0 0 1 3.54 8.53.5.5 0 0 1-.71-.7A3.99 3.99 0 0 0 10 7Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-1 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
    fill: primaryFill
  }));
};

export const CommunicationRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationRegularIcon, 'CommunicationRegular');

const CommunicationPersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4.5a6.5 6.5 0 0 0-4.6 11.1.75.75 0 1 1-1.06 1.05 8 8 0 1 1 13.63-6.35 3 3 0 0 0-1.76-1.21A6.5 6.5 0 0 0 10 4.5Zm4.64 4.63a5 5 0 1 0-8.18 5.4.75.75 0 0 0 1.06-1.06 3.5 3.5 0 1 1 5.81-3.54 3 3 0 0 1 1.3-.8ZM8 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm9.5 1a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const CommunicationPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationPersonFilledIcon, 'CommunicationPersonFilled');

const CommunicationPersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 11a7 7 0 0 1 13.79-1.7c.48.22.88.57 1.18 1a8 8 0 1 0-13.63 6.35.5.5 0 0 0 .7-.7A6.98 6.98 0 0 1 3 11Zm11.64-1.87a5 5 0 1 0-8.18 5.4.5.5 0 0 0 .7-.7A3.99 3.99 0 0 1 10 7a4 4 0 0 1 3.74 2.57c.27-.2.57-.35.9-.44ZM8 11a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7.5 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const CommunicationPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CommunicationPersonRegularIcon, 'CommunicationPersonRegular');

const CompassNorthwestFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.51-10.13a3 3 0 0 1 1.65 1.6l1.6 3.74c.14.35-.2.7-.55.55l-3.73-1.6a3 3 0 0 1-1.6-1.65l-1.4-3.48a.42.42 0 0 1 .54-.55l3.49 1.4Z",
    fill: primaryFill
  }));
};

export const CompassNorthwestFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CompassNorthwestFilledIcon, 'CompassNorthwestFilled');

const CompassNorthwestRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM6.1 7.42A1 1 0 0 1 7.42 6.1l3.26 1.48a3.5 3.5 0 0 1 1.74 1.74l1.48 3.26a1 1 0 0 1-1.32 1.32l-3.26-1.48a3.5 3.5 0 0 1-1.74-1.74L6.1 7.42Zm4.17 1.07L7 7.01l1.48 3.26c.25.55.7.99 1.24 1.24L13 12.99l-1.48-3.26c-.25-.55-.7-.99-1.24-1.24Z",
    fill: primaryFill
  }));
};

export const CompassNorthwestRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CompassNorthwestRegularIcon, 'CompassNorthwestRegular');

const ComposeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.78 3.28a.75.75 0 1 0-1.06-1.06l-7.5 7.5L9 11l1.28-.22 7.5-7.5ZM5.75 3A2.75 2.75 0 0 0 3 5.75v8.5A2.75 2.75 0 0 0 5.75 17h8.5A2.75 2.75 0 0 0 17 14.25v-5.5a.75.75 0 0 0-1.5 0v5.5c0 .69-.56 1.25-1.25 1.25h-8.5c-.69 0-1.25-.56-1.25-1.25v-8.5c0-.69.56-1.25 1.25-1.25h5.5a.75.75 0 0 0 0-1.5h-5.5Z",
    fill: primaryFill
  }));
};

export const ComposeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComposeFilledIcon, 'ComposeFilled');

const ComposeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 2.85a.5.5 0 0 0-.7-.7l-8 8L9 11l.85-.15 8-8ZM5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-6a.5.5 0 0 0-1 0v6c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 14.5v-9C4 4.67 4.67 4 5.5 4h6a.5.5 0 0 0 0-1h-6Z",
    fill: primaryFill
  }));
};

export const ComposeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ComposeRegularIcon, 'ComposeRegular');

const ConferenceRoomFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.19 2.11a.5.5 0 0 1 .41-.1l7 1.5c.23.05.4.25.4.5v12a.5.5 0 0 1-.4.48l-7 1.5a.5.5 0 0 1-.6-.49v-15c0-.15.07-.3.19-.39Zm3.31 7.9a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM8 3H3.5a.5.5 0 0 0-.5.5V16.5c0 .27.22.5.5.5H8V3Z",
    fill: primaryFill
  }));
};

export const ConferenceRoomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConferenceRoomFilledIcon, 'ConferenceRoomFilled');

const ConferenceRoomRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.49 10a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM9.6 2.01a.5.5 0 0 0-.6.5V17.5a.5.5 0 0 0 .6.5l7-1.51A.5.5 0 0 0 17 16V4a.5.5 0 0 0-.4-.49l-7-1.5Zm.4 14.87V3.12l6 1.29V15.6l-6 1.28ZM8 17v-1H4V4h4V3H3.5a.5.5 0 0 0-.5.5v13c0 .27.22.5.5.5H8Z",
    fill: primaryFill
  }));
};

export const ConferenceRoomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConferenceRoomRegularIcon, 'ConferenceRoomRegular');

const ConnectedFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4.5c0 .51-.15.98-.41 1.38L8.62 7.9a2.49 2.49 0 0 1 2.76 0l2.03-2.03a2.5 2.5 0 1 1 .7.7L12.1 8.63a2.49 2.49 0 0 1 0 2.76l2.03 2.03a2.5 2.5 0 1 1-.7.7l-2.04-2.02a2.49 2.49 0 0 1-2.76 0L6.6 14.12a2.5 2.5 0 1 1-.7-.7l2.02-2.04a2.49 2.49 0 0 1 0-2.76L5.88 6.6A2.5 2.5 0 1 1 7 4.5Z",
    fill: primaryFill
  }));
};

export const ConnectedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConnectedFilledIcon, 'ConnectedFilled');

const ConnectedRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.88 6.59a2.5 2.5 0 1 1 .7-.7L8.63 7.9a2.49 2.49 0 0 1 2.76 0l2.03-2.03a2.5 2.5 0 1 1 .7.7L12.1 8.63a2.49 2.49 0 0 1 0 2.76l2.03 2.03a2.5 2.5 0 1 1-.7.7l-2.04-2.02a2.49 2.49 0 0 1-2.76 0L6.6 14.12a2.5 2.5 0 1 1-.7-.7l2.02-2.04a2.49 2.49 0 0 1 0-2.76L5.88 6.6ZM6 4.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Zm11 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM4.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM17 15.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM11.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z",
    fill: primaryFill
  }));
};

export const ConnectedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConnectedRegularIcon, 'ConnectedRegular');

const ConnectorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3a.5.5 0 0 0-.5.5v2.8L2.15 8.14A.5.5 0 0 0 2 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 0 0 1 0V14h1v2.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.15-.35L7 6.29V3.5a.5.5 0 0 0-.5-.5h-2Zm11 14a.5.5 0 0 0 .5-.5v-2.8l1.85-1.85a.5.5 0 0 0 .15-.35v-5a.5.5 0 0 0-.5-.5H17V3.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V6h-.5a.5.5 0 0 0-.5.5v5c0 .13.05.26.15.35L13 13.71v2.79c0 .28.22.5.5.5h2ZM13 6V4h3v2h-3Z",
    fill: primaryFill
  }));
};

export const ConnectorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConnectorFilledIcon, 'ConnectorFilled');

const ConnectorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3.5a.5.5 0 0 0-1 0v2.8L2.15 8.14A.5.5 0 0 0 2 8.5v5c0 .28.22.5.5.5H4v2.5a.5.5 0 0 0 1 0V14h1v2.5a.5.5 0 0 0 1 0V14h1.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.15-.35L7 6.29V3.5a.5.5 0 0 0-1 0v3c0 .13.05.26.15.35L8 8.71V13H3V8.7l1.85-1.85A.5.5 0 0 0 5 6.5v-3Zm10 13v-3a.5.5 0 0 1 .15-.35L17 11.29V7h-5v4.3l1.85 1.85c.1.09.15.22.15.35v3a.5.5 0 0 1-1 0v-2.8l-1.85-1.85a.5.5 0 0 1-.15-.35v-5c0-.28.22-.5.5-.5h.5V3.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V6h.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.15.35L16 13.71v2.79a.5.5 0 0 1-1 0ZM13 6h3V4h-3v2Z",
    fill: primaryFill
  }));
};

export const ConnectorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConnectorRegularIcon, 'ConnectorRegular');

const ContactCardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-13Zm3 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm-1.55.75h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94ZM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const ContactCardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardFilledIcon, 'ContactCardFilled');

const ContactCardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8ZM11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM2 5.75C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 16 2 15.22 2 14.25v-8.5ZM3.75 5a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75h12.5c.41 0 .75-.34.75-.75v-8.5a.75.75 0 0 0-.75-.75H3.75Z",
    fill: primaryFill
  }));
};

export const ContactCardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardRegularIcon, 'ContactCardRegular');

const ContactCardGroupFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11ZM12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm.5 2.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1ZM4 10.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 .75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5v-.75ZM6.25 9a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm4.25-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1.07 3.98a2.26 2.26 0 0 0 .07-.41V10.75c0-.27-.06-.52-.17-.75H10a1 1 0 0 1 1 1c0 .83-.67 1.5-1.5 1.5h-.26c.1-.2.16-.37.2-.52Z",
    fill: primaryFill
  }));
};

export const ContactCardGroupFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardGroupFilledIcon, 'ContactCardGroupFilled');

const ContactCardGroupRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm-8-.75c0-.41.34-.75.75-.75h3a.75.75 0 0 1 .75.75v.81c-.02.16-.1.58-.5.92-.33.29-.86.52-1.75.52C4 13 4 11.5 4 11.5v-.75ZM6.25 9a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm4.25-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1.07 3.98c-.03.15-.1.33-.2.52h.27c.83 0 1.5-.67 1.5-1.5a1 1 0 0 0-1-1h-.67c.11.23.17.48.17.75V11.57a1.84 1.84 0 0 1-.07.4ZM4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11ZM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-7Z",
    fill: primaryFill
  }));
};

export const ContactCardGroupRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardGroupRegularIcon, 'ContactCardGroupRegular');

const ContactCardLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5C2 4.67 2.67 4 3.5 4h13c.83 0 1.5.67 1.5 1.5v5.84a3.49 3.49 0 0 0-1.5-.34h-4a3.5 3.5 0 0 0-3.16 5H3.5A1.5 1.5 0 0 1 2 14.5v-9Zm3 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm4 3.2a.95.95 0 0 0-.95-.95h-3.1a.95.95 0 0 0-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8ZM11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm1 4a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-3.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const ContactCardLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardLinkFilledIcon, 'ContactCardLinkFilled');

const ContactCardLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-1.55.75a.95.95 0 0 0-.95.95c0 .85.58 1.58 1.4 1.79l.06.01c.68.18 1.4.18 2.08 0l.06-.01c.82-.2 1.4-.94 1.4-1.8a.95.95 0 0 0-.95-.94h-3.1ZM12 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4.75 4C3.78 4 3 4.78 3 5.75v8.5c0 .97.78 1.75 1.75 1.75h5.59a3.47 3.47 0 0 1-.3-1H4.75a.75.75 0 0 1-.75-.75v-8.5c0-.41.34-.75.75-.75h12.5c.41 0 .75.34.75.75v5.29c.35.05.69.15 1 .3V5.75C19 4.78 18.22 4 17.25 4H4.75Zm8.75 8a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H17a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H17Zm-3.5 2a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const ContactCardLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardLinkRegularIcon, 'ContactCardLinkRegular');

const ContactCardRibbonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5H13v-.35a3.98 3.98 0 0 1-.87-3.65h-.63a.5.5 0 0 1 0-1h1.04A4 4 0 0 1 18 9.54V5.5c0-.83-.67-1.5-1.5-1.5h-13Zm3 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm1.55.75c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8 0-.52.42-.94.95-.94h3.1ZM11 8.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Zm8 4.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 3.46a3.98 3.98 0 0 1-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22v-2.29Z",
    fill: primaryFill
  }));
};

export const ContactCardRibbonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardRibbonFilledIcon, 'ContactCardRibbonFilled');

const ContactCardRibbonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-4 3.2c0-.53.42-.95.95-.95h3.1c.53 0 .95.42.95.95 0 .85-.58 1.58-1.4 1.79l-.06.01a4.3 4.3 0 0 1-2.08 0l-.06-.01c-.82-.2-1.4-.94-1.4-1.8ZM11.5 8a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Zm0 3a.5.5 0 0 0 0 1h.63c.09-.35.23-.7.4-1H11.5Zm-7.75 4h8.79c.13.23.28.45.46.65V16H3.75C2.78 16 2 15.22 2 14.25v-8.5C2 4.78 2.78 4 3.75 4h12.5c.97 0 1.75.78 1.75 1.75v3.79c-.3-.18-.65-.32-1-.41V5.75a.75.75 0 0 0-.75-.75H3.75a.75.75 0 0 0-.75.75v8.5c0 .41.34.75.75.75ZM19 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 3.46a3.98 3.98 0 0 1-4 0v2.29c0 .2.21.31.38.22L16 18l1.62.97c.17.1.38-.03.38-.22v-2.29Z",
    fill: primaryFill
  }));
};

export const ContactCardRibbonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContactCardRibbonRegularIcon, 'ContactCardRibbonRegular');

const ContentSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 5.25A2.75 2.75 0 0 1 5.25 2.5h9.5a2.75 2.75 0 0 1 2.75 2.75v4.64c-.46-.3-.96-.53-1.5-.68V7H4v7.75c0 .69.56 1.25 1.25 1.25h3.96c.15.54.38 1.04.68 1.5H5.25a2.75 2.75 0 0 1-2.75-2.75v-9.5ZM9 14.5v-6a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5ZM6 14V9h2v5H6Zm4-5.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Zm2.07 2.94a2 2 0 0 1-1.43 2.48l-.47.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ContentSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentSettingsFilledIcon, 'ContentSettingsFilled');

const ContentSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3A2.5 2.5 0 0 0 3 5.5v9A2.5 2.5 0 0 0 5.5 17h4.1c-.16-.32-.3-.65-.4-1H5.5A1.5 1.5 0 0 1 4 14.5V7h12v2.2c.35.1.68.24 1 .4V5.5A2.5 2.5 0 0 0 14.5 3h-9ZM4 5.5C4 4.67 4.67 4 5.5 4h9c.83 0 1.5.67 1.5 1.5V6H4v-.5Zm5 3v6a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-6c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5ZM6 9v5h2V9H6Zm4-.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Zm2.07 2.94a2 2 0 0 1-1.43 2.48l-.47.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const ContentSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentSettingsRegularIcon, 'ContentSettingsRegular');

const ContentViewFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 7H6v2h8V7Zm-2 5h2v1h-2v-1ZM6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6ZM5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7Zm7 4h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1Zm-7 .5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 1.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const ContentViewFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewFilledIcon, 'ContentViewFilled');

const ContentViewRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7Zm9 0H6v2h8V7Zm-2 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2Zm0 1h2v1h-2v-1Zm-7-.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z",
    fill: primaryFill
  }));
};

export const ContentViewRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewRegularIcon, 'ContentViewRegular');

const ContentViewGalleryFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 7H6v2h3V7ZM3 6a3 3 0 0 1 3-3h6v14H6a3 3 0 0 1-3-3V6Zm2 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1Zm.5 4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM5 13.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5Zm8 3.5h1a3 3 0 0 0 3-3v-1h-4v4Zm4-5V8h-4v4h4Zm0-5V6a3 3 0 0 0-3-3h-1v4h4Z",
    fill: primaryFill
  }));
};

export const ContentViewGalleryFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewGalleryFilledIcon, 'ContentViewGalleryFilled');

const ContentViewGalleryRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6Zm0 1h3v2H6V7Zm-1 4.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm8 10V4H6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h5Zm3 0a2 2 0 0 0 2-2v-1h-4v3h2Zm2-9V6a2 2 0 0 0-2-2h-2v3h4Zm0 5V8h-4v4h4Z",
    fill: primaryFill
  }));
};

export const ContentViewGalleryRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContentViewGalleryRegularIcon, 'ContentViewGalleryRegular');

const ContractDownLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m12.7 8 4.15-4.15a.5.5 0 0 0-.7-.7L12 7.29V3.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-3.8ZM6 4a2 2 0 0 0-2 2v4h4a2 2 0 0 1 2 2v4h4a2 2 0 0 0 2-2v-2.5a.5.5 0 0 1 1 0V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1H6Z",
    fill: primaryFill
  }));
};

export const ContractDownLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContractDownLeftFilledIcon, 'ContractDownLeftFilled');

const ContractDownLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m12.7 8 4.15-4.15a.5.5 0 0 0-.7-.7L12 7.29V3.5a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-3.8ZM4 6c0-1.1.9-2 2-2h2.5a.5.5 0 0 0 0-1H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-2.5a.5.5 0 0 0-1 0V14a2 2 0 0 1-2 2h-4v-4a2 2 0 0 0-2-2H4V6Zm0 5h4a1 1 0 0 1 1 1v4H6a2 2 0 0 1-2-2v-3Z",
    fill: primaryFill
  }));
};

export const ContractDownLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ContractDownLeftRegularIcon, 'ContractDownLeftRegular');

const ControlButtonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75v6.5A2.75 2.75 0 0 1 15.25 16H4.75A2.75 2.75 0 0 1 2 13.25v-6.5ZM6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H6Zm3 .5a.5.5 0 0 0-1 0V9h-.5a.5.5 0 0 0 0 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 0 0 0-1h-.25a.25.25 0 0 1-.25-.25V10h.5a.5.5 0 0 0 0-1H9V7.5Zm7 0a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5Zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 0 0 1 0v-2Z",
    fill: primaryFill
  }));
};

export const ControlButtonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ControlButtonFilledIcon, 'ControlButtonFilled');

const ControlButtonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 7a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H6Zm3 .5a.5.5 0 0 0-1 0V9h-.5a.5.5 0 0 0 0 1H8v1.75c0 .69.56 1.25 1.25 1.25h.25a.5.5 0 0 0 0-1h-.25a.25.25 0 0 1-.25-.25V10h.5a.5.5 0 0 0 0-1H9V7.5Zm7 0a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0v-5Zm-4 3c0-.28.22-.5.5-.5h1a.5.5 0 0 0 0-1h-1c-.83 0-1.5.67-1.5 1.5v2a.5.5 0 0 0 1 0v-2ZM4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h10.5A2.75 2.75 0 0 0 18 13.25v-6.5A2.75 2.75 0 0 0 15.25 4H4.75ZM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75v6.5c0 .97-.78 1.75-1.75 1.75H4.75C3.78 15 3 14.22 3 13.25v-6.5Z",
    fill: primaryFill
  }));
};

export const ControlButtonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ControlButtonRegularIcon, 'ControlButtonRegular');

const ConvertRangeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5Zm12.5 5c.28 0 .5.22.5.5v2a2.5 2.5 0 0 1-2.5 2.5h-1.8l1.15 1.15a.5.5 0 0 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L13.71 11h1.79c.83 0 1.5-.67 1.5-1.5v-2c0-.28.22-.5.5-.5Zm-5.62 3H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1.56-.35l-2-2a1.5 1.5 0 0 1 0-2.12l.44-.44ZM6.5 14c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const ConvertRangeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConvertRangeFilledIcon, 'ConvertRangeFilled');

const ConvertRangeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H5ZM4 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4Zm3 9.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H7Zm4.88-3.5H5a2 2 0 0 0-2 2v4c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2v-1.09a1.5 1.5 0 0 1-1 0V16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h6.09c.07-.2.19-.4.35-.56l.44-.44ZM18 7.5a.5.5 0 0 0-1 0v2c0 .83-.67 1.5-1.5 1.5h-1.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2a.5.5 0 0 0 0 .7l2 2a.5.5 0 0 0 .7-.7L13.71 12h1.79A2.5 2.5 0 0 0 18 9.5v-2Z",
    fill: primaryFill
  }));
};

export const ConvertRangeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/ConvertRangeRegularIcon, 'ConvertRangeRegular');

const CookiesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 0 1 9.87-7.78.5.5 0 0 1 .24.85 2 2 0 0 0 .95 3.38c.26.06.44.29.44.55A2 2 0 0 0 17 8.32a.5.5 0 0 1 .87.24A8 8 0 1 1 2 10Zm5-2a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const CookiesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CookiesFilledIcon, 'CookiesFilled');

const CookiesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-6 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3-12a8 8 0 1 0 7.87 6.56.5.5 0 0 0-.87-.24A2 2 0 0 1 13.5 7c0-.26-.18-.5-.44-.55a2 2 0 0 1-.95-3.38.5.5 0 0 0-.24-.85A8.02 8.02 0 0 0 10 2Zm-7 8a7 7 0 0 1 7.87-6.95 2.99 2.99 0 0 0 1.65 4.29 3 3 0 0 0 4.47 2.26l.01.4a7 7 0 1 1-14 0Z",
    fill: primaryFill
  }));
};

export const CookiesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CookiesRegularIcon, 'CookiesRegular');

const CopyFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4ZM4 6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17h6.23A2 2 0 0 1 12 18H7.5A3.5 3.5 0 0 1 4 14.5V6Z",
    fill: primaryFill
  }));
};

export const CopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyFilledIcon, 'CopyFilled');

const CopyRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h6a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8ZM7 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4ZM4 6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17h6.23A2 2 0 0 1 12 18H7.5A3.5 3.5 0 0 1 4 14.5V6Z",
    fill: primaryFill
  }));
};

export const CopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyRegularIcon, 'CopyRegular');

const CopyAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5.2A5.5 5.5 0 0 0 9.2 16H8a2 2 0 0 1-2-2V4Zm4.26 14a5.5 5.5 0 0 1-.66-1H7.5A2.5 2.5 0 0 1 5 14.5V4.27A2 2 0 0 0 4 6v8.5A3.5 3.5 0 0 0 7.5 18h2.76ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const CopyAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyAddFilledIcon, 'CopyAddFilled');

const CopyAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.02c.34.03.68.1 1 .19V4a2 2 0 0 0-2-2H8Zm-.5 15h2.1c.18.36.4.7.66 1H7.5A3.5 3.5 0 0 1 4 14.5V6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const CopyAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyAddRegularIcon, 'CopyAddRegular');

const CopyArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v5.2A5.5 5.5 0 0 0 9.2 16H8a2 2 0 0 1-2-2V4Zm4.26 14a5.5 5.5 0 0 1-.66-1H7.5A2.5 2.5 0 0 1 5 14.5V4.27A2 2 0 0 0 4 6v8.5A3.5 3.5 0 0 0 7.5 18h2.76Zm4.24-8a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const CopyArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyArrowRightFilledIcon, 'CopyArrowRightFilled');

const CopyArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h1.2c-.08-.32-.15-.66-.18-1H8a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5.02c.34.03.68.1 1 .19V4a2 2 0 0 0-2-2H8Zm-.5 15h2.1c.18.36.4.7.66 1H7.5A3.5 3.5 0 0 1 4 14.5V6a2 2 0 0 1 1-1.73V14.5A2.5 2.5 0 0 0 7.5 17Zm7-7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const CopyArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopyArrowRightRegularIcon, 'CopyArrowRightRegular');

const CopySelectFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 3a1 1 0 0 0-1 1v.5a.5.5 0 0 1-1 0V4c0-1.1.9-2 2-2h.5a.5.5 0 0 1 0 1H8Zm-1 9a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1H8a2 2 0 0 1-2-2v-.5a.5.5 0 0 1 1 0v.5Zm0-5.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3ZM16 3a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1h.5Zm0 10a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 1-2 2h-.5a.5.5 0 0 1 0-1h.5Zm1.5-7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5Zm-7-4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM10 13.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4 6h1v6.5A2.5 2.5 0 0 0 7.5 15H14v1a2 2 0 0 1-2 2H5.5A3.5 3.5 0 0 1 2 14.5V8c0-1.1.9-2 2-2Z",
    fill: primaryFill
  }));
};

export const CopySelectFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopySelectFilledIcon, 'CopySelectFilled');

const CopySelectRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 3a1 1 0 0 0-1 1v.5a.5.5 0 0 1-1 0V4c0-1.1.9-2 2-2h.5a.5.5 0 0 1 0 1H8Zm-1 9a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1H8a2 2 0 0 1-2-2v-.5a.5.5 0 0 1 1 0v.5Zm0-5.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3ZM16 3a1 1 0 0 1 1 1v.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2h-.5a.5.5 0 0 0 0 1h.5Zm0 10a1 1 0 0 0 1-1v-.5a.5.5 0 0 1 1 0v.5a2 2 0 0 1-2 2h-.5a.5.5 0 0 1 0-1h.5Zm1.5-7a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5Zm-7-4a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3ZM10 13.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM4 6h1v1H4a1 1 0 0 0-1 1v6.5A2.5 2.5 0 0 0 5.5 17H12a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H5.5A3.5 3.5 0 0 1 2 14.5V8c0-1.1.9-2 2-2Z",
    fill: primaryFill
  }));
};

export const CopySelectRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CopySelectRegularIcon, 'CopySelectRegular');

const CouchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 4H6a2 2 0 0 0-2 2v1a3 3 0 0 1 2.83 2h6.34A3 3 0 0 1 16 7V6a2 2 0 0 0-2-2Zm2 4a2 2 0 0 0-1.94 1.5c-.07.27-.28.5-.56.5h-7c-.28 0-.5-.23-.56-.5A2 2 0 0 0 2 10v2c0 1.1.9 2 2 2v1.5a.5.5 0 0 0 1 0V14h10v1.5a.5.5 0 0 0 1 0V14a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Z",
    fill: primaryFill
  }));
};

export const CouchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CouchFilledIcon, 'CouchFilled');

const CouchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4a2 2 0 0 0-2 2v1.05A2.5 2.5 0 0 0 2 9.5V12c0 1.1.9 2 2 2v1.5a.5.5 0 0 0 1 0V14h10v1.5a.5.5 0 0 0 1 0V14a2 2 0 0 0 2-2V9.5a2.5 2.5 0 0 0-2-2.45V6a2 2 0 0 0-2-2H6Zm9 3.05A2.5 2.5 0 0 0 13.05 9h-6.1A2.5 2.5 0 0 0 5 7.05V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v1.05ZM16 13H4a1 1 0 0 1-1-1V9.5a1.5 1.5 0 1 1 3 0c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5 1.5 1.5 0 0 1 3 0V12a1 1 0 0 1-1 1Z",
    fill: primaryFill
  }));
};

export const CouchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CouchRegularIcon, 'CouchRegular');

const CreditCardClockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75V8H2V6.75ZM9.2 16H4.76A2.75 2.75 0 0 1 2 13.25V9h12.5a5.5 5.5 0 0 0-5.3 7Zm9.8-1.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const CreditCardClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardClockFilledIcon, 'CreditCardClockFilled');

const CreditCardClockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h4.46c-.1-.32-.16-.66-.19-1H4.75C3.78 15 3 14.22 3 13.25V9h15V6.75A2.75 2.75 0 0 0 15.25 4H4.75ZM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V8H3V6.75Zm16 7.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM14.5 12a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5H16a.5.5 0 0 0 0-1h-1v-1.5a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const CreditCardClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardClockRegularIcon, 'CreditCardClockRegular');

const CreditCardPersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75V8H2V6.75ZM2 9h12.5a3 3 0 0 0-2.23 5.01c-1.1.1-2 .92-2.22 1.99h-5.3A2.75 2.75 0 0 1 2 13.25V9Zm14.5 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const CreditCardPersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardPersonFilledIcon, 'CreditCardPersonFilled');

const CreditCardPersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16h5.3c.07-.37.23-.7.45-1H4.75C3.78 15 3 14.22 3 13.25V9h15V6.75A2.75 2.75 0 0 0 15.25 4H4.75ZM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V8H3V6.75ZM16.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S11 17.75 11 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const CreditCardPersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardPersonRegularIcon, 'CreditCardPersonRegular');

const CreditCardToolboxFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75A2.75 2.75 0 0 1 4.75 4h10.5A2.75 2.75 0 0 1 18 6.75V8H2V6.75ZM13.5 9H2v4.25A2.75 2.75 0 0 0 4.75 16H9v-2.5a2.5 2.5 0 0 1 2.04-2.46A2.5 2.5 0 0 1 13.5 9ZM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const CreditCardToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardToolboxFilledIcon, 'CreditCardToolboxFilled');

const CreditCardToolboxRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4A2.75 2.75 0 0 0 2 6.75v6.5A2.75 2.75 0 0 0 4.75 16H9v-1H4.75C3.78 15 3 14.22 3 13.25V9h15V6.75A2.75 2.75 0 0 0 15.25 4H4.75ZM3 6.75C3 5.78 3.78 5 4.75 5h10.5c.97 0 1.75.78 1.75 1.75V8H3V6.75ZM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const CreditCardToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CreditCardToolboxRegularIcon, 'CreditCardToolboxRegular');

const CropFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2.75a.75.75 0 0 0-1.5 0V4.5H2.75a.75.75 0 0 0 0 1.5H4.5v6.75a2.75 2.75 0 0 0 2.75 2.75H14v1.75a.75.75 0 0 0 1.5 0V15.5h1.75a.75.75 0 0 0 0-1.5h-10C6.56 14 6 13.44 6 12.75v-10Zm8 4.5V13h1.5V7.25a2.75 2.75 0 0 0-2.75-2.75H7V6h5.75c.69 0 1.25.56 1.25 1.25Z",
    fill: primaryFill
  }));
};

export const CropFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropFilledIcon, 'CropFilled');

const CropRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2.5a.5.5 0 0 0-1 0V5H2.5a.5.5 0 0 0 0 1H5v6.5A2.5 2.5 0 0 0 7.5 15H14v2.5a.5.5 0 0 0 1 0V15h2.5a.5.5 0 0 0 0-1h-10A1.5 1.5 0 0 1 6 12.5v-10Zm8 5V13h1V7.5A2.5 2.5 0 0 0 12.5 5H7v1h5.5c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const CropRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropRegularIcon, 'CropRegular');

const CropInterimFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 4h3a2 2 0 0 0 1.77 1.99l.47 4.16A2 2 0 0 0 11 12H6a2 2 0 0 0-1.24-1.85L5.23 6A2 2 0 0 0 7 4Zm6.23 6.01-.47-4.16A2 2 0 1 0 10.26 3H6.74a2 2 0 1 0-2.5 2.85L3.78 10A2 2 0 1 0 5.73 13h5.54a2 2 0 1 0 1.96-2.99Zm.74-2.4A4.5 4.5 0 1 1 9.65 15h.85a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-.72A5.48 5.48 0 0 0 18.5 12a5.5 5.5 0 0 0-4.65-5.43l.12 1.03Z",
    fill: primaryFill
  }));
};

export const CropInterimFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimFilledIcon, 'CropInterimFilled');

const CropInterimRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-2-1H7a2 2 0 0 1-1.77 1.99l-.47 4.16A2 2 0 0 1 6 12h5a2 2 0 0 1 1.24-1.85L11.77 6A2 2 0 0 1 10 4Zm1.27 9H5.73a2 2 0 1 1-1.96-2.99l.47-4.16A2 2 0 1 1 6.74 3h3.53a2 2 0 1 1 2.5 2.85l.46 4.16A2 2 0 1 1 11.27 13ZM3 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm2-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm7 9a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm1.97-4.4A4.5 4.5 0 1 1 9.65 15h.85a.5.5 0 0 0 0-1h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-.72A5.48 5.48 0 0 0 18.5 12a5.5 5.5 0 0 0-4.65-5.43l.12 1.03Z",
    fill: primaryFill
  }));
};

export const CropInterimRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimRegularIcon, 'CropInterimRegular');

const CropInterimOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m3.02 3.73-.87-.88a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-1.2-1.2A5.47 5.47 0 0 1 9 15.78v.72a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.85a4.49 4.49 0 0 0 5.56.92l-1.94-1.94L13 14a2 2 0 0 1-1.73-1H5.73a2 2 0 1 1-1.96-2.99l.47-4.16a2 2 0 0 1-1.22-2.12Zm8 8L5.27 5.98h-.04l-.47 4.17A2 2 0 0 1 6 12h5c0-.1 0-.18.02-.27Zm.75-5.74.46 4.12 2.63 2.63A2 2 0 0 0 13.23 10l-.47-4.16A2 2 0 1 0 10.26 3H6.74a2 2 0 0 0-2.47-.86l2.6 2.6A2 2 0 0 0 7 4h3a2 2 0 0 0 1.77 1.99Zm4.92 8.58.72.72a5.5 5.5 0 0 0-3.56-8.72l.12 1.03a4.5 4.5 0 0 1 2.72 6.97Z",
    fill: primaryFill
  }));
};

export const CropInterimOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimOffFilledIcon, 'CropInterimOffFilled');

const CropInterimOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m3.02 3.73-.87-.88a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-1.2-1.2A5.47 5.47 0 0 1 9 15.78v.72a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.85a4.49 4.49 0 0 0 5.56.92l-1.94-1.94L13 14a2 2 0 0 1-1.73-1H5.73a2 2 0 1 1-1.96-2.99l.47-4.16a2 2 0 0 1-1.22-2.12Zm8 8L5.27 5.98a2 2 0 0 1-.04 0l-.47 4.17A2 2 0 0 1 6 12h5c0-.1 0-.18.02-.27Zm.75-5.74.46 4.12 2.63 2.63A2 2 0 0 0 13.23 10l-.47-4.16A2 2 0 1 0 10.26 3H6.74a2 2 0 0 0-2.47-.86l.87.87a1 1 0 0 1 .86.86l.87.87A2 2 0 0 0 7 4h3a2 2 0 0 0 1.77 1.99Zm4.92 8.58.72.72a5.5 5.5 0 0 0-3.56-8.72l.12 1.03a4.5 4.5 0 0 1 2.72 6.97ZM12 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm-9 7a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z",
    fill: primaryFill
  }));
};

export const CropInterimOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CropInterimOffRegularIcon, 'CropInterimOffRegular');

const CrownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.74 5.31 6.6 8.05a.5.5 0 0 1-.62.14L3.86 7.12a1.5 1.5 0 1 0-1.67.85L3.9 16c.12.58.63.99 1.22.99h9.78c.6 0 1.1-.41 1.22-1l1.7-8.03a1.5 1.5 0 1 0-1.67-.85L14 8.2a.5.5 0 0 1-.62-.14L11.26 5.3a1.5 1.5 0 1 0-2.53 0ZM10 14a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: primaryFill
  }));
};

export const CrownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CrownFilledIcon, 'CrownFilled');

const CrownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM8.74 5.31 6.6 8.05a.5.5 0 0 1-.62.14L3.86 7.12a1.5 1.5 0 1 0-1.67.85L3.9 16c.12.58.63.99 1.22.99h9.78c.6 0 1.1-.41 1.22-1l1.7-8.03a1.5 1.5 0 1 0-1.67-.85L14 8.2a.5.5 0 0 1-.62-.14L11.26 5.3a1.5 1.5 0 1 0-2.53 0Zm1.26 0 2.6 3.35a1.5 1.5 0 0 0 1.86.42l2.34-1.17-1.66 7.9a.25.25 0 0 1-.25.19H5.11a.25.25 0 0 1-.25-.2L3.2 7.91l2.34 1.17a1.5 1.5 0 0 0 1.86-.42L10 5.31Z",
    fill: primaryFill
  }));
};

export const CrownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CrownRegularIcon, 'CrownRegular');

const CubeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v7.64a1.5 1.5 0 0 1-.94 1.4l-5.76 2.3a3.5 3.5 0 0 1-2.6 0l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3Zm-3 3.56a.5.5 0 1 0-.4.92l4.2 1.86v4.68a.5.5 0 0 0 1 0V8.82l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9Z",
    fill: primaryFill
  }));
};

export const CubeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeFilledIcon, 'CubeFilled');

const CubeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.7 6.04a.5.5 0 1 0-.4.92l4.2 1.86v4.68a.5.5 0 0 0 1 0V8.82l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9Zm5.6-3.56a3.5 3.5 0 0 0-2.6 0l-5.76 2.3A1.5 1.5 0 0 0 2 6.18v7.64c0 .62.37 1.17.94 1.4l5.76 2.3a3.5 3.5 0 0 0 2.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 0 0-.94-1.4l-5.76-2.3Zm-2.23.93a2.5 2.5 0 0 1 1.86 0l5.76 2.3a.5.5 0 0 1 .31.47v7.64a.5.5 0 0 1-.31.47l-5.76 2.3a2.5 2.5 0 0 1-1.86 0l-5.76-2.3a.5.5 0 0 1-.31-.47V6.18c0-.2.12-.4.31-.47l5.76-2.3Z",
    fill: primaryFill
  }));
};

export const CubeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeRegularIcon, 'CubeRegular');

const CubeAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.48 5.48 0 0 0-7.5.46v-1.9l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9a.5.5 0 1 0-.4.9l4.2 1.87v3.39a5.48 5.48 0 0 0 .58 5.56 3.5 3.5 0 0 1-1.38-.25l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3ZM17 18.24a4.5 4.5 0 1 1-5-7.48 4.5 4.5 0 0 1 5 7.48Zm-2.15-6.1a.5.5 0 0 0-.85.36V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.15-.35Z",
    fill: primaryFill
  }));
};

export const CubeAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeAddFilledIcon, 'CubeAddFilled');

const CubeAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.07 16.59c.13.05.26.1.4.12.16.38.36.73.6 1.06a3.5 3.5 0 0 1-1.37-.25l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.5 5.5 0 0 0-1-.66V6.18a.5.5 0 0 0-.31-.47l-5.76-2.3a2.5 2.5 0 0 0-1.86 0L3.31 5.7a.5.5 0 0 0-.31.47v7.64c0 .2.12.4.31.47l5.76 2.3ZM5.7 6.04a.5.5 0 1 0-.4.92l4.2 1.86v3.39a5.5 5.5 0 0 1 1-1.49v-1.9l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9ZM17 18.24a4.5 4.5 0 1 1-5-7.48 4.5 4.5 0 0 1 5 7.48Zm-2.15-6.1a.5.5 0 0 0-.85.36V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5a.5.5 0 0 0-.15-.35Z",
    fill: primaryFill
  }));
};

export const CubeAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeAddRegularIcon, 'CubeAddRegular');

const CubeArrowCurveDownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 5.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm6.4.9-.9.89V5.74A2.75 2.75 0 0 0 3.75 3H3.5a.5.5 0 1 0 0 1h.25c.97 0 1.75.78 1.75 1.74V7.3l-.9-.9a.5.5 0 0 0-.7.7l1.75 1.76a.5.5 0 0 0 .7 0L8.12 7.1a.5.5 0 1 0-.71-.7Zm3.6-.9c0 .78-.16 1.53-.46 2.2l3.76-1.66a.5.5 0 0 1 .4.91l-4.2 1.87v4.67a.5.5 0 0 1-1 0V9.27a5.49 5.49 0 0 1-7.5.46v4.08c0 .61.37 1.16.94 1.39l5.76 2.3a3.5 3.5 0 0 0 2.6 0l5.76-2.3c.57-.23.94-.78.94-1.4V6.18a1.5 1.5 0 0 0-.94-1.39l-5.76-2.3a3.5 3.5 0 0 0-1.38-.25A5.47 5.47 0 0 1 11 5.5Z",
    fill: primaryFill
  }));
};

export const CubeArrowCurveDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeArrowCurveDownFilledIcon, 'CubeArrowCurveDownFilled');

const CubeArrowCurveDownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 5.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm6.4.89-.9.9V5.74A2.75 2.75 0 0 0 3.75 3H3.5a.5.5 0 1 0 0 1h.25c.97 0 1.75.78 1.75 1.74V7.3l-.9-.9a.5.5 0 0 0-.7.7l1.75 1.76a.5.5 0 0 0 .7 0L8.12 7.1a.5.5 0 1 0-.71-.71ZM2 9.73c.3.26.64.48 1 .66v3.42c0 .2.13.39.32.46l5.75 2.3c.6.24 1.26.24 1.86 0l5.76-2.3a.5.5 0 0 0 .31-.46V6.17a.5.5 0 0 0-.31-.46l-5.76-2.3a2.5 2.5 0 0 0-.4-.12 5.5 5.5 0 0 0-.6-1.06c.46-.01.93.07 1.37.25l5.76 2.3c.57.23.94.78.94 1.4v7.63a1.5 1.5 0 0 1-.94 1.39l-5.76 2.3a3.5 3.5 0 0 1-2.6 0l-5.76-2.3A1.5 1.5 0 0 1 2 13.8V9.74Zm8.54-2.02A5.5 5.5 0 0 1 9.5 9.27v4.22a.5.5 0 0 0 1 0V8.82l4.2-1.87a.5.5 0 1 0-.4-.91L10.54 7.7Z",
    fill: primaryFill
  }));
};

export const CubeArrowCurveDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeArrowCurveDownRegularIcon, 'CubeArrowCurveDownRegular');

const CubeLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v5.85a3.54 3.54 0 0 0-.5-.03h-4a3.5 3.5 0 0 0-2.73 5.68c-.69.16-1.41.1-2.07-.16l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3Zm-3 3.56a.5.5 0 1 0-.4.92l4.2 1.86v4.68a.5.5 0 0 0 1 0V8.82l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9ZM13.5 13a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 1 0 0 1h.5a1.5 1.5 0 0 1 0 3H17a.5.5 0 1 0 0 1h.5a2.5 2.5 0 0 0 0-5H17Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const CubeLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeLinkFilledIcon, 'CubeLinkFilled');

const CubeLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.04 6.3a.5.5 0 0 1 .66-.26L10 7.95l4.3-1.9a.5.5 0 1 1 .4.9l-4.2 1.87v4.68a.5.5 0 0 1-1 0V8.82L5.3 6.96a.5.5 0 0 1-.26-.66ZM8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v5.85a3.54 3.54 0 0 0-.5-.03H17V6.18a.5.5 0 0 0-.31-.47l-5.76-2.3a2.5 2.5 0 0 0-1.86 0L3.31 5.7a.5.5 0 0 0-.31.47v7.64c0 .2.12.4.31.47l5.76 2.3c.37.15.77.2 1.16.17.13.33.31.65.54.92-.69.16-1.41.1-2.07-.16l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3ZM13.5 13a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 1 0 0 1h.5a1.5 1.5 0 0 1 0 3H17a.5.5 0 1 0 0 1h.5a2.5 2.5 0 0 0 0-5H17Zm-3.5 2a.5.5 0 1 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const CubeLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeLinkRegularIcon, 'CubeLinkRegular');

const CubeMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 2.51a5 5 0 0 1 3.6 0l4.24 1.64c.58.22.96.77.96 1.4v.14a2.5 2.5 0 0 0-.6-.34l-4.96-1.9a4 4 0 0 0-2.88 0L3.6 5.35c-.22.09-.42.2-.6.34v-.14c0-.63.38-1.18.96-1.4L8.21 2.5Zm2.88 1.87a3 3 0 0 0-2.16 0l-4.96 1.9A1.5 1.5 0 0 0 3 7.69v6.63c0 .62.38 1.18.96 1.4l4.96 1.91a3 3 0 0 0 2.16 0l4.96-1.9c.58-.23.96-.79.96-1.4V7.68a1.5 1.5 0 0 0-.96-1.4l-4.96-1.91ZM6.04 8.3a.5.5 0 0 1 .66-.26L10 9.46l3.3-1.42a.5.5 0 0 1 .4.92l-3.2 1.37v3.17a.5.5 0 1 1-1 0v-3.17L6.3 8.96a.5.5 0 0 1-.26-.66Z",
    fill: primaryFill
  }));
};

export const CubeMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeMultipleFilledIcon, 'CubeMultipleFilled');

const CubeMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.2 2.51a5 5 0 0 1 3.6 0l4.24 1.64c.58.22.96.77.96 1.4v.14a2.5 2.5 0 0 0-.6-.34l-4.96-1.9a4 4 0 0 0-2.88 0L3.6 5.34c-.22.09-.42.2-.6.34v-.14c0-.63.38-1.18.96-1.4L8.21 2.5Zm-2.16 5.8a.5.5 0 0 1 .66-.27L10 9.46l3.3-1.42a.5.5 0 0 1 .4.92l-3.2 1.37v3.17a.5.5 0 0 1-1 0v-3.17L6.3 8.96a.5.5 0 0 1-.26-.66Zm2.88-3.93a3 3 0 0 1 2.16 0l4.96 1.9c.58.23.96.79.96 1.4v6.63a1.5 1.5 0 0 1-.96 1.4l-4.96 1.91a3 3 0 0 1-2.16 0l-4.96-1.9a1.5 1.5 0 0 1-.96-1.4V7.68c0-.62.38-1.18.96-1.4l4.96-1.91Zm1.8.93a2 2 0 0 0-1.44 0L4.32 7.22a.5.5 0 0 0-.32.47v6.62c0 .21.13.4.32.47l4.96 1.9a2 2 0 0 0 1.44 0l4.96-1.9a.5.5 0 0 0 .32-.47V7.7a.5.5 0 0 0-.32-.47l-4.96-1.9Z",
    fill: primaryFill
  }));
};

export const CubeMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeMultipleRegularIcon, 'CubeMultipleRegular');

const CubeQuickFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.81 4.67a1.5 1.5 0 0 1 1.38 0l3 1.54c.5.26.81.77.81 1.33v3.92a1.5 1.5 0 0 1-.81 1.33l-3 1.54a1.5 1.5 0 0 1-1.38 0l-3-1.54A1.5 1.5 0 0 1 9 11.46V7.54c0-.56.31-1.07.81-1.33l3-1.54Zm-1.76 3.1a.5.5 0 0 0 .23.68L13 9.3v2.2a.5.5 0 0 0 1 0V9.3l1.72-.86a.5.5 0 1 0-.44-.9l-1.78.9-1.78-.9a.5.5 0 0 0-.67.23ZM3.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm-1 3a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Zm1 3a.5.5 0 1 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const CubeQuickFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeQuickFilledIcon, 'CubeQuickFilled');

const CubeQuickRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.27 5.56a.5.5 0 0 1 .46 0l3 1.54a.5.5 0 0 1 .27.44v3.92a.5.5 0 0 1-.27.44l-3 1.54a.5.5 0 0 1-.46 0l-3-1.54a.5.5 0 0 1-.27-.44V7.54c0-.18.1-.36.27-.44l3-1.54Zm.92-.9a1.5 1.5 0 0 0-1.38 0l-3 1.55c-.5.26-.81.77-.81 1.33v3.92c0 .56.31 1.07.81 1.33l3 1.54c.43.22.95.22 1.38 0l3-1.54c.5-.25.81-.77.81-1.33V7.54a1.5 1.5 0 0 0-.81-1.33l-3-1.54ZM3 6.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm-1 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm1 3c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm8.05-4.72a.5.5 0 0 1 .67-.23l1.78.9 1.78-.9a.5.5 0 1 1 .44.9L14 9.3v2.19a.5.5 0 1 1-1 0V9.3l-1.72-.85a.5.5 0 0 1-.23-.67Z",
    fill: primaryFill
  }));
};

export const CubeQuickRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeQuickRegularIcon, 'CubeQuickRegular');

const CubeRotateFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.53 2.63c.93-.43 2-.43 2.94 0l4.66 2.15c.53.24.87.78.87 1.36V8h-1a1.5 1.5 0 0 0-.81 2.76A10.54 10.54 0 0 1 9.99 12c-2.1 0-3.92-.5-5.18-1.24A1.5 1.5 0 0 0 4 8H3V6.14c0-.58.34-1.12.87-1.36l4.66-2.15ZM6.7 6.54a.5.5 0 0 0-.4.92l3.2 1.37v1.67a.5.5 0 1 0 1 0V8.83l3.2-1.37a.5.5 0 1 0-.4-.92L10 7.96 6.7 6.54Zm8.8 2.96c0-.28.22-.5.5-.5h2.5a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-1 0v-.98a6.2 6.2 0 0 1-1.64 1.37A12.4 12.4 0 0 1 10 14a12.4 12.4 0 0 1-6.36-1.61A6.2 6.2 0 0 1 2 11.02V12a.5.5 0 0 1-1 0V9.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H2.48a4.12 4.12 0 0 0 .92 1 6.57 6.57 0 0 0 .76.54c.4.25.87.47 1.37.67 1.27.5 2.8.8 4.47.8s3.2-.3 4.47-.8a8.67 8.67 0 0 0 2.13-1.2 5.24 5.24 0 0 0 .92-1H16a.5.5 0 0 1-.5-.5ZM10 15c-2.66 0-5.16-.67-7-1.83v.7c0 .58.34 1.1.87 1.35l4.66 2.15c.93.43 2 .43 2.94 0l4.66-2.15c.53-.24.87-.77.87-1.36v-.69A13.32 13.32 0 0 1 10 15Z",
    fill: primaryFill
  }));
};

export const CubeRotateFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeRotateFilledIcon, 'CubeRotateFilled');

const CubeRotateRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.95 3.53a2.5 2.5 0 0 1 2.1 0L15.7 5.7a.5.5 0 0 1 .29.45V8h1V6.14a1.5 1.5 0 0 0-.87-1.36l-4.66-2.15a3.5 3.5 0 0 0-2.94 0L3.87 4.78A1.5 1.5 0 0 0 3 6.14V8h1V6.14c0-.2.11-.37.29-.45l4.66-2.16ZM3.4 11a6.46 6.46 0 0 0 .76.54A11.4 11.4 0 0 0 10 13a11.4 11.4 0 0 0 6-1.56 6.46 6.46 0 0 0 1-.8c.2-.21.38-.42.52-.64H16a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .5.5V12a.5.5 0 0 1-1 0v-.98a6.2 6.2 0 0 1-1.64 1.37l-.36.21c-1.6.87-3.7 1.4-6 1.4a12.67 12.67 0 0 1-6.36-1.61A6.2 6.2 0 0 1 2 11.02V12a.5.5 0 0 1-1 0V9.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1H2.48a4.12 4.12 0 0 0 .92 1Zm.6 2.72v.14c0 .2.11.37.29.45l4.66 2.16c.67.3 1.43.3 2.1 0l4.66-2.16a.5.5 0 0 0 .29-.45v-.14a10 10 0 0 0 1-.55v.7a1.5 1.5 0 0 1-.87 1.35l-4.66 2.15c-.93.43-2 .43-2.94 0l-4.66-2.15A1.5 1.5 0 0 1 3 13.86v-.69c.31.2.65.39 1 .55ZM6.04 6.8a.5.5 0 0 1 .66-.26L10 7.96l3.3-1.42a.5.5 0 0 1 .4.92l-3.2 1.37V11a.5.5 0 1 1-1 0V8.83L6.3 7.46a.5.5 0 0 1-.26-.66Z",
    fill: primaryFill
  }));
};

export const CubeRotateRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeRotateRegularIcon, 'CubeRotateRegular');

const CubeSyncFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.7 2.48a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.48 5.48 0 0 0-7.5.46v-1.9l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9a.5.5 0 1 0-.4.9l4.2 1.87v3.39a5.48 5.48 0 0 0 .58 5.56 3.5 3.5 0 0 1-1.38-.25l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3ZM10 14.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 1 1 0-1h.47a2 2 0 0 0-2.38.34.5.5 0 1 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.53a3 3 0 0 1-2.62-.18V17a.5.5 0 1 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 1.72.1 2 2 0 0 0 .66-.44.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z",
    fill: primaryFill
  }));
};

export const CubeSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeSyncFilledIcon, 'CubeSyncFilled');

const CubeSyncRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.7 6.04a.5.5 0 1 0-.4.92l4.2 1.86v3.39a5.5 5.5 0 0 1 1-1.49v-1.9l4.2-1.86a.5.5 0 1 0-.4-.92L10 7.95l-4.3-1.9ZM9.07 16.6c.13.05.26.1.4.12.16.38.36.73.6 1.06a3.5 3.5 0 0 1-1.37-.25l-5.76-2.3a1.5 1.5 0 0 1-.94-1.4V6.18c0-.62.37-1.17.94-1.4l5.76-2.3a3.5 3.5 0 0 1 2.6 0l5.76 2.3c.57.23.94.78.94 1.4v4.08a5.5 5.5 0 0 0-1-.66V6.18a.5.5 0 0 0-.31-.47l-5.76-2.3a2.5 2.5 0 0 0-1.86 0L3.31 5.7a.5.5 0 0 0-.31.47v7.64c0 .2.12.4.31.47l5.76 2.3Zm.93-2.1a4.5 4.5 0 1 0 9 .01 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.23.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 1 1 0-1h.47a2 2 0 0 0-2.38.35.5.5 0 1 1-.71-.71 3 3 0 0 1 3.62-.48V12c0-.28.22-.5.5-.5Zm-.88 5.54a3 3 0 0 1-2.62-.18V17a.5.5 0 1 1-1 0v-1.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.97 1.97 0 0 0 1.72.1 2 2 0 0 0 .66-.44.5.5 0 0 1 .71.71 3 3 0 0 1-1 .66Z",
    fill: primaryFill
  }));
};

export const CubeSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeSyncRegularIcon, 'CubeSyncRegular');

const CubeTreeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.57 2.07c.28-.09.58-.09.86 0l2.85.85a1 1 0 0 1 .72.95v4.26a1 1 0 0 1-.72.96l-2.79.83a.5.5 0 0 1 .01.08v1H12a2 2 0 0 1 2 2v.05a2.5 2.5 0 1 1-1 0V13a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v.05a2.5 2.5 0 1 1-1 0V13c0-1.1.9-2 2-2h1.5v-1a.5.5 0 0 1 0-.08l-2.78-.83A1 1 0 0 1 6 8.13V3.87a1 1 0 0 1 .72-.95l2.85-.85Zm-.91 2.46a.5.5 0 0 0-.32.95l1.16.38V7a.5.5 0 0 0 1 0V5.86l1.16-.38a.5.5 0 1 0-.32-.95L10 4.97l-1.34-.44Z",
    fill: primaryFill
  }));
};

export const CubeTreeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeTreeFilledIcon, 'CubeTreeFilled');

const CubeTreeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.66 4.53a.5.5 0 0 0-.32.95l1.16.38V7a.5.5 0 0 0 1 0V5.86l1.16-.38a.5.5 0 1 0-.32-.95L10 4.97l-1.34-.44Zm1.77-2.46a1.5 1.5 0 0 0-.86 0l-2.86.85a.99.99 0 0 0-.71.95v4.26c0 .44.3.83.72.96l2.79.83a.5.5 0 0 0-.01.08v1H8a2 2 0 0 0-2 2v.05a2.5 2.5 0 1 0 1 0V13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v.05a2.5 2.5 0 1 0 1 0V13a2 2 0 0 0-2-2h-1.5v-1a.5.5 0 0 0 0-.08l2.78-.83a1 1 0 0 0 .72-.96V3.87a1 1 0 0 0-.72-.95l-2.85-.85Zm-.57.95a.5.5 0 0 1 .28 0l2.86.85v4.26l-2.86.85a.5.5 0 0 1-.28 0L7 8.13V3.87l2.86-.85ZM5 15.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm8.5-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
    fill: primaryFill
  }));
};

export const CubeTreeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CubeTreeRegularIcon, 'CubeTreeRegular');

const CurrencyDollarEuroFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2a.75.75 0 0 0-.75.75v.33A3.5 3.5 0 0 0 2 6.5v.28c0 1.47.85 2.8 2.17 3.42l.58.27v4.87a2 2 0 0 1-1.25-1.86V12.4a.75.75 0 0 0-1.5 0v1.08a3.5 3.5 0 0 0 2.75 3.42v.35a.75.75 0 0 0 1.5 0v-.35A3.5 3.5 0 0 0 9 13.48v-.27c0-1.46-.84-2.8-2.17-3.42l-.58-.27V4.64A2 2 0 0 1 7.5 6.5v1.1a.75.75 0 0 0 1.5 0V6.5a3.5 3.5 0 0 0-2.75-3.42v-.33A.75.75 0 0 0 5.5 2Zm-2 4.5a2 2 0 0 1 1.25-1.86v4.18A2.28 2.28 0 0 1 3.5 6.78V6.5Zm2.75 8.84v-4.16a2.27 2.27 0 0 1 1.25 2.03v.27a2 2 0 0 1-1.25 1.86ZM12.5 10c0-.34.02-.66.06-.98h1.7a.75.75 0 0 0 0-1.5h-1.38A6.1 6.1 0 0 1 13.61 6c.67-1 1.52-1.5 2.36-1.5.3 0 .63.1.86.25a.75.75 0 0 0 .84-1.24 3.1 3.1 0 0 0-1.7-.51c-1.49 0-2.75.9-3.6 2.16a7.8 7.8 0 0 0-1.05 2.36h-.57a.75.75 0 0 0 0 1.5h.3a10.02 10.02 0 0 0-.05 1h-.25a.75.75 0 1 0 0 1.5h.37a8.2 8.2 0 0 0 1.25 3.32c.85 1.26 2.11 2.16 3.6 2.16.54 0 1.2-.14 1.72-.52a.75.75 0 1 0-.87-1.22c-.21.15-.53.24-.85.24-.84 0-1.69-.5-2.36-1.5a6.6 6.6 0 0 1-.97-2.48h1.61a.75.75 0 1 0 0-1.5H12.5V10Z",
    fill: primaryFill
  }));
};

export const CurrencyDollarEuroFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarEuroFilledIcon, 'CurrencyDollarEuroFilled');

const CurrencyDollarEuroRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2a.5.5 0 0 0-.5.5v.54c-1.7.24-3 1.7-3 3.46v.13c0 1.43.84 2.73 2.14 3.31l.86.38v5.62a2.5 2.5 0 0 1-2-2.45v-.99a.5.5 0 1 0-1 0v.99a3.5 3.5 0 0 0 3 3.46v.55a.5.5 0 0 0 1 0v-.55c1.7-.24 3-1.7 3-3.46v-.12c0-1.43-.84-2.72-2.14-3.3L6 9.66V4.06A2.5 2.5 0 0 1 8 6.5v1a.5.5 0 0 0 1 0v-1a3.5 3.5 0 0 0-3-3.46V2.5a.5.5 0 0 0-.5-.5ZM3 6.5c0-1.2.86-2.22 2-2.45v5.18l-.45-.2A2.63 2.63 0 0 1 3 6.63V6.5Zm3 9.44v-5.17l.45.2A2.62 2.62 0 0 1 8 13.37v.12a2.5 2.5 0 0 1-2 2.45ZM12 10c0-.34.02-.68.06-1h1.44a.5.5 0 1 0 0-1h-1.26c.21-.89.57-1.67 1.01-2.3.77-1.1 1.78-1.7 2.85-1.7.39 0 .81.11 1.12.31a.5.5 0 1 0 .55-.84A3.15 3.15 0 0 0 16.1 3c-1.48 0-2.76.85-3.66 2.12-.57.8-1 1.79-1.23 2.88h-.71a.5.5 0 1 0 0 1h.55a9.7 9.7 0 0 0-.05 1h-.5a.5.5 0 0 0 0 1h.55c.16 1.5.65 2.84 1.39 3.88A4.55 4.55 0 0 0 16.1 17c.54 0 1.17-.13 1.68-.48a.5.5 0 0 0-.56-.82c-.3.2-.72.3-1.12.3-1.07 0-2.08-.6-2.85-1.7a7.19 7.19 0 0 1-1.2-3.3h1.45a.5.5 0 0 0 0-1H12Z",
    fill: primaryFill
  }));
};

export const CurrencyDollarEuroRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarEuroRegularIcon, 'CurrencyDollarEuroRegular');

const CurrencyDollarRupeeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 2.75a.75.75 0 1 0-1.5 0v.33A3.5 3.5 0 0 0 2 6.5v.28c0 1.47.85 2.8 2.17 3.42l.58.27v4.87a2 2 0 0 1-1.25-1.86V12.4a.75.75 0 0 0-1.5 0v1.08a3.5 3.5 0 0 0 2.75 3.42v.35a.75.75 0 0 0 1.5 0v-.35A3.5 3.5 0 0 0 9 13.48v-.27c0-1.46-.84-2.8-2.17-3.42l-.58-.27V4.64A2 2 0 0 1 7.5 6.5v1.1a.75.75 0 0 0 1.5 0V6.5a3.5 3.5 0 0 0-2.75-3.42v-.33Zm-1.5 1.9v4.17A2.28 2.28 0 0 1 3.5 6.78V6.5a2 2 0 0 1 1.25-1.86Zm1.5 6.53a2.27 2.27 0 0 1 1.25 2.03v.27a2 2 0 0 1-1.25 1.86v-4.16ZM10.75 3a.75.75 0 0 0 0 1.5h2.75c.88 0 1.65.5 2.02 1.25h-4.77a.75.75 0 0 0 0 1.5h4.94A2.25 2.25 0 0 1 13.5 9h-2.75a.75.75 0 0 0-.57 1.24l6.5 7.5a.75.75 0 1 0 1.14-.98l-5.43-6.26h1.11c1.9 0 3.47-1.42 3.72-3.25h.03a.75.75 0 0 0 0-1.5h-.13a3.74 3.74 0 0 0-.62-1.25h.75a.75.75 0 0 0 0-1.5h-6.5Z",
    fill: primaryFill
  }));
};

export const CurrencyDollarRupeeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarRupeeFilledIcon, 'CurrencyDollarRupeeFilled');

const CurrencyDollarRupeeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2c.28 0 .5.22.5.5v.54c1.7.24 3 1.7 3 3.46v1a.5.5 0 0 1-1 0v-1a2.5 2.5 0 0 0-2-2.45v5.63l.86.38A3.62 3.62 0 0 1 9 13.36v.13a3.5 3.5 0 0 1-3 3.46v.55a.5.5 0 0 1-1 0v-.55a3.5 3.5 0 0 1-3-3.46v-.99a.5.5 0 1 1 1 0v.99a2.5 2.5 0 0 0 2 2.45v-5.62l-.86-.38A3.63 3.63 0 0 1 2 6.63V6.5a3.5 3.5 0 0 1 3-3.46V2.5c0-.28.22-.5.5-.5ZM3 6.5v.13c0 1.03.6 1.97 1.55 2.4l.45.2V4.05A2.5 2.5 0 0 0 3 6.5Zm3 9.44a2.5 2.5 0 0 0 2-2.45v-.12c0-1.04-.6-1.97-1.55-2.4l-.45-.2v5.17ZM10 3.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 3c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0-3c0-.28.22-.5.5-.5h3a3.5 3.5 0 1 1 0 7h-1.9l6.28 7.17a.5.5 0 0 1-.76.66l-7-8A.5.5 0 0 1 10.5 9h3a2.5 2.5 0 0 0 0-5h-3a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const CurrencyDollarRupeeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CurrencyDollarRupeeRegularIcon, 'CurrencyDollarRupeeRegular');

const CursorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.64 2.29A1 1 0 0 0 5 3.06v14a1 1 0 0 0 1.76.65l3.52-4.07c.28-.33.7-.52 1.13-.52h5.6a1 1 0 0 0 .63-1.77l-11-9.06Z",
    fill: primaryFill
  }));
};

export const CursorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorFilledIcon, 'CursorFilled');

const CursorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3.06a1 1 0 0 1 1.64-.77l11 9.06a1 1 0 0 1-.63 1.77h-5.6c-.43 0-.85.19-1.13.52L6.76 17.7A1 1 0 0 1 5 17.06v-14Zm12 9.06L6 3.06v14l3.52-4.08a2.5 2.5 0 0 1 1.9-.86H17Z",
    fill: primaryFill
  }));
};

export const CursorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorRegularIcon, 'CursorRegular');

const CursorClickFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5ZM3.61 3.61c.2-.2.51-.2.7 0l1.42 1.42a.5.5 0 1 1-.7.7L3.6 4.32a.5.5 0 0 1 0-.7Zm7.78 0c.2.2.2.51 0 .7L9.97 5.74a.5.5 0 1 1-.7-.7l1.41-1.42c.2-.2.51-.2.7 0ZM2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm5.5.53v9.26c0 .45.54.67.85.36l2.56-2.56a2 2 0 0 1 1.42-.59h3.23a.5.5 0 0 0 .31-.9L8.31 7.65a.5.5 0 0 0-.81.4Z",
    fill: primaryFill
  }));
};

export const CursorClickFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorClickFilledIcon, 'CursorClickFilled');

const CursorClickRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5ZM3.61 3.61c.2-.2.51-.2.7 0l1.42 1.42a.5.5 0 1 1-.7.7L3.6 4.32a.5.5 0 0 1 0-.7Zm7.78 0c.2.2.2.51 0 .7L9.97 5.74a.5.5 0 1 1-.7-.7l1.41-1.42c.2-.2.51-.2.7 0ZM2 7.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm6.64-.2A1 1 0 0 0 7 8.07v9.1a1 1 0 0 0 1.75.66l2.03-2.32c.28-.32.7-.51 1.13-.51h3.2a1 1 0 0 0 .65-1.77L8.64 7.3ZM8 17.17v-9.1L15.12 14H11.9c-.72 0-1.4.31-1.88.85L8 17.17Z",
    fill: primaryFill
  }));
};

export const CursorClickRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorClickRegularIcon, 'CursorClickRegular');

const CursorHoverFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4a2 2 0 0 0-2 2v7c0 1.1.9 2 2 2h5v-4.5a1.5 1.5 0 0 1 2.56-1.06l5 5c.11.11.2.24.28.38A2 2 0 0 0 18 13V6a2 2 0 0 0-2-2H4Zm6.85 6.15a.5.5 0 0 0-.85.35v7a.5.5 0 0 0 .91.29l1.57-2.25 2.94.45a.5.5 0 0 0 .43-.84l-5-5ZM11 15.9v-4.2l3.07 3.06-1.74-.26a.5.5 0 0 0-.49.2l-.84 1.2Z",
    fill: primaryFill
  }));
};

export const CursorHoverFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverFilledIcon, 'CursorHoverFilled');

const CursorHoverRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-1.16 1.82 1.5 1.5 0 0 0-.28-.38l-.45-.45A1 1 0 0 0 17 13V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5v1H4a2 2 0 0 1-2-2V6Zm8.85 4.15a.5.5 0 0 0-.85.35v7a.5.5 0 0 0 .91.29l1.57-2.25 2.94.45a.5.5 0 0 0 .43-.84l-5-5ZM11 15.9v-4.2l3.07 3.06-1.74-.26a.5.5 0 0 0-.49.2l-.84 1.2Z",
    fill: primaryFill
  }));
};

export const CursorHoverRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverRegularIcon, 'CursorHoverRegular');

const CursorHoverOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L3.39 4.1A2 2 0 0 0 2 6v7c0 1.1.9 2 2 2h5v-4.5c0-.23.05-.45.15-.65l.85.86v6.79a.5.5 0 0 0 .91.29l1.57-2.25 2.78.43 1.89 1.88a.5.5 0 0 0 .7-.7l-8-8-7-7Zm11.22 12.62-1.74-.26a.5.5 0 0 0-.49.2l-.84 1.2v-4.2l3.07 3.06Zm2.84.01A2 2 0 0 0 18 13V6a2 2 0 0 0-2-2H6.12l10.79 10.78Z",
    fill: primaryFill
  }));
};

export const CursorHoverOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverOffFilledIcon, 'CursorHoverOffFilled');

const CursorHoverOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7L3.39 4.1A2 2 0 0 0 2 6v7c0 1.1.9 2 2 2h5v-1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h.3l5.7 5.7v6.8a.5.5 0 0 0 .91.29l1.57-2.25 2.78.43 1.89 1.88a.5.5 0 0 0 .7-.7l-15-15Zm11.22 12.62-1.74-.26a.5.5 0 0 0-.49.2l-.84 1.2v-4.2l3.07 3.06Zm2.84.01A2 2 0 0 0 18 13V6a2 2 0 0 0-2-2H6.12l1 1H16a1 1 0 0 1 1 1v7a1 1 0 0 1-.89 1l.8.78Z",
    fill: primaryFill
  }));
};

export const CursorHoverOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CursorHoverOffRegularIcon, 'CursorHoverOffRegular');

const CutFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m14.88 3.16-3.1 4.77-.9-1.38 2.74-4.2a.75.75 0 0 1 1.26.8Zm-2.38 8.6a3.24 3.24 0 0 1 4.5 2.99 3.25 3.25 0 1 1-5.72-2.11L10 10.66l-1.28 1.98a3.25 3.25 0 1 1-1.21-.88l1.6-2.47-3.99-6.13a.75.75 0 0 1 1.26-.82l6.12 9.41Zm.2 1.6a1.75 1.75 0 1 0 .01-.02l-.02.02ZM6.24 13a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5Z",
    fill: primaryFill
  }));
};

export const CutFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/CutFilledIcon, 'CutFilled');

const CutRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.92 2.23a.5.5 0 0 0-.84.54L9.4 9.43l-1.92 2.96a3 3 0 1 0 .78.64L10 10.35l1.74 2.68a3 3 0 1 0 .78-.64L5.92 2.23ZM14 17a2 2 0 1 1 0-4 2 2 0 0 1 0 4ZM4 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm7.2-6.49-.6-.92 3.48-5.36a.5.5 0 0 1 .84.54l-3.73 5.74Z",
    fill: primaryFill
  }));
};

export const CutRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/CutRegularIcon, 'CutRegular');

const DarkThemeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3.5a6.5 6.5 0 1 1 0 13v-13ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    fill: primaryFill
  }));
};

export const DarkThemeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DarkThemeFilledIcon, 'DarkThemeFilled');

const DarkThemeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 3a7 7 0 1 1 0 14V3Zm0-1a8 8 0 1 0 0 16 8 8 0 0 0 0-16Z",
    fill: primaryFill
  }));
};

export const DarkThemeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DarkThemeRegularIcon, 'DarkThemeRegular');

const DataAreaFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.49a.5.5 0 0 0-1 .01v15c0 .28.22.5.5.5h15a.5.5 0 1 0 0-1H3V2.49ZM16 16V5.5a.5.5 0 0 0-.81-.39L10.45 8.9l-3.2-1.83a.5.5 0 0 0-.45-.03L4 8.3V16h12Z",
    fill: primaryFill
  }));
};

export const DataAreaFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataAreaFilledIcon, 'DataAreaFilled');

const DataAreaRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.5a.5.5 0 1 0-1 0v15c0 .28.22.5.5.5h15a.5.5 0 0 0 0-1H16V5.5a.5.5 0 0 0-.81-.39L10.45 8.9l-3.2-1.83a.5.5 0 0 0-.45-.03L3 8.74V2.5Zm0 7.32 3.97-1.76 3.28 1.87c.18.1.4.09.56-.04L15 6.54V17H3V9.82Z",
    fill: primaryFill
  }));
};

export const DataAreaRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataAreaRegularIcon, 'DataAreaRegular');

const DataBarHorizontalFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 1 0 0 4h5a2 2 0 1 0 0-4H4Zm0 6a2 2 0 1 0 0 4h8a2 2 0 1 0 0-4H4Zm0 6a2 2 0 1 0 0 4h12a2 2 0 1 0 0-4H4Z",
    fill: primaryFill
  }));
};

export const DataBarHorizontalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarHorizontalFilledIcon, 'DataBarHorizontalFilled');

const DataBarHorizontalRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h5a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm2-1a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2H4Zm-2 7c0-1.1.9-2 2-2h8a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm2-1a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H4Zm-2 7c0-1.1.9-2 2-2h12a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm2-1a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H4Z",
    fill: primaryFill
  }));
};

export const DataBarHorizontalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarHorizontalRegularIcon, 'DataBarHorizontalRegular');

const DataBarVerticalFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2Zm5 3a2 2 0 0 0-2 2v7a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2Zm5 3a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0v-4a2 2 0 0 0-2-2Z",
    fill: primaryFill
  }));
};

export const DataBarVerticalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalFilledIcon, 'DataBarVerticalFilled');

const DataBarVerticalRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v10a2 2 0 1 0 4 0V5a2 2 0 0 0-2-2ZM4 5a1 1 0 0 1 2 0v10a1 1 0 1 1-2 0V5Zm4 3a2 2 0 1 1 4 0v7a2 2 0 1 1-4 0V8Zm2-1a1 1 0 0 0-1 1v7a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1Zm3 4a2 2 0 1 1 4 0v4a2 2 0 1 1-4 0v-4Zm2-1a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1Z",
    fill: primaryFill
  }));
};

export const DataBarVerticalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalRegularIcon, 'DataBarVerticalRegular');

const DataBarVerticalAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 3a2 2 0 0 1 2 2v4.6a5.48 5.48 0 0 0-4-.4V5c0-1.1.9-2 2-2ZM9 14.5c0 .88.2 1.72.58 2.46A2 2 0 0 1 8 15V8a2 2 0 1 1 4 0v1.6a5.5 5.5 0 0 0-3 4.9ZM7 11a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0v-4Zm12 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const DataBarVerticalAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalAddFilledIcon, 'DataBarVerticalAddFilled');

const DataBarVerticalAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 3a2 2 0 0 1 2 2v4.6c-.32-.16-.65-.3-1-.4V5a1 1 0 1 0-2 0v4.02c-.34.03-.68.1-1 .19V5c0-1.1.9-2 2-2ZM9.07 15.36c.09.57.26 1.1.5 1.6A2 2 0 0 1 8 15V8a2 2 0 1 1 4 0v1.6c-.36.18-.7.4-1 .66V8a1 1 0 1 0-2 0v7a1 1 0 0 0 .07.36ZM5 9a2 2 0 0 1 2 2v4a2 2 0 1 1-4 0v-4c0-1.1.9-2 2-2Zm1 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Zm13 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14h-1.5a.5.5 0 0 0 0 1H14v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H15v-1.5Z",
    fill: primaryFill
  }));
};

export const DataBarVerticalAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalAddRegularIcon, 'DataBarVerticalAddRegular');

const DataBarVerticalStarFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 3a2 2 0 0 1 2 2v4.6a5.48 5.48 0 0 0-4-.4V5c0-1.1.9-2 2-2ZM9 14.5c0 .88.2 1.72.58 2.46A2 2 0 0 1 8 15V8a2 2 0 1 1 4 0v1.6a5.5 5.5 0 0 0-3 4.9ZM7 11a2 2 0 1 0-4 0v4a2 2 0 1 0 4 0v-4Zm12 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53Z",
    fill: primaryFill
  }));
};

export const DataBarVerticalStarFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalStarFilledIcon, 'DataBarVerticalStarFilled');

const DataBarVerticalStarRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 3a2 2 0 0 1 2 2v4.6c-.32-.16-.65-.3-1-.4V5a1 1 0 1 0-2 0v4.02c-.34.03-.68.1-1 .19V5c0-1.1.9-2 2-2ZM9.07 15.36c.09.57.26 1.1.5 1.6A2 2 0 0 1 8 15V8a2 2 0 1 1 4 0v1.6c-.36.18-.7.4-1 .66V8a1 1 0 1 0-2 0v7a1 1 0 0 0 .07.36ZM5 9a2 2 0 0 1 2 2v4a2 2 0 1 1-4 0v-4c0-1.1.9-2 2-2Zm1 2a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4Zm13 3.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.02-2.64a.5.5 0 0 0-.96 0l-.47 1.53H12c-.48 0-.69.65-.3.95l1.26.94-.48 1.53c-.15.49.38.89.77.59l1.25-.95 1.25.95c.4.3.92-.1.77-.59l-.48-1.53 1.25-.94c.4-.3.2-.95-.3-.95h-1.54l-.47-1.53Z",
    fill: primaryFill
  }));
};

export const DataBarVerticalStarRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataBarVerticalStarRegularIcon, 'DataBarVerticalStarRegular');

const DataFunnelFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm2 6c0-1.1.9-2 2-2h8a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2Zm4 4a2 2 0 1 0 0 4h4a2 2 0 1 0 0-4H8Z",
    fill: primaryFill
  }));
};

export const DataFunnelFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataFunnelFilledIcon, 'DataFunnelFilled');

const DataFunnelRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2Zm2-1a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H4Zm0 7c0-1.1.9-2 2-2h8a2 2 0 1 1 0 4H6a2 2 0 0 1-2-2Zm2-1a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H6Zm2 5a2 2 0 1 0 0 4h4a2 2 0 1 0 0-4H8Zm-1 2a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
    fill: primaryFill
  }));
};

export const DataFunnelRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataFunnelRegularIcon, 'DataFunnelRegular');

const DataHistogramFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 4.5c0-.83-.67-1.5-1.5-1.5h-1C8.67 3 8 3.67 8 4.5V17h4V4.5ZM13 6v11h3.5a.5.5 0 0 0 .5-.5V8a2 2 0 0 0-2-2h-2ZM5 9h2v8H3.5a.5.5 0 0 1-.5-.5V11c0-1.1.9-2 2-2Z",
    fill: primaryFill
  }));
};

export const DataHistogramFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataHistogramFilledIcon, 'DataHistogramFilled');

const DataHistogramRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5v11h4V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1ZM7 9V5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1h2a2 2 0 0 1 2 2v8.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V11c0-1.1.9-2 2-2h2Zm0 7v-6H5a1 1 0 0 0-1 1v5h3Zm6 0h3V8a1 1 0 0 0-1-1h-2v9Z",
    fill: primaryFill
  }));
};

export const DataHistogramRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataHistogramRegularIcon, 'DataHistogramRegular');

const DataLineFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 5.5a2.5 2.5 0 0 1-3.44 2.32l-1.29 1.92A2.5 2.5 0 0 1 11.5 14a2.5 2.5 0 0 1-2.05-1.08L6.95 14A2.51 2.51 0 0 1 4.5 17a2.5 2.5 0 1 1 2.05-3.92L9.05 12a2.51 2.51 0 0 1 3.4-2.83l1.28-1.92A2.5 2.5 0 0 1 15.5 3 2.5 2.5 0 0 1 18 5.5Z",
    fill: primaryFill
  }));
};

export const DataLineFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataLineFilledIcon, 'DataLineFilled');

const DataLineRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 5.5a2.5 2.5 0 1 1 1.56 2.32l-1.29 1.92A2.5 2.5 0 0 1 11.5 14a2.5 2.5 0 0 1-2.05-1.08L6.95 14A2.51 2.51 0 0 1 4.5 17a2.5 2.5 0 1 1 2.05-3.92L9.05 12A2.51 2.51 0 0 1 11.5 9c.33 0 .65.07.94.18l1.29-1.92A2.5 2.5 0 0 1 13 5.5Zm-3 6a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm-7 3a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
    fill: primaryFill
  }));
};

export const DataLineRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataLineRegularIcon, 'DataLineRegular');

const DataPieFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 4.07c.55-.08 1 .38 1 .93v6h6c.55 0 1 .45.93 1A7 7 0 1 1 8 4.07ZM17.06 10c.5 0 .93-.37.94-.86V9a7 7 0 0 0-7.14-7c-.5.01-.86.44-.86.94V9a1 1 0 0 0 1 1h6.06Z",
    fill: primaryFill
  }));
};

export const DataPieFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataPieFilledIcon, 'DataPieFilled');

const DataPieRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 12a1 1 0 0 1-1-1V5.08A6 6 0 1 0 14.92 12H9ZM8 4.07c.55-.08 1 .38 1 .93v6h6c.55 0 1 .45.93 1A7 7 0 1 1 8 4.07ZM11 9V3a6 6 0 0 1 6 6h-6Zm6.06 1c.5 0 .93-.37.94-.86V9a7 7 0 0 0-7.14-7c-.5.01-.86.44-.86.94V9a1 1 0 0 0 1 1h6.06Z",
    fill: primaryFill
  }));
};

export const DataPieRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataPieRegularIcon, 'DataPieRegular');

const DataScatterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.5a.5.5 0 0 0-1 0v15c0 .28.22.5.5.5h15a.5.5 0 0 0 0-1H3V2.5ZM7.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM17 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM12.5 15a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: primaryFill
  }));
};

export const DataScatterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataScatterFilledIcon, 'DataScatterFilled');

const DataScatterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 2.5a.5.5 0 0 0-1 0v15c0 .28.22.5.5.5h15a.5.5 0 0 0 0-1H3V2.5Zm3 5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM7.5 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm7-1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 5.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Zm-1 7a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
    fill: primaryFill
  }));
};

export const DataScatterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataScatterRegularIcon, 'DataScatterRegular');

const DataSunburstFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.94 3.13a.5.5 0 0 1-.2.68A7.03 7.03 0 0 0 3.8 6.73a.5.5 0 1 1-.89-.46 8.03 8.03 0 0 1 3.35-3.35.5.5 0 0 1 .67.21Zm6.12 0a.5.5 0 0 1 .67-.2 8.03 8.03 0 0 1 3.35 3.34.5.5 0 0 1-.89.46 7.03 7.03 0 0 0-2.92-2.92.5.5 0 0 1-.21-.68Zm-9.93 9.93a.5.5 0 0 1 .68.2 7.03 7.03 0 0 0 2.92 2.93.5.5 0 1 1-.46.89 8.03 8.03 0 0 1-3.35-3.35.5.5 0 0 1 .21-.67Zm13.74 0a.5.5 0 0 1 .2.67 8.03 8.03 0 0 1-3.34 3.35.5.5 0 0 1-.46-.89 7.03 7.03 0 0 0 2.92-2.92.5.5 0 0 1 .68-.21ZM10 5.5c-.15 0-.3 0-.45.02a.5.5 0 0 1-.1-1L10 4.5a5.5 5.5 0 0 1 5.25 3.85.5.5 0 1 1-.96.3A4.5 4.5 0 0 0 10 5.5Zm-2.6.2a.5.5 0 0 1-.1.7 4.5 4.5 0 0 0-1.2 5.85.5.5 0 1 1-.86.5A5.48 5.48 0 0 1 6.7 5.6a.5.5 0 0 1 .7.1Zm7.52 5.32a.5.5 0 0 1 .33.63 5.5 5.5 0 0 1-8 3.11.5.5 0 1 1 .5-.86 4.5 4.5 0 0 0 6.54-2.55.5.5 0 0 1 .63-.33ZM10 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: primaryFill
  }));
};

export const DataSunburstFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataSunburstFilledIcon, 'DataSunburstFilled');

const DataSunburstRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.94 3.13a.5.5 0 0 1-.2.68A7.03 7.03 0 0 0 3.8 6.73a.5.5 0 1 1-.89-.46 8.03 8.03 0 0 1 3.35-3.35.5.5 0 0 1 .67.21Zm6.12 0a.5.5 0 0 1 .67-.2 8.03 8.03 0 0 1 3.35 3.34.5.5 0 0 1-.89.46 7.03 7.03 0 0 0-2.92-2.92.5.5 0 0 1-.21-.68Zm-9.93 9.93a.5.5 0 0 1 .68.2 7.03 7.03 0 0 0 2.92 2.93.5.5 0 1 1-.46.89 8.03 8.03 0 0 1-3.35-3.35.5.5 0 0 1 .21-.67Zm13.74 0a.5.5 0 0 1 .2.67 8.03 8.03 0 0 1-3.34 3.35.5.5 0 0 1-.46-.89 7.03 7.03 0 0 0 2.92-2.92.5.5 0 0 1 .68-.21ZM10 5.5c-.15 0-.3 0-.45.02a.5.5 0 0 1-.1-1L10 4.5a5.5 5.5 0 0 1 5.25 3.85.5.5 0 1 1-.96.3A4.5 4.5 0 0 0 10 5.5Zm-2.6.2a.5.5 0 0 1-.1.7 4.5 4.5 0 0 0-1.2 5.85.5.5 0 1 1-.86.5A5.48 5.48 0 0 1 6.7 5.6a.5.5 0 0 1 .7.1Zm7.52 5.32a.5.5 0 0 1 .33.63 5.5 5.5 0 0 1-8 3.11.5.5 0 1 1 .5-.86 4.5 4.5 0 0 0 6.54-2.55.5.5 0 0 1 .63-.33ZM8 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
    fill: primaryFill
  }));
};

export const DataSunburstRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataSunburstRegularIcon, 'DataSunburstRegular');

const DataTreemapFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h1V3Zm1 14h6a3 3 0 0 0 3-3v-1H8v4Zm9-5V6a3 3 0 0 0-3-3H8v9h9Z",
    fill: primaryFill
  }));
};

export const DataTreemapFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTreemapFilledIcon, 'DataTreemapFilled');

const DataTreemapRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm1 1v12H6a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1Zm1 12v-3h8v1a2 2 0 0 1-2 2H8Zm8-4H8V4h6a2 2 0 0 1 2 2v6Z",
    fill: primaryFill
  }));
};

export const DataTreemapRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTreemapRegularIcon, 'DataTreemapRegular');

const DataTrendingFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3.75a.75.75 0 0 0-1.5 0v10.5A2.75 2.75 0 0 0 5.75 17h10.5a.75.75 0 0 0 0-1.5H5.75c-.69 0-1.25-.56-1.25-1.25V3.75ZM12.75 5a.75.75 0 0 0 0 1.5h1.69L11 9.94 9.53 8.47a.75.75 0 0 0-1.06 0l-2.75 2.75a.75.75 0 1 0 1.06 1.06L9 10.06l1.47 1.47a.75.75 0 0 0 1.06 0l3.97-3.97v1.69a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75h-3.5Z",
    fill: primaryFill
  }));
};

export const DataTrendingFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTrendingFilledIcon, 'DataTrendingFilled');

const DataTrendingRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3.5a.5.5 0 0 0-1 0v11A2.5 2.5 0 0 0 5.5 17h11a.5.5 0 0 0 0-1h-11A1.5 1.5 0 0 1 4 14.5v-11ZM12.5 5a.5.5 0 0 0 0 1h2.8L11 10.3 9.35 8.64a.5.5 0 0 0-.7 0l-3.5 3.5a.5.5 0 0 0 .7.7L9 9.71l1.65 1.64a.5.5 0 0 0 .7 0L16 6.71V9.5a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-.5-.5h-4Z",
    fill: primaryFill
  }));
};

export const DataTrendingRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataTrendingRegularIcon, 'DataTrendingRegular');

const DataUsageFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm5 7c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5ZM6 8.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5ZM13.5 6c.28 0 .5.22.5.5v7a.5.5 0 0 1-1 0v-7c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DataUsageFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageFilledIcon, 'DataUsageFilled');

const DataUsageRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 10a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5ZM6 8.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5ZM13.5 6a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 1 0v-7a.5.5 0 0 0-.5-.5ZM3 5c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm1 0v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1Z",
    fill: primaryFill
  }));
};

export const DataUsageRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageRegularIcon, 'DataUsageRegular');

const DataUsageEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h5.48c.15-.5.42-.96.8-1.33l1.84-1.85a.5.5 0 0 1-.12-.32v-7a.5.5 0 0 1 1 0v6.44l2.1-2.1c.27-.27.57-.47.9-.6V4a2 2 0 0 0-2-2H4Zm5 7c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5ZM5 7.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm5.98 7.88 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.82 4.83a2.2 2.2 0 0 1-1.03.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const DataUsageEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageEditFilledIcon, 'DataUsageEditFilled');

const DataUsageEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 15h5.99c-.23.3-.4.64-.51 1H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v5.23c-.33.14-.63.34-.9.61l-.1.1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1Zm8-9.5a.5.5 0 0 1 1 0v6.44l-.88.88a.5.5 0 0 1-.12-.32v-7Zm-7 2a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5ZM9 9a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 1 0v-3A.5.5 0 0 0 9 9Zm1.98 6.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.82 4.83a2.2 2.2 0 0 1-1.03.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Z",
    fill: primaryFill
  }));
};

export const DataUsageEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageEditRegularIcon, 'DataUsageEditRegular');

const DataUsageSettingsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3.2a5.5 5.5 0 0 0-3 0V6.5a.5.5 0 0 0-1 0v3.1a5.5 5.5 0 0 0-2.5 2.6v-1.7a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .52.5 5.5 5.5 0 0 0 .58 3H5a3 3 0 0 1-3-3V6Zm3.5 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm6.57 3.44a2 2 0 0 1-1.43 2.48l-.47.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const DataUsageSettingsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageSettingsFilledIcon, 'DataUsageSettingsFilled');

const DataUsageSettingsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h4.6a5.5 5.5 0 0 1-.4-1H5a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v3.02a5.5 5.5 0 0 1 1 .19V6a3 3 0 0 0-3-3H5Zm4.02 11a5.5 5.5 0 0 1 .48-1.8v-1.7a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .52.5Zm3.38-4.58.6-.21V6.5a.5.5 0 0 0-1 0v3.1c.13-.06.26-.13.4-.18ZM5.5 8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-.5-.5Zm6.57 3.44a2 2 0 0 1-1.43 2.48l-.47.12a4.7 4.7 0 0 0 .01 1.01l.35.09A2 2 0 0 1 12 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 0 1 2.91 0l.34.36c.3-.13.57-.3.82-.5l-.15-.55a2 2 0 0 1 1.43-2.48l.46-.12a4.73 4.73 0 0 0-.01-1.01l-.35-.09A2 2 0 0 1 17 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 0 1-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.16.55Zm2.43 4.06a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
    fill: primaryFill
  }));
};

export const DataUsageSettingsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageSettingsRegularIcon, 'DataUsageSettingsRegular');

const DataUsageToolboxFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h5v-2.5c0-.17.02-.34.05-.5H9a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0V12c.37-.5.91-.84 1.54-.96A2.5 2.5 0 0 1 12 9.5v-4a.5.5 0 0 1 1 0v3.55c.16-.03.33-.05.5-.05h2c.17 0 .34.02.5.05V4a2 2 0 0 0-2-2H4Zm1 5.5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm7 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0V16Z",
    fill: primaryFill
  }));
};

export const DataUsageToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageToolboxFilledIcon, 'DataUsageToolboxFilled');

const DataUsageToolboxRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 9a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .55.5c.08-.37.23-.71.45-1V9.5A.5.5 0 0 0 9 9Zm-5 6h5v1H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v5.05a2.51 2.51 0 0 0-.5-.05H15V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1Zm9-9.5v3.55c-.37.07-.7.23-1 .45v-4a.5.5 0 0 1 1 0Zm-8 2a.5.5 0 0 1 1 0v5a.5.5 0 0 1-1 0v-5Zm7 4.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 4.5h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0V16Z",
    fill: primaryFill
  }));
};

export const DataUsageToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataUsageToolboxRegularIcon, 'DataUsageToolboxRegular');

const DataWaterfallFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3.5c0-.28.22-.5.5-.5H7a2 2 0 0 1 2 2v4.5h6c1.04 0 2 .74 2 1.8V16h1.5a.5.5 0 0 1 0 1H13c-1.04 0-2-.74-2-1.8v-4.7H5a2 2 0 0 1-2-2V4H1.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DataWaterfallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWaterfallFilledIcon, 'DataWaterfallFilled');

const DataWaterfallRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 3.5c0-.28.22-.5.5-.5H7a2 2 0 0 1 2 2v4.5h6c1.04 0 2 .74 2 1.8V16h1.5a.5.5 0 0 1 0 1H13c-1.04 0-2-.74-2-1.8v-4.7H5a2 2 0 0 1-2-2V4H1.5a.5.5 0 0 1-.5-.5ZM4 4v4.5a1 1 0 0 0 1 1h3V5a1 1 0 0 0-1-1H4Zm12 12v-4.7c0-.38-.38-.8-1-.8h-3v4.7c0 .38.38.8 1 .8h3Z",
    fill: primaryFill
  }));
};

export const DataWaterfallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWaterfallRegularIcon, 'DataWaterfallRegular');

const DataWhiskerFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a.5.5 0 0 0 0 1h1v1h-.5C4.67 4 4 4.67 4 5.5V10h5V5.5C9 4.67 8.33 4 7.5 4H7V3h1a.5.5 0 0 0 0-1H5Zm7 2a.5.5 0 0 0 0 1h1v1h-.5c-.83 0-1.5.67-1.5 1.5V9h5V7.5c0-.83-.67-1.5-1.5-1.5H14V5h1a.5.5 0 0 0 0-1h-3ZM4.5 15.5c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H7v-1h.5c.83 0 1.5-.67 1.5-1.5V11H4v1.5c0 .83.67 1.5 1.5 1.5H6v1H5a.5.5 0 0 0-.5.5ZM12 18a.5.5 0 0 1 0-1h1v-1h-.5a1.5 1.5 0 0 1-1.5-1.5V10h5v4.5c0 .83-.67 1.5-1.5 1.5H14v1h1a.5.5 0 0 1 0 1h-3Z",
    fill: primaryFill
  }));
};

export const DataWhiskerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWhiskerFilledIcon, 'DataWhiskerFilled');

const DataWhiskerRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a.5.5 0 0 0 0 1h1v1h-.5C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5H6v1H5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H7v-1h.5c.83 0 1.5-.67 1.5-1.5v-7C9 4.67 8.33 4 7.5 4H7V3h1a.5.5 0 0 0 0-1H5Zm0 10.5V11h3v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5Zm0-7c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V10H5V5.5ZM12 4a.5.5 0 0 0 0 1h1v1h-.5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h.5v1h-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-1v-1h.5c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5H14V5h1a.5.5 0 0 0 0-1h-3Zm3 5h-3V7.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5V9Zm-3 1h3v4.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V10Z",
    fill: primaryFill
  }));
};

export const DataWhiskerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DataWhiskerRegularIcon, 'DataWhiskerRegular');

const DatabaseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9V15c0 1.66-2.69 3-6 3s-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98Z",
    fill: primaryFill
  }));
};

export const DatabaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseFilledIcon, 'DatabaseFilled');

const DatabaseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v10c0 1-.88 1.76-1.9 2.22-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5Zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0 0 10 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5Zm10 1.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69c.96-.43 1.32-.94 1.32-1.31V6.7Z",
    fill: primaryFill
  }));
};

export const DatabaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseRegularIcon, 'DatabaseRegular');

const DatabaseArrowDownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9v2.09A5.5 5.5 0 0 0 10.26 18H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85 2.35a.5.5 0 0 0 .35.15.5.5 0 0 0 .35-.15l2-2a.5.5 0 0 0-.7-.7L15 15.29V12.5a.5.5 0 0 0-1 0v2.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2Z",
    fill: primaryFill
  }));
};

export const DatabaseArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowDownFilledIcon, 'DatabaseArrowDownFilled');

const DatabaseArrowDownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4.2c-.32-.08-.66-.15-1-.18V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 9.6 17c.18.36.4.7.66 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5Zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 7a9.2 9.2 0 0 0 3.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0 0 10 3a9.2 9.2 0 0 0-3.68.69C5.36 4.12 5 4.63 5 5Zm14 9.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85 2.35a.5.5 0 0 0 .35.15.5.5 0 0 0 .35-.15l2-2a.5.5 0 0 0-.7-.7L15 15.29V12.5a.5.5 0 0 0-1 0v2.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2Z",
    fill: primaryFill
  }));
};

export const DatabaseArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowDownRegularIcon, 'DatabaseArrowDownRegular');

const DatabaseArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9v2.09A5.5 5.5 0 0 0 10.26 18H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM14.5 10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const DatabaseArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowRightFilledIcon, 'DatabaseArrowRightFilled');

const DatabaseArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4.2c-.32-.08-.66-.15-1-.18V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 9.6 17c.18.36.4.7.66 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5Zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 7a9.2 9.2 0 0 0 3.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0 0 10 3a9.2 9.2 0 0 0-3.68.69C5.36 4.12 5 4.63 5 5Zm9.5 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const DatabaseArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowRightRegularIcon, 'DatabaseArrowRightRegular');

const DatabaseArrowUpFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9v2.09A5.5 5.5 0 0 0 10.26 18H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM10 14.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.85-2.35a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.15l-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2Z",
    fill: primaryFill
  }));
};

export const DatabaseArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowUpFilledIcon, 'DatabaseArrowUpFilled');

const DatabaseArrowUpRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4.2c-.32-.08-.66-.15-1-.18V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 9.6 17c.18.36.4.7.66 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5Zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 7a9.2 9.2 0 0 0 3.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0 0 10 3a9.2 9.2 0 0 0-3.68.69C5.36 4.12 5 4.63 5 5Zm5 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm4.85-2.35a.5.5 0 0 0-.35-.15.5.5 0 0 0-.35.15l-2 2a.5.5 0 0 0 .7.7L14 13.71v2.79a.5.5 0 0 0 1 0v-2.8l1.15 1.15a.5.5 0 0 0 .7-.7l-2-2Z",
    fill: primaryFill
  }));
};

export const DatabaseArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseArrowUpRegularIcon, 'DatabaseArrowUpRegular');

const DatabaseLightningFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9V9h-1.92c-.6 0-1.15.36-1.38.92l-2.08 5A1.5 1.5 0 0 0 12 17h.47l-.2.78c-.7.14-1.46.22-2.27.22-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM13.11 16c.33 0 .57.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-.4a.5.5 0 0 1-.48-.66l.56-1.68a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7h1.11Z",
    fill: primaryFill
  }));
};

export const DatabaseLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLightningFilledIcon, 'DatabaseLightningFilled');

const DatabaseLightningRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v4h-1V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 17c.5.01 1-.02 1.49-.09.15.06.33.09.51.09h.47l-.2.79c-.74.15-1.5.22-2.27.21-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5Zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 7a9.2 9.2 0 0 0 3.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0 0 10 3a9.2 9.2 0 0 0-3.68.69C5.36 4.12 5 4.63 5 5Zm8.11 11c.33 0 .57.3.49.62l-.44 1.74c-.12.48.46.83.83.49l4.87-4.55a.75.75 0 0 0-.51-1.3h-.4a.5.5 0 0 1-.48-.66l.56-1.68a.5.5 0 0 0-.47-.66h-3.47a.5.5 0 0 0-.47.3l-2.08 5c-.14.34.1.7.46.7h1.11Z",
    fill: primaryFill
  }));
};

export const DatabaseLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLightningRegularIcon, 'DatabaseLightningRegular');

const DatabaseLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9V11h-3.5a3.5 3.5 0 0 0-.88 6.89c-.51.07-1.06.11-1.62.11-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM12.5 12a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DatabaseLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLinkFilledIcon, 'DatabaseLinkFilled');

const DatabaseLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v6h-1V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69h.05c.43.43.98.74 1.59.9-.53.06-1.07.1-1.64.1-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5Zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0 0 10 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5Zm7.5 7a2.5 2.5 0 0 0 0 5h.5a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3h.5a.5.5 0 0 0 0-1h-.5Zm3.5 0a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H16a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H16Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DatabaseLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseLinkRegularIcon, 'DatabaseLinkRegular');

const DatabaseMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 4c0 1.66-2.69 3-6 3S6 5.66 6 4s2.69-3 6-3 6 1.34 6 3Zm0 2.12c-.38.36-.84.66-1.31.9-1.25.62-2.91.98-4.69.98-.62 0-1.23-.04-1.81-.13.93.53 1.72 1.34 1.8 2.44H12v6.19c0 .17-.02.34-.05.5H12c3.31 0 6-1.34 6-3V6.12Zm-10.69.9.05.02A9.08 9.08 0 0 0 6 7.01v-.89c.38.36.84.66 1.31.9ZM9 8.42A7.86 7.86 0 0 0 6.5 8C4.01 8 2 9.12 2 10.5S4.01 13 6.5 13s4.5-1.12 4.5-2.5c0-.87-.8-1.63-2-2.08Zm1.17 4.72c-1 .55-2.29.86-3.67.86s-2.68-.3-3.67-.86c-.29-.16-.58-.36-.83-.59v3.95C2 17.88 4.01 19 6.5 19s4.5-1.12 4.5-2.5v-3.95c-.25.23-.54.43-.83.6Z",
    fill: primaryFill
  }));
};

export const DatabaseMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseMultipleFilledIcon, 'DatabaseMultipleFilled');

const DatabaseMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.9 1.78C6.88 2.24 6 2.99 6 4v3.01a9.16 9.16 0 0 1 1 0V5.7c.27.2.58.38.9.52 1.08.5 2.53.78 4.1.78 1.57 0 3.02-.29 4.1-.78.32-.14.63-.32.9-.52V14c0 .37-.36.88-1.32 1.31-.91.42-2.22.69-3.68.69v.5c0 .17-.02.34-.05.5H12c1.57 0 3.02-.29 4.1-.78 1.02-.46 1.9-1.21 1.9-2.22V4c0-1-.88-1.76-1.9-2.22A10.17 10.17 0 0 0 12 1c-1.57 0-3.02.29-4.1.78Zm.42 3.53C7.36 4.88 7 4.37 7 4c0-.37.36-.88 1.32-1.31A9.19 9.19 0 0 1 12 2c1.46 0 2.77.27 3.68.69.96.43 1.32.94 1.32 1.31 0 .37-.36.88-1.32 1.31-.91.42-2.22.69-3.68.69a9.19 9.19 0 0 1-3.68-.69ZM7 8.01a7.68 7.68 0 0 1 2 .41c1.2.45 2 1.21 2 2.08 0 1.38-2.01 2.5-4.5 2.5S2 11.88 2 10.5c0-1.29 1.75-2.35 4-2.48a8.16 8.16 0 0 1 1 0Zm3.93 8.94C10.54 18.12 8.7 19 6.5 19 4.01 19 2 17.88 2 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85s2.68-.3 3.67-.86c.29-.16.58-.36.83-.59v3.95c0 .15-.03.3-.07.45Z",
    fill: primaryFill
  }));
};

export const DatabaseMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseMultipleRegularIcon, 'DatabaseMultipleRegular');

const DatabasePersonFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 5c0 1.66-2.69 3-6 3S4 6.66 4 5s2.69-3 6-3 6 1.34 6 3Zm-1.31 3.02c.28-.14.55-.3.81-.49 0 .81-.7 1.44-1.41 1.82a3 3 0 0 0-.82 4.66A2.5 2.5 0 0 0 11 16.5c0 .49.1.97.33 1.43-.43.04-.87.07-1.33.07-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM17.5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const DatabasePersonFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePersonFilledIcon, 'DatabasePersonFilled');

const DatabasePersonRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v4.04a3.02 3.02 0 0 0-1 0V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69.35 0 .7-.02 1.03-.05.05.34.15.67.3.98-.43.05-.87.07-1.33.07-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5Zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0 0 10 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5Zm12.5 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5Z",
    fill: primaryFill
  }));
};

export const DatabasePersonRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePersonRegularIcon, 'DatabasePersonRegular');

const DatabasePlugConnectedFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9v2.99a2.97 2.97 0 0 0-1.87.86l-.6.6a1.98 1.98 0 0 0-.58 1.52 1.95 1.95 0 0 0-1.52.58l-.6.6a2.99 2.99 0 0 0-.77 2.9l-.76.75-.05.06C6.3 17.79 4 16.53 4 15V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98Zm4.5 2.83a.5.5 0 1 0-.7-.7l-1.19 1.18a.64.64 0 0 0-.03.05 2 2 0 0 0-2.44.3l-.6.6a.98.98 0 0 0 0 1.4l1.45 1.43a.98.98 0 0 0 1.38 0l.6-.6a2 2 0 0 0 .3-2.44.36.36 0 0 0 .06-.03l1.18-1.19Zm-5.66 3.53a.98.98 0 0 0-1.39 0l-.6.6a2 2 0 0 0-.3 2.43.42.42 0 0 0-.05.04L10 18.63a.5.5 0 0 0 .7.7l1.19-1.18a.5.5 0 0 0 .03-.05 2 2 0 0 0 2.44-.3l.6-.6a.98.98 0 0 0 0-1.39l-1.44-1.44Z",
    fill: primaryFill
  }));
};

export const DatabasePlugConnectedFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePlugConnectedFilledIcon, 'DatabasePlugConnectedFilled');

const DatabasePlugConnectedRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v5.1a2.97 2.97 0 0 0-1 .27V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 17h.02a3 3 0 0 0 .04.16l-.76.77a1.5 1.5 0 0 0-.06.06 10.18 10.18 0 0 1-3.34-.77C4.87 16.75 4 16.01 4 15V5Zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 7a9.2 9.2 0 0 0 3.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0 0 10 3a9.2 9.2 0 0 0-3.68.69C5.36 4.12 5 4.63 5 5Zm14.2 5.85a.5.5 0 1 0-.7-.7l-1.2 1.18a.64.64 0 0 0-.03.05 2 2 0 0 0-2.44.3l-.6.6a.98.98 0 0 0 0 1.4l1.45 1.43a.98.98 0 0 0 1.38 0l.6-.6a2 2 0 0 0 .3-2.44.36.36 0 0 0 .06-.03l1.18-1.19Zm-5.67 3.53a.98.98 0 0 0-1.39 0l-.6.6a2 2 0 0 0-.3 2.43.42.42 0 0 0-.05.04L10 18.63a.5.5 0 0 0 .7.7l1.19-1.18a.5.5 0 0 0 .03-.05 2 2 0 0 0 2.44-.3l.6-.6a.98.98 0 0 0 0-1.39l-1.44-1.44Z",
    fill: primaryFill
  }));
};

export const DatabasePlugConnectedRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabasePlugConnectedRegularIcon, 'DatabasePlugConnectedRegular');

const DatabaseSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9v2.64a4.5 4.5 0 1 0-3.83 8.04c-.68.13-1.4.2-2.17.2-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM13.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 15.6a3.5 3.5 0 1 0-2.8 1.4Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const DatabaseSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseSearchFilledIcon, 'DatabaseSearchFilled');

const DatabaseSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v4.76c-.3-.2-.64-.38-1-.5V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.88 1.32 1.31a9.19 9.19 0 0 0 4.33.67c.45.37.97.65 1.53.82-.68.13-1.41.2-2.18.2-1.57 0-3.02-.29-4.1-.78C4.88 16.76 4 16.01 4 15V5Zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0 0 10 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5Zm8.5 12c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 1 0 .7-.7L16.3 15.6a3.5 3.5 0 1 0-2.8 1.4Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const DatabaseSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseSearchRegularIcon, 'DatabaseSearchRegular');

const DatabaseSwitchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.85 18.85a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .81.16.5.5 0 0 1-.1.54L10.7 16h5.58l-1.14-1.15a.5.5 0 0 1 .16-.81.5.5 0 0 1 .54.1l2 2a.5.5 0 0 1 0 .71l-2 2a.5.5 0 0 1-.81-.16.5.5 0 0 1 .1-.54L16.3 17h-5.58l1.14 1.15a.5.5 0 0 1 0 .7ZM10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm-1.56 9.56a1.5 1.5 0 0 1 0-2.12l2-2a1.5 1.5 0 0 1 2.12 0 1.5 1.5 0 0 1 .35 1.56h1.18A1.5 1.5 0 0 1 16 13.1V7.11a4.93 4.93 0 0 1-1.31.9c-.33.16-.66.3-1.01.42-1.19.38-2.43.57-3.68.56-1.25.01-2.5-.18-3.68-.57a8.15 8.15 0 0 1-1.7-.81 4.93 4.93 0 0 1-.62-.5V15c0 1.45 2.07 2.66 4.81 2.93l-.37-.37Z",
    fill: primaryFill
  }));
};

export const DatabaseSwitchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseSwitchFilledIcon, 'DatabaseSwitchFilled');

const DatabaseSwitchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.44 17.56c-.2-.2-.32-.46-.38-.73-.6-.1-1.18-.27-1.74-.52C5.36 15.87 5 15.37 5 15V6.7c.28.2.58.38.9.52 1.3.54 2.7.8 4.1.78 1.4.03 2.8-.24 4.1-.78.32-.14.62-.31.9-.52v6.4c.32-.13.68-.13 1 0V5c0-1-.88-1.76-1.9-2.22-1.3-.54-2.7-.8-4.1-.78-1.4-.03-2.8.24-4.1.78C4.87 3.24 4 3.99 4 5v10c0 1 .88 1.75 1.9 2.22.93.4 1.91.64 2.92.72l-.38-.38ZM6.32 3.7A9.2 9.2 0 0 1 10 3a9.2 9.2 0 0 1 3.68.69C14.64 4.12 15 4.63 15 5c0 .37-.36.87-1.32 1.31A9.2 9.2 0 0 1 10 7a9.2 9.2 0 0 1-3.68-.69C5.36 5.87 5 5.37 5 5c0-.37.36-.88 1.32-1.31Zm5.53 15.16a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 0 1 .7.7L10.71 16h5.58l-1.14-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 0 .7l-2 2a.5.5 0 1 1-.7-.7L16.29 17h-5.58l1.14 1.15a.5.5 0 0 1 0 .7Z",
    fill: primaryFill
  }));
};

export const DatabaseSwitchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseSwitchRegularIcon, 'DatabaseSwitchRegular');

const DatabaseWarningFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 5c0 1.66-2.69 3-6 3S4 6.66 4 5s2.69-3 6-3 6 1.34 6 3Zm-1.31 3.02.31-.17v.21c-.53.14-1 .48-1.29 1.05l-3.5 7c-.31.64-.25 1.34.06 1.89H10c-3.31 0-6-1.34-6-3V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98Zm-.09 1.53-3.5 7A1 1 0 0 0 12 18h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM16 11.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z",
    fill: primaryFill
  }));
};

export const DatabaseWarningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWarningFilledIcon, 'DatabaseWarningFilled');

const DatabaseWarningRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22 1.3-.54 2.7-.8 4.1-.78 1.4-.03 2.8.24 4.1.78C15.13 3.24 16 3.99 16 5v3.06a2.05 2.05 0 0 0-1 0V6.7c-.28.2-.58.38-.9.52-1.3.54-2.7.8-4.1.78-1.4.03-2.8-.24-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 17c0 .36.1.7.28 1H10c-1.4.03-2.8-.24-4.1-.78C4.87 16.75 4 16.01 4 15V5Zm1 0c0 .37.36.87 1.32 1.31A9.2 9.2 0 0 0 10 7a9.2 9.2 0 0 0 3.68-.69C14.64 5.87 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.2 9.2 0 0 0 10 3a9.2 9.2 0 0 0-3.68.69C5.36 4.12 5 4.63 5 5Zm9.6 4.55-3.5 7A1 1 0 0 0 12 18h7a1 1 0 0 0 .9-1.45l-3.5-7a1 1 0 0 0-1.8 0ZM16 11.5v3a.5.5 0 1 1-1 0v-3a.5.5 0 1 1 1 0Zm-.5 5.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z",
    fill: primaryFill
  }));
};

export const DatabaseWarningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWarningRegularIcon, 'DatabaseWarningRegular');

const DatabaseWindowFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 8c3.31 0 6-1.34 6-3s-2.69-3-6-3-6 1.34-6 3 2.69 3 6 3Zm4.69.02c.47-.24.93-.54 1.31-.9V9h-4.5A2.5 2.5 0 0 0 9 11.5v6c0 .16.01.31.04.46C6.18 17.73 4 16.5 4 15V7.12c.38.36.84.66 1.31.9C6.56 8.64 8.22 9 10 9c1.78 0 3.44-.36 4.69-.98ZM10 11.5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v.5h-9v-.5Zm0 1.5h9v4.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V13Z",
    fill: primaryFill
  }));
};

export const DatabaseWindowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWindowFilledIcon, 'DatabaseWindowFilled');

const DatabaseWindowRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c0-1 .88-1.76 1.9-2.22C6.98 2.28 8.43 2 10 2c1.57 0 3.02.29 4.1.78C15.12 3.24 16 3.99 16 5v4h-1V6.7c-.27.2-.58.38-.9.52-1.08.5-2.53.78-4.1.78-1.57 0-3.02-.29-4.1-.78A4.92 4.92 0 0 1 5 6.7V15c0 .37.36.88 1.32 1.31.7.32 1.63.55 2.68.65v.54c0 .16.01.31.04.46a9.47 9.47 0 0 1-3.14-.74C4.88 16.76 4 16.01 4 15V5Zm1 0c0 .37.36.88 1.32 1.31.91.42 2.22.69 3.68.69s2.77-.27 3.68-.69C14.64 5.88 15 5.37 15 5c0-.37-.36-.88-1.32-1.31A9.19 9.19 0 0 0 10 3c-1.46 0-2.77.27-3.68.69C5.36 4.12 5 4.63 5 5Zm5 6.5c0-.83.67-1.5 1.5-1.5h6c.83 0 1.5.67 1.5 1.5v.5h-9v-.5Zm0 1.5h9v4.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V13Z",
    fill: primaryFill
  }));
};

export const DatabaseWindowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DatabaseWindowRegularIcon, 'DatabaseWindowRegular');

const DecimalArrowLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3Zm-1 2.5a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0v-4ZM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12.5-9A2.5 2.5 0 0 0 13 5.5v3.7c.48-.13.98-.2 1.5-.2V5.5a1 1 0 1 1 2 0v3.87c.51.2.98.48 1.4.81.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0 0 15.5 3Zm-1 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const DecimalArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowLeftFilledIcon, 'DecimalArrowLeftFilled');

const DecimalArrowLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3ZM7 5.5a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 0 1-3 0v-4ZM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12.5-9A2.5 2.5 0 0 0 13 5.5v3.7c.32-.08.66-.15 1-.18V5.5a1.5 1.5 0 0 1 3 0v4.1c.32.16.62.36.9.58.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0 0 15.5 3Zm-1 16a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L13.71 15h2.79a.5.5 0 0 0 0-1h-2.8l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const DecimalArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowLeftRegularIcon, 'DecimalArrowLeftRegular');

const DecimalArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3Zm-1 2.5a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0v-4ZM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12.5-9A2.5 2.5 0 0 0 13 5.5v3.7c.48-.13.98-.2 1.5-.2V5.5a1 1 0 1 1 2 0v3.87c.51.2.98.48 1.4.81.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0 0 15.5 3Zm-1 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const DecimalArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowRightFilledIcon, 'DecimalArrowRightFilled');

const DecimalArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3A2.5 2.5 0 0 0 6 5.5v4a2.5 2.5 0 0 0 5 0v-4A2.5 2.5 0 0 0 8.5 3ZM7 5.5a1.5 1.5 0 1 1 3 0v4a1.5 1.5 0 0 1-3 0v-4ZM3 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm12.5-9A2.5 2.5 0 0 0 13 5.5v3.7c.32-.08.66-.15 1-.18V5.5a1.5 1.5 0 0 1 3 0v4.1c.32.16.62.36.9.58.07-.22.1-.44.1-.68v-4A2.5 2.5 0 0 0 15.5 3Zm-1 7a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm2.35 4.85a.5.5 0 0 0 .15-.35.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 14H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2Z",
    fill: primaryFill
  }));
};

export const DecimalArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DecimalArrowRightRegularIcon, 'DecimalArrowRightRegular');

const DeleteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 4h3a1.5 1.5 0 0 0-3 0Zm-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5ZM9 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V8Zm2.5-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5Z",
    fill: primaryFill
  }));
};

export const DeleteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteFilledIcon, 'DeleteFilled');

const DeleteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 4h3a1.5 1.5 0 0 0-3 0Zm-1 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-1.2 10.34A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5ZM5.74 15.23A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77L15.44 5H4.56l1.18 10.23ZM8.5 7.5c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0V8c0-.28.22-.5.5-.5ZM12 8a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V8Z",
    fill: primaryFill
  }));
};

export const DeleteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteRegularIcon, 'DeleteRegular');

const DeleteArrowBackFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 0 0-3 0h3Zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.5 5.5 0 0 0-5.7 8.8H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5Zm7 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const DeleteArrowBackFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteArrowBackFilledIcon, 'DeleteArrowBackFilled');

const DeleteArrowBackRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 0 0-3 0h3Zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.48 5.48 0 0 0-.98-.18L15.44 5H4.56l1.18 10.23A2 2 0 0 0 7.73 17H9.6c.18.36.4.7.66 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5Zm7 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-.9-6.4-.9.9h1.55A2.75 2.75 0 0 1 17 16.25v.25a.5.5 0 0 1-1 0v-.25c0-.97-.78-1.75-1.75-1.75h-1.54l.9.9a.5.5 0 0 1-.71.7l-1.76-1.75a.5.5 0 0 1 0-.7l1.76-1.75a.5.5 0 0 1 .7.7Z",
    fill: primaryFill
  }));
};

export const DeleteArrowBackRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteArrowBackRegularIcon, 'DeleteArrowBackRegular');

const DeleteDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 0 0-3 0h3Zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.5 5.5 0 0 0-5.7 8.8H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const DeleteDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteDismissFilledIcon, 'DeleteDismissFilled');

const DeleteDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 0 0-3 0h3Zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.49 4.2a5.48 5.48 0 0 0-.98-.18L15.44 5H4.56l1.18 10.23A2 2 0 0 0 7.73 17H9.6c.18.36.4.7.66 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const DeleteDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteDismissRegularIcon, 'DeleteDismissRegular');

const DeleteLinesFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 0 0-3 0h3Zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.81 7H11.5a1.5 1.5 0 0 0-1.12 2.5 1.5 1.5 0 0 0 0 2 1.5 1.5 0 0 0-.3 1.5H7.74a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5Zm4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z",
    fill: primaryFill
  }));
};

export const DeleteLinesFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteLinesFilledIcon, 'DeleteLinesFilled');

const DeleteLinesRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 4a1.5 1.5 0 0 0-3 0h3Zm-4 0a2.5 2.5 0 0 1 5 0h5a.5.5 0 0 1 0 1h-1.05l-.81 7h-1l.8-7H4.56l1.18 10.23A2 2 0 0 0 7.73 17h2.36a1.5 1.5 0 0 0 0 1H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h5Zm4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z",
    fill: primaryFill
  }));
};

export const DeleteLinesRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteLinesRegularIcon, 'DeleteLinesRegular');

const DeleteOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.3 4 2.14 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2-2A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h.8Zm8.7 8.7-1-1V14a.5.5 0 0 0 1 0v-1.3Zm-3-3-1-1V14a.5.5 0 0 0 1 0V9.7ZM12 8v1.88l3.48 3.48.97-8.36h1.05a.5.5 0 0 0 0-1h-5a2.5 2.5 0 0 0-5 0H6.12L11 8.88V8a.5.5 0 0 1 1 0Zm-.5-4h-3a1.5 1.5 0 1 1 3 0Z",
    fill: primaryFill
  }));
};

export const DeleteOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteOffFilledIcon, 'DeleteOffFilled');

const DeleteOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.3 4 2.14 2.85a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-2-2A3 3 0 0 1 12.27 18H7.73a3 3 0 0 1-2.98-2.66L3.55 5H2.5a.5.5 0 0 1 0-1h.8Zm10.99 11L12 12.7V14a.5.5 0 0 1-1 0v-2.3l-2-2V14a.5.5 0 0 1-1 0V8.7L4.6 5.3l1.14 9.93A2 2 0 0 0 7.73 17h4.54a2 2 0 0 0 1.99-1.77l.03-.24ZM11 8.87l1 1V8a.5.5 0 0 0-1 0v.88ZM15.44 5l-.86 7.46.9.9.97-8.36h1.05a.5.5 0 0 0 0-1h-5a2.5 2.5 0 0 0-5 0H6.12l1 1h8.32ZM11.5 4h-3a1.5 1.5 0 1 1 3 0Z",
    fill: primaryFill
  }));
};

export const DeleteOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeleteOffRegularIcon, 'DeleteOffRegular');

const DentistFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.94 3.93a3.46 3.46 0 0 0-2.9-.74c-.92.18-1.73.69-2.26 1.27a4.1 4.1 0 0 0-1.24 2.7c-.03.6.06 1.47.53 2.13a5 5 0 0 1 1.12 3.15c0 .65.14 1.53.46 2.34.32.8.87 1.6 1.77 1.94h.02l.03.01c.52.14 1 .1 1.38-.25.32-.3.46-.76.53-1.16.07-.38.1-.82.14-1.25l.01-.15a12 12 0 0 1 .18-1.44c.27-1.27.65-1.5.83-1.55.49-.13.78-.04.97.1.28.2.49.61.64 1.22.14.6.2 1.27.25 1.88.07.87.25 1.65.6 2.16.18.26.44.49.79.56.35.08.69-.03.99-.22 1.1-.7 1.74-2.17 1.91-4.1.08-.88.17-1.3.3-1.64.1-.25.22-.46.42-.8a39.23 39.23 0 0 0 .36-.63c.25-.43.65-1.23.7-2.16a3.48 3.48 0 0 0-1.44-2.96 4.4 4.4 0 0 0-3.01-1.16c-.9.05-1.62.46-2.13.9h-.01l-.01.02c-.5.49-.73.58-.88.57-.17 0-.45-.14-1.01-.7l-.02-.02-.02-.02Zm4 1.67c.48 0 .98.15 1.38.5.4.35.64.87.7 1.52a.5.5 0 1 1-1 .1c-.03-.45-.19-.72-.37-.88a1.06 1.06 0 0 0-.71-.24.5.5 0 0 1 0-1Z",
    fill: primaryFill
  }));
};

export const DentistFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DentistFilledIcon, 'DentistFilled');

const DentistRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.94 5.6a.5.5 0 0 0 0 1c.29 0 .53.08.71.24.18.16.34.43.38.87a.5.5 0 1 0 1-.09 2.25 2.25 0 0 0-.71-1.52c-.4-.35-.9-.5-1.38-.5Zm-4-1.67a3.46 3.46 0 0 0-2.9-.74c-.92.18-1.73.69-2.26 1.27a4.1 4.1 0 0 0-1.24 2.7c-.03.6.06 1.47.53 2.13a5 5 0 0 1 1.12 3.15c0 .65.14 1.53.46 2.34.32.8.87 1.6 1.77 1.94h.02l.03.01c.52.14 1 .1 1.38-.25.32-.3.46-.76.53-1.16.07-.38.1-.82.14-1.25l.01-.15a12 12 0 0 1 .18-1.44c.27-1.27.65-1.5.83-1.55.49-.13.78-.04.97.1.28.2.49.61.64 1.22.14.6.2 1.27.25 1.88.07.87.25 1.65.6 2.16.18.26.44.49.79.56.35.08.69-.03.99-.22 1.1-.7 1.74-2.17 1.91-4.1.08-.88.17-1.3.3-1.64.1-.25.22-.46.42-.8a39.23 39.23 0 0 0 .36-.63c.25-.43.65-1.23.7-2.16a3.48 3.48 0 0 0-1.44-2.96 4.4 4.4 0 0 0-3.01-1.16c-.9.05-1.62.46-2.13.9h-.01l-.01.02c-.5.49-.73.58-.88.57-.17 0-.45-.14-1.01-.7l-.02-.02-.02-.02Zm-4.43 1.2c.4-.43 1.03-.82 1.72-.96a2.45 2.45 0 0 1 2.06.52c.54.54 1.06.96 1.65.98.62.03 1.13-.37 1.61-.84.4-.34.91-.62 1.52-.65.61-.03 1.39.17 2.33.94.89.72 1.1 1.48 1.06 2.13-.03.7-.33 1.32-.56 1.72l-.12.2-.2.36c-.21.36-.4.66-.52 1-.18.47-.28 1-.36 1.9-.17 1.82-.75 2.9-1.46 3.36-.16.1-.23.09-.25.08-.01 0-.08-.02-.17-.15-.2-.28-.36-.85-.43-1.67v-.02c-.05-.6-.1-1.34-.27-2.01-.16-.67-.44-1.38-1.02-1.8-.49-.35-1.1-.44-1.82-.26h-.01c-.73.22-1.24.92-1.53 2.32-.11.52-.16 1.07-.2 1.56l-.02.15c-.03.44-.06.82-.12 1.14-.07.37-.16.55-.24.62-.03.03-.11.1-.41.02-.5-.2-.9-.7-1.17-1.37a5.7 5.7 0 0 1-.4-1.97 5.98 5.98 0 0 0-1.3-3.72 2.6 2.6 0 0 1-.35-1.51c.04-.87.45-1.48.98-2.06Z",
    fill: primaryFill
  }));
};

export const DentistRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DentistRegularIcon, 'DentistRegular');

const DesignIdeasFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4.5c-.75 0-1.44.24-2.01.64a3.59 3.59 0 0 0-.41-1.52A5 5 0 0 1 14 8h2.25c.97 0 1.75.78 1.75 1.75v5.5c0 .97-.78 1.75-1.75 1.75h-5.5C9.78 17 9 16.22 9 15.25V13c-.72 0-1.4-.15-2.02-.42L7 11.5V10.87c.56.4 1.26.63 2 .63V9.75C9 8.78 9.78 8 10.75 8h1.75A3.5 3.5 0 0 0 9 4.5Zm4.77 5a5.01 5.01 0 0 1-3.27 3.27v2.48c0 .14.11.25.25.25h5.5c.14 0 .25-.11.25-.25v-5.5a.25.25 0 0 0-.25-.25h-2.48Zm-1.6 0h-1.42a.25.25 0 0 0-.25.25v1.41a3.51 3.51 0 0 0 1.66-1.66ZM4.57 2.13a.5.5 0 0 1 .12.6l-.01.08c0 .07.01.19.16.34l.2.18.16.16c.13.12.27.27.4.45.25.38.39.86.39 1.56 0 .85-.32 1.58-.8 2.03l.05.07c.29.34.45.79.55 1.23.2.87.2 1.92.2 2.64v.03c0 2.79-.38 4.37-.8 5.27-.2.46-.43.75-.62.93a1.48 1.48 0 0 1-.4.26S4.09 18 4 18c-.07 0-.19-.04-.19-.04a.75.75 0 0 1-.13-.06c-.07-.05-.16-.1-.26-.2-.2-.18-.41-.47-.62-.93-.42-.9-.8-2.48-.8-5.27v-.03c0-.72 0-1.77.2-2.64a3.02 3.02 0 0 1 .6-1.3C2.33 7.08 2 6.35 2 5.5a4.73 4.73 0 0 1 .69-2.1A4.07 4.07 0 0 1 3.93 2.1l.04-.03a.5.5 0 0 1 .61.05Z",
    fill: primaryFill
  }));
};

export const DesignIdeasFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignIdeasFilledIcon, 'DesignIdeasFilled');

const DesignIdeasRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4c-.76 0-1.48.21-2.08.58a3.3 3.3 0 0 0-.34-.96A5 5 0 0 1 14 8h2.5c.83 0 1.5.67 1.5 1.5v6c0 .83-.67 1.5-1.5 1.5h-6A1.5 1.5 0 0 1 9 15.5V13c-.72 0-1.4-.15-2.02-.42L7 11.5v-.04c.59.35 1.27.54 2 .54V9.5c0-.83.67-1.5 1.5-1.5H13a4 4 0 0 0-4-4Zm4.9 5a5 5 0 0 1-3.9 3.9v2.6c0 .28.22.5.5.5h6a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-2.6Zm-1.03 0H10.5a.5.5 0 0 0-.5.5v2.37A4 4 0 0 0 12.87 9ZM4.58 2.13a.5.5 0 0 1 .12.6l-.01.08c0 .07.01.19.16.34l.2.18.16.16c.13.12.27.27.4.45.25.38.39.86.39 1.56 0 .85-.32 1.58-.8 2.03l.05.07c.29.34.45.79.55 1.23.2.87.2 1.92.2 2.64v.03c0 2.79-.38 4.37-.8 5.27-.2.46-.43.75-.62.93a1.48 1.48 0 0 1-.4.26S4.09 18 4 18c-.07 0-.19-.04-.19-.04a.75.75 0 0 1-.13-.06c-.07-.05-.16-.1-.26-.2-.2-.18-.41-.47-.62-.93-.42-.9-.8-2.48-.8-5.27v-.03c0-.72 0-1.77.2-2.64a3.02 3.02 0 0 1 .6-1.3C2.33 7.08 2 6.35 2 5.5a4.73 4.73 0 0 1 .69-2.1A4.07 4.07 0 0 1 3.93 2.1l.03-.02h.01a.5.5 0 0 1 .61.04ZM4 7c.39 0 1-.43 1-1.5 0-.55-.1-.82-.23-1-.06-.1-.14-.2-.25-.3l-.12-.1-.25-.25a1.67 1.67 0 0 1-.28-.36 2.5 2.5 0 0 0-.34.44A3.73 3.73 0 0 0 3 5.5C3 6.57 3.62 7 4 7Zm-.48 1.23c-.14.18-.26.45-.35.82C3 9.8 3 10.75 3 11.5c0 2.71.37 4.13.7 4.85.11.24.22.4.3.5.08-.1.19-.26.3-.5.33-.72.7-2.14.7-4.85 0-.76 0-1.7-.17-2.45-.1-.37-.2-.64-.35-.82A.57.57 0 0 0 4 8a.57.57 0 0 0-.48.23Z",
    fill: primaryFill
  }));
};

export const DesignIdeasRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesignIdeasRegularIcon, 'DesignIdeasRegular');

const DesktopFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5v-10c0-.83-.67-1.5-1.5-1.5h-13ZM12 15v2H8v-2h4Z",
    fill: primaryFill
  }));
};

export const DesktopFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopFilledIcon, 'DesktopFilled');

const DesktopRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm8 13v2H8v-2h4ZM3 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Z",
    fill: primaryFill
  }));
};

export const DesktopRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopRegularIcon, 'DesktopRegular');

const DesktopArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35A.5.5 0 0 0 17 5.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 5H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2ZM14.5 11c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H13v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H3.5A1.5 1.5 0 0 1 2 13.5v-10C2 2.67 2.67 2 3.5 2h6.76a5.5 5.5 0 0 0 4.24 9ZM12 17v-2H8v2h4Z",
    fill: primaryFill
  }));
};

export const DesktopArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopArrowRightFilledIcon, 'DesktopArrowRightFilled');

const DesktopArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15.35A.5.5 0 0 0 17 5.5a.5.5 0 0 0-.15-.35l-2-2a.5.5 0 0 0-.7.7L15.29 5H12.5a.5.5 0 0 0 0 1h2.8l-1.15 1.15a.5.5 0 0 0 .7.7l2-2ZM17 13v-2.6c.36-.18.7-.4 1-.66V13a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1Zm-5 4v-2H8v2h4Z",
    fill: primaryFill
  }));
};

export const DesktopArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopArrowRightRegularIcon, 'DesktopArrowRightRegular');

const DesktopCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L13.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7ZM14.5 11c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H13v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H3.5A1.5 1.5 0 0 1 2 13.5v-10C2 2.67 2.67 2 3.5 2h6.76a5.5 5.5 0 0 0 4.24 9ZM12 15H8v2h4v-2Z",
    fill: primaryFill
  }));
};

export const DesktopCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopCheckmarkFilledIcon, 'DesktopCheckmarkFilled');

const DesktopCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.85-1.85L13.5 6.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0-.7-.7ZM17 13v-2.6c.36-.18.7-.4 1-.66V13a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1Zm-5 2H8v2h4v-2Z",
    fill: primaryFill
  }));
};

export const DesktopCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopCheckmarkRegularIcon, 'DesktopCheckmarkRegular');

const DesktopCursorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 0 0 0 1H11v-1H8v-2h3v-4.5a1.5 1.5 0 0 1 2.56-1.07l4.4 4.37c.03-.1.04-.2.04-.3v-10c0-.83-.67-1.5-1.5-1.5h-13Zm9.36 8.14a.5.5 0 0 0-.86.36v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84l-6-5.95Z",
    fill: primaryFill
  }));
};

export const DesktopCursorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopCursorFilledIcon, 'DesktopCursorFilled');

const DesktopCursorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 0 0 0 1H11v-1H8v-2h3v-1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8.84l.87.87A2 2 0 0 0 18 13V4a2 2 0 0 0-2-2H4Zm8.86 8.15a.5.5 0 0 0-.86.35v8a.5.5 0 0 0 .9.3l2-2.65 3.5.78a.5.5 0 0 0 .45-.84l-6-5.94Z",
    fill: primaryFill
  }));
};

export const DesktopCursorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopCursorRegularIcon, 'DesktopCursorRegular');

const DesktopEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m10.98 6.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02Zm-.7-.71L13.93 2H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5V6.06l-3.67 3.67c-.4.4-.92.7-1.48.84l-1.5.37a1.89 1.89 0 0 1-2.3-2.29l.38-1.5a3.2 3.2 0 0 1 .84-1.48ZM12 15v2H8v-2h4Z",
    fill: primaryFill
  }));
};

export const DesktopEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopEditFilledIcon, 'DesktopEditFilled');

const DesktopEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m10.98 6.38 4.83-4.83a1.87 1.87 0 1 1 2.64 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02ZM17 13V7.06l1-1V13a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h9.94l-1 1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1Zm-5 2H8v2h4v-2Z",
    fill: primaryFill
  }));
};

export const DesktopEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopEditRegularIcon, 'DesktopEditRegular');

const DesktopFlowFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2.5c0-.18.03-.34.09-.5H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5V7h-2.5a1.5 1.5 0 0 1-1.1-.47l-.25.76A2.5 2.5 0 0 1 12 9v.51c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 6 9.5v-3C6 5.67 6.67 5 7.5 5h3c.43 0 .82.18 1.1.47l.25-.76A2.5 2.5 0 0 1 14 3V2.5ZM12 15v2H8v-2h4Zm3.5-13a.5.5 0 0 0-.5.5V4h-.78a1.5 1.5 0 0 0-1.42 1.03l-.55 1.63a.5.5 0 0 1-.47.34H11v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5V8h.78a1.5 1.5 0 0 0 1.42-1.03l.55-1.63a.5.5 0 0 1 .47-.34H15v.5c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Z",
    fill: primaryFill
  }));
};

export const DesktopFlowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopFlowFilledIcon, 'DesktopFlowFilled');

const DesktopFlowRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.09 2H4a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V7h-1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10v-.5c0-.18.03-.34.09-.5ZM12 17H8v-2h4v2Zm3-14.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V5h-.78a.5.5 0 0 0-.47.34l-.55 1.63A1.5 1.5 0 0 1 11.78 8H11v1.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V7h.78a.5.5 0 0 0 .47-.34l.55-1.63A1.5 1.5 0 0 1 14.22 4H15V2.5ZM10 7H8v2h2V7Zm6-2h2V3h-2v2Z",
    fill: primaryFill
  }));
};

export const DesktopFlowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopFlowRegularIcon, 'DesktopFlowRegular');

const DesktopKeyboardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7.1a2.75 2.75 0 0 0-.75-.1h-5.5A2.75 2.75 0 0 0 9 13.75v3.5c0 .26.04.51.1.75H6.5a.5.5 0 0 1 0-1H8v-2H4a2 2 0 0 1-2-2V4Zm9.75 8c-.97 0-1.75.78-1.75 1.75v3.5c0 .97.78 1.75 1.75 1.75h5.5c.97 0 1.75-.78 1.75-1.75v-3.5c0-.97-.78-1.75-1.75-1.75h-5.5Zm.25 5.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5-3.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-1.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1.5 1.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm.5-1.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z",
    fill: primaryFill
  }));
};

export const DesktopKeyboardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopKeyboardFilledIcon, 'DesktopKeyboardFilled');

const DesktopKeyboardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v7.1c-.24-.06-.49-.1-.75-.1H17V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h5v3.25c0 .26.04.51.1.75H6.5a.5.5 0 0 1 0-1H8v-2H4a2 2 0 0 1-2-2V4Zm9.75 8h5.5c.97 0 1.75.78 1.75 1.75v3.5c0 .97-.78 1.75-1.75 1.75h-5.5c-.97 0-1.75-.78-1.75-1.75v-3.5c0-.97.78-1.75 1.75-1.75Zm.25 5.5c0 .28.22.5.5.5h4a.5.5 0 0 0 0-1h-4a.5.5 0 0 0-.5.5Zm.5-3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5 1.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Zm.5-1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Zm1.5 1.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0Zm.5-1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
    fill: primaryFill
  }));
};

export const DesktopKeyboardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopKeyboardRegularIcon, 'DesktopKeyboardRegular');

const DesktopMacFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h4v1a1 1 0 0 1-1 1h-.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1H13a1 1 0 0 1-1-1v-1h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4ZM3 13v-1h14v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Zm5.73 4A2 2 0 0 0 9 16v-1h2v1c0 .36.1.7.27 1H8.73Z",
    fill: primaryFill
  }));
};

export const DesktopMacFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopMacFilledIcon, 'DesktopMacFilled');

const DesktopMacRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-4v1a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1H7a1 1 0 0 0 1-1v-1H4a2 2 0 0 1-2-2V4Zm1 8v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1H3Zm14-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v7h14Zm-5.73 6a2 2 0 0 1-.27-1v-1H9v1a2 2 0 0 1-.27 1h2.54Z",
    fill: primaryFill
  }));
};

export const DesktopMacRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopMacRegularIcon, 'DesktopMacRegular');

const DesktopPulseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v4h-2.57l-1.09-2.17a1.5 1.5 0 0 0-2.68 0L10.32 8.5 8.93 4.05a1.5 1.5 0 0 0-2.82-.1L4.49 8H2V4Zm12.5 7H18v2a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2v-2h3.5a1.5 1.5 0 0 0 1.4-.94l.43-1.09 1.24 3.98a1.5 1.5 0 0 0 2.77.22L13 9.85l.16.32c.25.5.77.83 1.34.83ZM12 17v-2H8v2h4ZM7.98 4.35a.5.5 0 0 0-.94-.04L5.16 9H2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .47-.31l1.47-3.7 2.08 6.66a.5.5 0 0 0 .93.07L13 7.62l1.05 2.1a.5.5 0 0 0 .45.28h3a.5.5 0 0 0 0-1h-2.7l-1.35-2.72a.5.5 0 0 0-.9 0l-2.44 4.89-2.13-6.82Z",
    fill: primaryFill
  }));
};

export const DesktopPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopPulseFilledIcon, 'DesktopPulseFilled');

const DesktopPulseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v4h1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4h1V4a2 2 0 0 0-2-2H4ZM2 13v-2h1v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2h1v2a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2Zm10 2H8v2h4v-2ZM7.98 4.35a.5.5 0 0 0-.94-.04L5.16 9H2.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .46-.31l1.48-3.7 2.08 6.66a.5.5 0 0 0 .93.07L13 7.62l1.05 2.1a.5.5 0 0 0 .45.28h3a.5.5 0 1 0 0-1h-2.7l-1.35-2.72a.5.5 0 0 0-.9 0l-2.44 4.89-2.13-6.82Z",
    fill: primaryFill
  }));
};

export const DesktopPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopPulseRegularIcon, 'DesktopPulseRegular');

const DesktopSignalFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 1c-.18 0-.36 0-.54.02a.5.5 0 1 0 .08 1L12 2a6 6 0 0 1 5.98 6.46.5.5 0 1 0 1 .08L19 8a7 7 0 0 0-7-7Zm0 2c-.19 0-.37.01-.55.03a.5.5 0 0 0 .1 1L12 4a4 4 0 0 1 3.98 4.45.5.5 0 1 0 .99.1A5 5 0 0 0 12 3Zm0 2c-.2 0-.4.02-.6.06a.5.5 0 0 0 .2.98A2.01 2.01 0 0 1 14 8c0 .14-.01.27-.04.4a.5.5 0 0 0 .98.2A3.01 3.01 0 0 0 12 5Zm-1.92-3H3.5C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 1 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3.5c.83 0 1.5-.67 1.5-1.5V9.92a1.5 1.5 0 0 1-.52-.3 1.5 1.5 0 0 1-2.02-.01 1.5 1.5 0 0 1-2.13-.11 2 2 0 0 1-2.82-2.82 1.5 1.5 0 0 1-.12-2.14 1.5 1.5 0 0 1 0-2.02 1.5 1.5 0 0 1-.31-.52ZM12 15v2H8v-2h4Zm1-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: primaryFill
  }));
};

export const DesktopSignalFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSignalFilledIcon, 'DesktopSignalFilled');

const DesktopSignalRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 1c-.18 0-.36 0-.54.02a.5.5 0 1 0 .08 1L12 2a6 6 0 0 1 5.98 6.46.5.5 0 1 0 1 .08L19 8a7 7 0 0 0-7-7Zm0 2c-.19 0-.37.01-.55.03a.5.5 0 0 0 .1 1L12 4a4 4 0 0 1 3.98 4.45.5.5 0 1 0 .99.1A5 5 0 0 0 12 3Zm0 2c-.2 0-.4.02-.6.06a.5.5 0 0 0 .2.98A2.01 2.01 0 0 1 14 8c0 .14-.01.27-.04.4a.5.5 0 0 0 .98.2A3.01 3.01 0 0 0 12 5Zm-1.92-3H4a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 1 0 0 1h9a.5.5 0 0 0 0-1H13v-2h3a2 2 0 0 0 2-2V9.92a1.5 1.5 0 0 1-.52-.3c-.14.12-.3.22-.48.28V13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6.1c.06-.18.16-.34.29-.48a1.5 1.5 0 0 1-.31-.52ZM12 15v2H8v-2h4Zm1-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: primaryFill
  }));
};

export const DesktopSignalRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSignalRegularIcon, 'DesktopSignalRegular');

const DesktopSpeakerFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 0 0 0 1h6.38l-1-1H8v-2h1v-1.5c0-.83.67-1.5 1.5-1.5h.38l1.56-1.56a1.5 1.5 0 0 1 2.5.67c.3-.12.6-.14.88-.07A1.5 1.5 0 0 1 18 10.2V3.5c0-.83-.67-1.5-1.5-1.5h-13Zm10.2 9.04c.18.08.3.26.3.46v6a.5.5 0 0 1-.85.35L11.29 16h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11Zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 0 1-.85-.52l.12-.19a5.9 5.9 0 0 0 .58-2.6 5.9 5.9 0 0 0-.58-2.58l-.07-.11a.5.5 0 0 1 .8-.6Zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 1 0-.9.45 4.6 4.6 0 0 1 .45 1.78 3.94 3.94 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22c0-.5-.1-1.02-.28-1.53Z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerFilledIcon, 'DesktopSpeakerFilled');

const DesktopSpeakerRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 0 0 0 1h6.38l-1-1H8v-2h1v-1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.02c.34-.06.7 0 1 .18V4a2 2 0 0 0-2-2H4Zm9.7 9.04c.18.08.3.26.3.46v6a.5.5 0 0 1-.85.35L11.29 16h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l1.85-1.85a.5.5 0 0 1 .54-.11Zm3.95.16c.12.16.29.45.44.87.26.68.41 1.5.41 2.43 0 .94-.15 1.75-.4 2.43-.16.42-.33.7-.45.87a.5.5 0 0 1-.85-.52l.12-.19a5.9 5.9 0 0 0 .58-2.6 5.9 5.9 0 0 0-.58-2.58l-.07-.11a.5.5 0 0 1 .8-.6Zm-1.43 1.77c-.1-.3-.2-.55-.27-.7a.5.5 0 1 0-.9.45 4.6 4.6 0 0 1 .45 1.78 3.94 3.94 0 0 1-.37 1.6l-.08.18a.5.5 0 1 0 .9.44 5.5 5.5 0 0 0 .55-2.22c0-.5-.1-1.02-.28-1.53Z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerRegularIcon, 'DesktopSpeakerRegular');

const DesktopSpeakerOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.15 2.85a.5.5 0 0 1 .7-.7l15 15a.5.5 0 0 1-.7.7L14 14.71v2.79a.5.5 0 0 1-.85.35L11.29 16h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l.5-.5-.71-.7-.21.2h-.38c-.83 0-1.5.67-1.5 1.5V15H8v2h2.88l1 1H5.5a.5.5 0 0 1 0-1H7v-2H3.5A1.5 1.5 0 0 1 2 13.5v-10c0-.23.05-.45.15-.65ZM18.5 14.5a7.4 7.4 0 0 1-.19 1.7l-.86-.87a6.95 6.95 0 0 0-.3-2.9c-.08-.24-.17-.41-.23-.52l-.07-.11a.5.5 0 0 1 .8-.6c.12.16.29.45.44.87.26.68.41 1.5.41 2.43Zm-2.28-1.53c.16.47.26.95.28 1.4l-1.3-1.29a3.95 3.95 0 0 0-.15-.36.5.5 0 1 1 .9-.44c.07.14.17.38.27.69Zm-2.15-2.86a1.5 1.5 0 0 0-1.57.27L4.12 2H16.5c.83 0 1.5.67 1.5 1.5v6.7a1.5 1.5 0 0 0-2.18.84 1.5 1.5 0 0 0-.87.07 1.5 1.5 0 0 0-.88-1Z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerOffFilledIcon, 'DesktopSpeakerOffFilled');

const DesktopSpeakerOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4a2 2 0 0 1 .28-1.02l-.13-.13a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7L14 14.71v2.79a.5.5 0 0 1-.85.35L11.29 16h-.79a.5.5 0 0 1-.5-.5v-2c0-.28.22-.5.5-.5h.8l.5-.5-8.77-8.76A1 1 0 0 0 3 4v9a1 1 0 0 0 1 1h5v1H8v2h2.88l1 1H5.5a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2V4Zm16.5 10.5a7.4 7.4 0 0 1-.19 1.7l-.86-.87a6.95 6.95 0 0 0-.3-2.9c-.08-.24-.17-.41-.23-.52l-.07-.11a.5.5 0 0 1 .8-.6c.12.16.29.45.44.87.26.68.41 1.5.41 2.43Zm-2.28-1.53c.16.47.26.95.28 1.4l-1.3-1.29a3.95 3.95 0 0 0-.15-.36.5.5 0 1 1 .9-.44c.07.14.17.38.27.69ZM16 3H5.12l-1-1H16a2 2 0 0 1 2 2v6.2a1.5 1.5 0 0 0-1-.18V4a1 1 0 0 0-1-1Z",
    fill: primaryFill
  }));
};

export const DesktopSpeakerOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSpeakerOffRegularIcon, 'DesktopSpeakerOffRegular');

const DesktopSyncFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.98 1.98 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 1 1-.71-.71A3 3 0 0 1 16 3.15V3c0-.28.22-.5.5-.5Zm-.88 5.53A3 3 0 0 1 13 7.85V8a.5.5 0 0 1-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.98 1.98 0 0 0 1.72.1 2 2 0 0 0 .66-.44.5.5 0 1 1 .71.71 3 3 0 0 1-1 .66ZM14.5 11c1.33 0 2.55-.47 3.5-1.26v3.76c0 .83-.67 1.5-1.5 1.5H13v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H3.5A1.5 1.5 0 0 1 2 13.5v-10C2 2.67 2.67 2 3.5 2h6.76a5.5 5.5 0 0 0 4.24 9ZM12 15H8v2h4v-2Z",
    fill: primaryFill
  }));
};

export const DesktopSyncFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSyncFilledIcon, 'DesktopSyncFilled');

const DesktopSyncRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-.5.5H15a.5.5 0 0 1 0-1h.47a1.98 1.98 0 0 0-1.72-.1 2 2 0 0 0-.66.44.5.5 0 1 1-.71-.71A3 3 0 0 1 16 3.15V3c0-.28.22-.5.5-.5Zm-.88 5.53A3 3 0 0 1 13 7.85V8a.5.5 0 0 1-1 0V6.5c0-.28.22-.5.5-.5H14a.5.5 0 0 1 0 1h-.47a1.98 1.98 0 0 0 1.72.1 2 2 0 0 0 .66-.44.5.5 0 1 1 .71.71 3 3 0 0 1-1 .66ZM17 13v-2.6c.36-.18.7-.4 1-.66V13a2 2 0 0 1-2 2h-3v2h1.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H4a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h6.26c-.26.3-.48.64-.66 1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1Zm-5 2H8v2h4v-2Z",
    fill: primaryFill
  }));
};

export const DesktopSyncRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopSyncRegularIcon, 'DesktopSyncRegular');

const DesktopToolboxFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2C2.67 2 2 2.67 2 3.5v10c0 .83.67 1.5 1.5 1.5H7v2H5.5a.5.5 0 0 0 0 1h3.55a2.51 2.51 0 0 1-.05-.5V17H8v-2h1v-1.5a2.5 2.5 0 0 1 2.04-2.46A2.5 2.5 0 0 1 13.5 9h2a2.5 2.5 0 0 1 2.46 2.04l.04.01V3.5c0-.83-.67-1.5-1.5-1.5h-13ZM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const DesktopToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopToolboxFilledIcon, 'DesktopToolboxFilled');

const DesktopToolboxRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 2a2 2 0 0 0-2 2v9c0 1.1.9 2 2 2h3v2H5.5a.5.5 0 0 0 0 1h3.55a2.51 2.51 0 0 1-.05-.5V17H8v-2h1v-1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v5.5c.5.37.84.91.96 1.54l.04.01V4a2 2 0 0 0-2-2H4Zm8 10v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const DesktopToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DesktopToolboxRegularIcon, 'DesktopToolboxRegular');

const DeveloperBoardFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8V2.5Zm5 7.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardFilledIcon, 'DeveloperBoardFilled');

const DeveloperBoardRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-2 3a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-.5-8c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 0 1 1 0V4H12V2.5a.5.5 0 0 1 1 0V4h.5A2.5 2.5 0 0 1 16 6.5V7h1.5a.5.5 0 0 1 0 1H16v1.5h1.5a.5.5 0 0 1 0 1H16V12h1.5a.5.5 0 0 1 0 1H16v.5a2.5 2.5 0 0 1-2.5 2.5H13v1.5a.5.5 0 0 1-1 0V16h-1.5v1.5a.5.5 0 0 1-1 0V16H8v1.5a.5.5 0 0 1-1 0V16h-.5A2.5 2.5 0 0 1 4 13.5V13H2.5a.5.5 0 0 1 0-1H4v-1.5H2.5a.5.5 0 0 1 0-1H4V8H2.5a.5.5 0 0 1 0-1H4v-.5A2.5 2.5 0 0 1 6.5 4H7V2.5c0-.28.22-.5.5-.5ZM15 6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardRegularIcon, 'DeveloperBoardRegular');

const DeveloperBoardLightningFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8V2.5Zm2.99 5.04L10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningFilledIcon, 'DeveloperBoardLightningFilled');

const DeveloperBoardLightningRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.99 7.54 10.57 9h1.53c.34 0 .52.4.3.66l-2.65 3.19c-.3.35-.86.05-.73-.4L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39ZM8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1.5v1.5a.5.5 0 0 0 1 0V16H12v1.5a.5.5 0 0 0 1 0V16h.5a2.5 2.5 0 0 0 2.5-2.5V13h1.5a.5.5 0 0 0 0-1H16v-1.5h1.5a.5.5 0 0 0 0-1H16V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8V2.5ZM13.5 5c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 13.5v-7C5 5.67 5.67 5 6.5 5h7Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningRegularIcon, 'DeveloperBoardLightningRegular');

const DeveloperBoardLightningToolboxFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 2.5a.5.5 0 0 0-1 0V4h-.5A2.5 2.5 0 0 0 4 6.5V7H2.5a.5.5 0 0 0 0 1H4v1.5H2.5a.5.5 0 0 0 0 1H4V12H2.5a.5.5 0 0 0 0 1H4v.5A2.5 2.5 0 0 0 6.5 16H7v1.5a.5.5 0 0 0 1 0V16h1v-2.5c0-.23.03-.45.09-.67a.4.4 0 0 1-.07-.37L9.46 11H7.9a.4.4 0 0 1-.3-.66l2.66-3.19c.3-.34.85-.05.73.39L10.57 9h1.53c.17 0 .3.1.36.23.32-.15.67-.23 1.04-.23h2c.17 0 .34.02.5.05V8h1.5a.5.5 0 0 0 0-1H16v-.5A2.5 2.5 0 0 0 13.5 4H13V2.5a.5.5 0 0 0-1 0V4h-1.5V2.5a.5.5 0 0 0-1 0V4H8V2.5Zm4 9.5v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningToolboxFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningToolboxFilledIcon, 'DeveloperBoardLightningToolboxFilled');

const DeveloperBoardLightningToolboxRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 2c.28 0 .5.22.5.5V4h1.5V2.5a.5.5 0 0 1 1 0V4H12V2.5a.5.5 0 0 1 1 0V4h.5A2.5 2.5 0 0 1 16 6.5V7h1.5a.5.5 0 0 1 0 1H16v1.05a2.51 2.51 0 0 0-.5-.05H15V6.5c0-.83-.67-1.5-1.5-1.5h-7C5.67 5 5 5.67 5 6.5v7c0 .83.67 1.5 1.5 1.5H9v1H8v1.5a.5.5 0 0 1-1 0V16h-.5A2.5 2.5 0 0 1 4 13.5V13H2.5a.5.5 0 0 1 0-1H4v-1.5H2.5a.5.5 0 0 1 0-1H4V8H2.5a.5.5 0 0 1 0-1H4v-.5A2.5 2.5 0 0 1 6.5 4H7V2.5c0-.28.22-.5.5-.5Zm3.54 9.04a2.5 2.5 0 0 1 1.42-1.81.4.4 0 0 0-.36-.23h-1.53l.42-1.46c.12-.44-.44-.73-.73-.39l-2.67 3.2a.4.4 0 0 0 .3.65h1.57l-.44 1.46a.4.4 0 0 0 .07.37 2.5 2.5 0 0 1 1.95-1.79ZM12 12v-.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v.5h.5c.83 0 1.5.67 1.5 1.5V15h-2v-.5a.5.5 0 0 0-1 0v.5h-3v-.5a.5.5 0 0 0-1 0v.5h-2v-1.5c0-.83.67-1.5 1.5-1.5h.5Zm1-.5v.5h3v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5Zm4 5V16h2v1.5c0 .83-.67 1.5-1.5 1.5h-6a1.5 1.5 0 0 1-1.5-1.5V16h2v.5a.5.5 0 0 0 1 0V16h3v.5a.5.5 0 0 0 1 0Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardLightningToolboxRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardLightningToolboxRegularIcon, 'DeveloperBoardLightningToolboxRegular');

const DeveloperBoardSearchFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8.5 1c.28 0 .5.22.5.5V3h1.5V1.5a.5.5 0 0 1 1 0V3H13V1.5a.5.5 0 0 1 1 0V3h.5A2.5 2.5 0 0 1 17 5.5V6h1.5a.5.5 0 0 1 0 1H17v1.5h1.5a.5.5 0 0 1 0 1H17V11h1.5a.5.5 0 0 1 0 1H17v.5a2.5 2.5 0 0 1-2.5 2.5H14v1.5a.5.5 0 0 1-1 0V15h-1.5v1.5a.5.5 0 0 1-1 0V15H8.74a4.5 4.5 0 0 0-5.68-5.76.5.5 0 0 1 .44-.74H5V7H3.5a.5.5 0 0 1 0-1H5v-.5A2.5 2.5 0 0 1 7.5 3H8V1.5c0-.28.22-.5.5-.5ZM11 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-6.5 5c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 0 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardSearchFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardSearchFilledIcon, 'DeveloperBoardSearchFilled');

const DeveloperBoardSearchRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM9 1.5a.5.5 0 0 0-1 0V3h-.5A2.5 2.5 0 0 0 5 5.5V6H3.5a.5.5 0 0 0 0 1H5v1.5H3.5a.5.5 0 0 0-.44.74A4.5 4.5 0 0 1 6 9.26V5.5C6 4.67 6.67 4 7.5 4h7c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H8.97c-.04.35-.11.68-.23 1h1.76v1.5a.5.5 0 0 0 1 0V15H13v1.5a.5.5 0 0 0 1 0V15h.5a2.5 2.5 0 0 0 2.5-2.5V12h1.5a.5.5 0 0 0 0-1H17V9.5h1.5a.5.5 0 0 0 0-1H17V7h1.5a.5.5 0 0 0 0-1H17v-.5A2.5 2.5 0 0 0 14.5 3H14V1.5a.5.5 0 0 0-1 0V3h-1.5V1.5a.5.5 0 0 0-1 0V3H9V1.5ZM4.5 17c.79 0 1.51-.26 2.1-.7l2.55 2.55a.5.5 0 0 0 .7-.7L7.3 15.6A3.5 3.5 0 1 0 4.5 17Zm0-1a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Z",
    fill: primaryFill
  }));
};

export const DeveloperBoardSearchRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeveloperBoardSearchRegularIcon, 'DeveloperBoardSearchRegular');

const DeviceEqFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c.41 0 .75.34.75.75v14.5a.75.75 0 0 1-1.5 0V2.75c0-.41.34-.75.75-.75Zm3.75 3c.41 0 .75.34.75.75v8.5a.75.75 0 0 1-1.5 0v-8.5c0-.41.34-.75.75-.75ZM7 5.75a.75.75 0 0 0-1.5 0v8.5a.75.75 0 0 0 1.5 0v-8.5ZM17.25 8c.41 0 .75.34.75.75v2.5a.75.75 0 0 1-1.5 0v-2.5c0-.41.34-.75.75-.75ZM3.5 8.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0v-2.5Z",
    fill: primaryFill
  }));
};

export const DeviceEqFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceEqFilledIcon, 'DeviceEqFilled');

const DeviceEqRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2c.28 0 .5.22.5.5v15a.5.5 0 0 1-1 0v-15c0-.28.22-.5.5-.5Zm3.5 3c.28 0 .5.22.5.5v9a.5.5 0 0 1-1 0v-9c0-.28.22-.5.5-.5ZM7 5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0v-9ZM16.5 8c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5ZM4 8.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Z",
    fill: primaryFill
  }));
};

export const DeviceEqRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceEqRegularIcon, 'DeviceEqRegular');

const DeviceMeetingRoomFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H4.5a2.5 2.5 0 0 1-2.43-3.05l1.59-7ZM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 1 0 0-1h-9Z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomFilledIcon, 'DeviceMeetingRoomFilled');

const DeviceMeetingRoomRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.1 3a2.5 2.5 0 0 0-2.44 1.95l-1.6 7A2.5 2.5 0 0 0 4.5 15h11a2.5 2.5 0 0 0 2.43-3.05l-1.59-7A2.5 2.5 0 0 0 13.9 3H6.1ZM4.63 5.17A1.5 1.5 0 0 1 6.1 4h7.8c.7 0 1.31.48 1.47 1.17l1.59 7A1.5 1.5 0 0 1 15.49 14H4.5a1.5 1.5 0 0 1-1.46-1.83l1.6-7ZM5.5 16a.5.5 0 0 0 0 1h9a.5.5 0 1 0 0-1h-9Z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomRegularIcon, 'DeviceMeetingRoomRegular');

const DeviceMeetingRoomRemoteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H9V9.5A2.5 2.5 0 0 0 6.5 7h-3c-.1 0-.21 0-.31.02l.47-2.07ZM9 16.5c0 .17-.02.34-.05.5h5.55a.5.5 0 0 0 0-1H9v.5ZM5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5v-7ZM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-3Z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomRemoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomRemoteFilledIcon, 'DeviceMeetingRoomRemoteFilled');

const DeviceMeetingRoomRemoteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.66 4.95A2.5 2.5 0 0 1 6.1 3h7.8c1.17 0 2.18.8 2.44 1.95l1.6 7A2.5 2.5 0 0 1 15.48 15H9v-1h6.5c.96 0 1.67-.9 1.46-1.83l-1.6-7A1.5 1.5 0 0 0 13.9 4H6.1c-.7 0-1.31.48-1.47 1.17L4.22 7H3.5c-.1 0-.21 0-.31.02l.47-2.07ZM8.95 17h5.55a.5.5 0 0 0 0-1H9v.5c0 .17-.02.34-.05.5ZM5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM2 9.5C2 8.67 2.67 8 3.5 8h3C7.33 8 8 8.67 8 9.5v7c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 2 16.5v-7ZM3.5 9a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-3Z",
    fill: primaryFill
  }));
};

export const DeviceMeetingRoomRemoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DeviceMeetingRoomRemoteRegularIcon, 'DeviceMeetingRoomRemoteRegular');

const DiagramFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03c.36.06.7.2 1 .4V5a3 3 0 0 0-3-3H5Zm.5 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM5 8.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM6.5 11a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42H6.5Z",
    fill: primaryFill
  }));
};

export const DiagramFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiagramFilledIcon, 'DiagramFilled');

const DiagramRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h.82l.9-1H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5.03c.36.06.7.2 1 .4V5a3 3 0 0 0-3-3H5Zm1.5 9a.5.5 0 0 0-.37.83L8.94 15l-2.81 3.17a.5.5 0 0 0 .37.83h8.1c.38 0 .76-.15 1.04-.42l3.13-3.04c.3-.3.3-.78 0-1.08l-3.13-3.04a1.5 1.5 0 0 0-1.05-.42H6.5Zm3.34 3.5L7.6 12h6.98a.5.5 0 0 1 .35.14L17.9 15l-2.95 2.86a.5.5 0 0 1-.35.14H7.61l2.23-2.5a.75.75 0 0 0 0-1ZM5 5.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5.5 8a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z",
    fill: primaryFill
  }));
};

export const DiagramRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiagramRegularIcon, 'DiagramRegular');

const DialpadFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm0 4a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM7.25 12a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM14 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
    fill: primaryFill
  }));
};

export const DialpadFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadFilledIcon, 'DialpadFilled');

const DialpadRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    fill: primaryFill
  }));
};

export const DialpadRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadRegularIcon, 'DialpadRegular');

const DialpadOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l3.9 3.9H6a1.25 1.25 0 1 0 1.25 1.2l2.8 2.8H10a1.25 1.25 0 1 0 1.25 1.2l5.9 5.9a.5.5 0 0 0 .7-.7l-15-15ZM15.25 12c0 .31-.12.6-.3.82l-1.77-1.76a1.25 1.25 0 0 1 2.07.94Zm-4-4c0 .31-.12.6-.3.82L9.17 7.06a1.25 1.25 0 0 1 2.07.94Zm-4-4c0 .31-.12.6-.3.82L5.17 3.06A1.25 1.25 0 0 1 7.25 4Zm0 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM10 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM11.25 16a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM14 5.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM15.25 8a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
    fill: primaryFill
  }));
};

export const DialpadOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadOffFilledIcon, 'DialpadOffFilled');

const DialpadOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 1 0-.7.7l4.2 4.22A1 1 0 0 0 5 8a1 1 0 1 0 1.93-.36l3.43 3.43a1 1 0 1 0 .57.57l6.22 6.21a.5.5 0 0 0 .7-.7l-15-15ZM15 12a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 15 12Zm-4-4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 11 8ZM7 4a1 1 0 0 1-.23.64l-1.41-1.4A1 1 0 0 1 7 4Zm0 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3-11a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm1 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: primaryFill
  }));
};

export const DialpadOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DialpadOffRegularIcon, 'DialpadOffRegular');

const DiamondFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.59 11.41a2 2 0 0 1 0-2.82l6-6a2 2 0 0 1 2.83 0l6 6a2 2 0 0 1 0 2.82l-6 6a2 2 0 0 1-2.83 0l-6-6Z",
    fill: primaryFill
  }));
};

export const DiamondFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiamondFilledIcon, 'DiamondFilled');

const DiamondRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.59 11.41a2 2 0 0 1 0-2.82l6-6a2 2 0 0 1 2.83 0l6 6a2 2 0 0 1 0 2.82l-6 6a2 2 0 0 1-2.83 0l-6-6Zm.7-2.12a1 1 0 0 0 0 1.42l6 6a1 1 0 0 0 1.42 0l6-6a1 1 0 0 0 0-1.42l-6-6a1 1 0 0 0-1.42 0l-6 6Z",
    fill: primaryFill
  }));
};

export const DiamondRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiamondRegularIcon, 'DiamondRegular');

const DirectionsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.77 3.06a2.5 2.5 0 0 0-3.54 0L3.06 8.23a2.5 2.5 0 0 0 0 3.54l5.17 5.17a2.5 2.5 0 0 0 3.54 0l5.17-5.17a2.5 2.5 0 0 0 0-3.54l-5.17-5.17Zm-1.12 3.09c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65h-.79C9.67 8.5 9 9.17 9 10v2.5a.5.5 0 0 1-1 0V10a2.5 2.5 0 0 1 2.5-2.5h.8l-.65-.65a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const DirectionsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DirectionsFilledIcon, 'DirectionsFilled');

const DirectionsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 8.5C9.67 8.5 9 9.17 9 10v2.5a.5.5 0 1 1-1 0V10a2.5 2.5 0 0 1 2.5-2.5h.8l-.65-.65a.5.5 0 0 1 .7-.7l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 1 1-.7-.7l.64-.65h-.79ZM8.23 3.06a2.5 2.5 0 0 1 3.54 0l5.17 5.17a2.5 2.5 0 0 1 0 3.54l-5.17 5.17a2.5 2.5 0 0 1-3.54 0l-5.17-5.17a2.5 2.5 0 0 1 0-3.54l5.17-5.17Zm2.83.7a1.5 1.5 0 0 0-2.12 0L3.77 8.95a1.5 1.5 0 0 0 0 2.12l5.17 5.17a1.5 1.5 0 0 0 2.12 0l5.17-5.17a1.5 1.5 0 0 0 0-2.12l-5.17-5.17Z",
    fill: primaryFill
  }));
};

export const DirectionsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DirectionsRegularIcon, 'DirectionsRegular');

const DishwasherFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v2h14V6a3 3 0 0 0-3-3H6Zm8 14H6.91a1.5 1.5 0 0 0-.91-.91v-1.43a3.5 3.5 0 0 0 2-3.16v-2c0-.17-.03-.34-.09-.5H17v5a3 3 0 0 1-3 3ZM6.75 6.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM10 5.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5h-4Z",
    fill: primaryFill
  }));
};

export const DishwasherFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DishwasherFilledIcon, 'DishwasherFilled');

const DishwasherRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 0 0-3 3v2h13v6a2 2 0 0 1-2 2H6v.09c.43.15.76.48.91.91H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm10 3v1H4V6c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2Zm-8.5-.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.5 0c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5ZM2.5 9a.5.5 0 0 0-.5.5v2a2.5 2.5 0 0 0 2 2.45V17h-.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H5v-3.05a2.5 2.5 0 0 0 2-2.45v-2a.5.5 0 0 0-.5-.5h-4Z",
    fill: primaryFill
  }));
};

export const DishwasherRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DishwasherRegularIcon, 'DishwasherRegular');

const DismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m3.9 4.05.07-.08a.75.75 0 0 1 .98-.07l.08.07L10 8.94l4.97-4.97a.75.75 0 0 1 .98-.07l.08.07c.27.27.3.68.07.98l-.07.08L11.06 10l4.97 4.97c.27.27.3.68.07.98l-.07.08a.75.75 0 0 1-.98.07l-.08-.07L10 11.06l-4.97 4.97a.75.75 0 0 1-.98.07l-.08-.07a.75.75 0 0 1-.07-.98l.07-.08L8.94 10 3.97 5.03a.75.75 0 0 1-.07-.98l.07-.08-.07.08Z",
    fill: primaryFill
  }));
};

export const DismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissFilledIcon, 'DismissFilled');

const DismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z",
    fill: primaryFill
  }));
};

export const DismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissRegularIcon, 'DismissRegular');

const DismissCircleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16ZM7.8 7.11a.5.5 0 0 0-.63.06l-.06.07a.5.5 0 0 0 .06.64L9.3 10l-2.12 2.12-.06.07a.5.5 0 0 0 .06.64l.07.06c.2.13.47.11.64-.06L10 10.7l2.12 2.12.07.06c.2.13.46.11.64-.06l.06-.07a.5.5 0 0 0-.06-.64L10.7 10l2.12-2.12.06-.07a.5.5 0 0 0-.06-.64l-.07-.06a.5.5 0 0 0-.64.06L10 9.3 7.88 7.17l-.07-.06Z",
    fill: primaryFill
  }));
};

export const DismissCircleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissCircleFilledIcon, 'DismissCircleFilled');

const DismissCircleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14ZM7.8 7.11l.08.06L10 9.3l2.12-2.12a.5.5 0 0 1 .64-.06l.07.06c.17.18.2.44.06.64l-.06.07L10.7 10l2.12 2.12c.17.17.2.44.06.64l-.06.07a.5.5 0 0 1-.64.06l-.07-.06L10 10.7l-2.12 2.12a.5.5 0 0 1-.64.06l-.07-.06a.5.5 0 0 1-.06-.64l.06-.07L9.3 10 7.17 7.88a.5.5 0 0 1-.06-.64l.06-.07a.5.5 0 0 1 .64-.06Z",
    fill: primaryFill
  }));
};

export const DismissCircleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissCircleRegularIcon, 'DismissCircleRegular');

const DismissSquareFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm4.15 1.15a.5.5 0 0 0 0 .7L9.29 10l-2.14 2.15a.5.5 0 0 0 .7.7L10 10.71l2.15 2.14a.5.5 0 0 0 .7-.7L10.71 10l2.14-2.15a.5.5 0 0 0-.7-.7L10 9.29 7.85 7.15a.5.5 0 0 0-.7 0Z",
    fill: primaryFill
  }));
};

export const DismissSquareFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareFilledIcon, 'DismissSquareFilled');

const DismissSquareRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.15 7.15c.2-.2.5-.2.7 0L10 9.29l2.15-2.14a.5.5 0 0 1 .7.7L10.71 10l2.14 2.15a.5.5 0 0 1-.7.7L10 10.71l-2.15 2.14a.5.5 0 0 1-.7-.7L9.29 10 7.15 7.85a.5.5 0 0 1 0-.7ZM3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm3-2a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6Z",
    fill: primaryFill
  }));
};

export const DismissSquareRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareRegularIcon, 'DismissSquareRegular');

const DismissSquareMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5v-7Zm3.15.65a.5.5 0 0 0 0 .7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29 6.85 6.15a.5.5 0 0 0-.7 0ZM5.5 16c.46.6 1.18 1 2 1h5a4.5 4.5 0 0 0 4.5-4.5v-5c0-.82-.4-1.54-1-2v7a3.5 3.5 0 0 1-3.5 3.5h-7Z",
    fill: primaryFill
  }));
};

export const DismissSquareMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareMultipleFilledIcon, 'DismissSquareMultipleFilled');

const DismissSquareMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 5.5A2.5 2.5 0 0 1 5.5 3h7A2.5 2.5 0 0 1 15 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 3 12.5v-7ZM5.5 4C4.67 4 4 4.67 4 5.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-7Zm2 13a2.5 2.5 0 0 1-2-1h7a3.5 3.5 0 0 0 3.5-3.5v-7c.6.46 1 1.18 1 2v5a4.5 4.5 0 0 1-4.5 4.5h-5ZM6.85 6.15a.5.5 0 1 0-.7.7L8.29 9l-2.14 2.15a.5.5 0 0 0 .7.7L9 9.71l2.15 2.14a.5.5 0 0 0 .7-.7L9.71 9l2.14-2.15a.5.5 0 0 0-.7-.7L9 8.29 6.85 6.15Z",
    fill: primaryFill
  }));
};

export const DismissSquareMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DismissSquareMultipleRegularIcon, 'DismissSquareMultipleRegular');

const DiversityFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.74 16.45A2.99 2.99 0 0 1 6 17a3 3 0 0 1-2.45-4.74l4.19 4.19Zm5.9-5.36-2.23 1.15a.75.75 0 0 0-.41.66v2.2c0 .28.16.53.41.66l2.23 1.15c.23.12.5.12.72 0l2.23-1.15a.75.75 0 0 0 .41-.66v-2.2a.75.75 0 0 0-.41-.66l-2.23-1.15a.79.79 0 0 0-.72 0Zm-5.2 4.65A2.99 2.99 0 0 0 9 14a3 3 0 0 0-4.74-2.45l4.19 4.19ZM13 3a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2Zm-8.09.67c.45-.9 1.73-.9 2.18 0l1.78 3.54c.4.82-.18 1.79-1.1 1.79H4.23c-.9 0-1.5-.97-1.09-1.79l1.78-3.54Z",
    fill: primaryFill
  }));
};

export const DiversityFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiversityFilledIcon, 'DiversityFilled');

const DiversityRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 5c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V5ZM4.91 3.67c.45-.9 1.73-.9 2.18 0l1.78 3.54c.4.82-.18 1.79-1.1 1.79H4.23c-.9 0-1.5-.97-1.09-1.79l1.78-3.54Zm1.28.45a.21.21 0 0 0-.38 0L4.03 7.66c-.09.17.04.34.2.34h3.55c.15 0 .28-.17.2-.34L6.18 4.12ZM9 14a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-1 0a2 2 0 0 0-3.02-1.72l2.74 2.74A2 2 0 0 0 8 14Zm-2 2a2 2 0 0 0 1.02-.28l-2.74-2.74A2 2 0 0 0 6 16Zm7.64-4.91c.23-.12.5-.12.72 0l2.23 1.15c.25.13.41.38.41.66v2.2c0 .28-.16.53-.41.66l-2.23 1.15a.79.79 0 0 1-.72 0l-2.23-1.15a.75.75 0 0 1-.41-.66v-2.2c0-.28.16-.53.41-.66l2.23-1.15ZM12 13.06v1.88l2 1.03 2-1.03v-1.88l-2-1.03-2 1.03Z",
    fill: primaryFill
  }));
};

export const DiversityRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DiversityRegularIcon, 'DiversityRegular');

const DividerShortFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 3c.41 0 .75.34.75.75v12.5a.75.75 0 0 1-1.5 0V3.75c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const DividerShortFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerShortFilledIcon, 'DividerShortFilled');

const DividerShortRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 3c.28 0 .5.22.5.5v13a.5.5 0 0 1-1 0v-13c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DividerShortRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerShortRegularIcon, 'DividerShortRegular');

const DividerTallFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 1c.41 0 .75.34.75.75v16.5a.75.75 0 0 1-1.5 0V1.75c0-.41.34-.75.75-.75Z",
    fill: primaryFill
  }));
};

export const DividerTallFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerTallFilledIcon, 'DividerTallFilled');

const DividerTallRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 1c.28 0 .5.22.5.5v17a.5.5 0 0 1-1 0v-17c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DividerTallRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DividerTallRegularIcon, 'DividerTallRegular');

const DockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.53 3.22a.75.75 0 0 0-1.06 0l-2.5 2.5a.75.75 0 0 0 1.06 1.06l1.22-1.22v6.69a.75.75 0 0 0 1.5 0V5.56l1.22 1.22a.75.75 0 1 0 1.06-1.06l-2.5-2.5ZM3.5 10.5a1 1 0 0 1 1-1h2.75a.75.75 0 0 0 0-1.5H4.5A2.5 2.5 0 0 0 2 10.5v3A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 15.5 8h-2.75a.75.75 0 0 0 0 1.5h2.75a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-3Z",
    fill: primaryFill
  }));
};

export const DockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockFilledIcon, 'DockFilled');

const DockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.35 3.15a.5.5 0 0 0-.7 0l-3 3a.5.5 0 1 0 .7.7L9.5 4.71v7.79a.5.5 0 0 0 1 0V4.7l2.15 2.15a.5.5 0 0 0 .7-.7l-3-3ZM3 10.5C3 9.67 3.67 9 4.5 9h3a.5.5 0 0 0 0-1h-3A2.5 2.5 0 0 0 2 10.5v3A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-3A2.5 2.5 0 0 0 15.5 8h-3a.5.5 0 0 0 0 1h3c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-3Z",
    fill: primaryFill
  }));
};

export const DockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockRegularIcon, 'DockRegular');

const DockRowFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c-.83 0-1.5.67-1.5 1.5v2C1.5 8.33 2.17 9 3 9h2c.83 0 1.5-.67 1.5-1.5v-2C6.5 4.67 5.83 4 5 4H3Zm0 6c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H3Zm4.5-4.5C7.5 4.67 8.17 4 9 4h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H9a1.5 1.5 0 0 1-1.5-1.5v-2ZM9 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H9Zm4.5-4.5c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-2ZM15 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-2Z",
    fill: primaryFill
  }));
};

export const DockRowFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockRowFilledIcon, 'DockRowFilled');

const DockRowRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c-.83 0-1.5.67-1.5 1.5v2C1.5 8.33 2.17 9 3 9h2c.83 0 1.5-.67 1.5-1.5v-2C6.5 4.67 5.83 4 5 4H3Zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2A.5.5 0 0 1 5 8H3a.5.5 0 0 1-.5-.5v-2ZM3 10c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H3Zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-2Zm5-6C7.5 4.67 8.17 4 9 4h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H9a1.5 1.5 0 0 1-1.5-1.5v-2ZM9 5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-2A.5.5 0 0 0 11 5H9Zm0 5c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H9Zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-2Zm5-6c0-.83.67-1.5 1.5-1.5h2c.83 0 1.5.67 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-2ZM15 5a.5.5 0 0 0-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 0 0 .5-.5v-2A.5.5 0 0 0 17 5h-2Zm0 5c-.83 0-1.5.67-1.5 1.5v2c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5h-2Zm-.5 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2Z",
    fill: primaryFill
  }));
};

export const DockRowRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DockRowRegularIcon, 'DockRowRegular');

const DoctorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 3C7.67 3 7 3.67 7 4.5V7H4.5C3.67 7 3 7.67 3 8.5v3c0 .83.67 1.5 1.5 1.5H7v2.5c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5V13h2.5c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5H13V4.5c0-.83-.67-1.5-1.5-1.5h-3Z",
    fill: primaryFill
  }));
};

export const DoctorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoctorFilledIcon, 'DoctorFilled');

const DoctorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h3c.28 0 .5.22.5.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3c0-.28.22-.5.5-.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 0-.5-.5h-3ZM7 4.5C7 3.67 7.67 3 8.5 3h3c.83 0 1.5.67 1.5 1.5V7h2.5c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5H13v2.5c0 .83-.67 1.5-1.5 1.5h-3A1.5 1.5 0 0 1 7 15.5V13H4.5A1.5 1.5 0 0 1 3 11.5v-3C3 7.67 3.67 7 4.5 7H7V4.5Z",
    fill: primaryFill
  }));
};

export const DoctorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DoctorRegularIcon, 'DoctorRegular');

const Document100FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h1.09a1.5 1.5 0 0 1-.09-.5v-2a1.5 1.5 0 0 1-.73-2.81c.27-.15.5-.46.66-.79.47-.96 1.46-.92 1.76-.86a1.64 1.64 0 0 1 1.15.87 3 3 0 0 1 4.66.43 3 3 0 0 1 1.5-1.17V4a2 2 0 0 0-2-2H6Zm3 10.6c0-.2-.1-.35-.2-.44a.64.64 0 0 0-.3-.14c-.13-.03-.5-.03-.67.32-.2.41-.54.93-1.07 1.22a.5.5 0 1 0 .48.88c.3-.17.55-.37.76-.6v3.66a.5.5 0 0 0 1 0v-4.9Zm1 1.4a2 2 0 1 1 4 0v2a2 2 0 1 1-4 0v-2Zm2-1a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm5-1a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0v-2a2 2 0 0 0-2-2Zm-1 2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2Z",
    fill: primaryFill
  }));
};

export const Document100Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Document100FilledIcon, 'Document100Filled');

const Document100RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h1.09a1.5 1.5 0 0 1-.09-.5V17H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v7.76a3 3 0 0 1 1-.59V4a2 2 0 0 0-2-2H6Zm6 10a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0v-2a2 2 0 0 0-2-2Zm-1 2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2Zm-2-1.4c0-.2-.1-.35-.2-.44a.64.64 0 0 0-.3-.14c-.13-.03-.5-.03-.67.32-.2.41-.54.93-1.07 1.22a.5.5 0 1 0 .48.88c.3-.17.55-.37.76-.6v3.66a.5.5 0 0 0 1 0v-4.9Zm6 1.4a2 2 0 1 1 4 0v2a2 2 0 1 1-4 0v-2Zm2-1a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Z",
    fill: primaryFill
  }));
};

export const Document100Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Document100RegularIcon, 'Document100Regular');

const DocumentFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5v-13C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25Z",
    fill: primaryFill
  }));
};

export const DocumentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFilledIcon, 'DocumentFilled');

const DocumentRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6ZM5 4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm9.8 3h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7Z",
    fill: primaryFill
  }));
};

export const DocumentRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentRegularIcon, 'DocumentRegular');

const DocumentAddFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5Z",
    fill: primaryFill
  }));
};

export const DocumentAddFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentAddFilledIcon, 'DocumentAddFilled');

const DocumentAddRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-2a.5.5 0 0 0-1 0V14H3.5a.5.5 0 0 0 0 1H5v1.5a.5.5 0 0 0 1 0V15h1.5a.5.5 0 0 0 0-1H6v-1.5Z",
    fill: primaryFill
  }));
};

export const DocumentAddRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentAddRegularIcon, 'DocumentAddRegular');

const DocumentArrowDownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-2.35-4.15a.5.5 0 0 1 .7-.7L5 15.29V12.5a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.35.15.5.5 0 0 1-.35-.14l-2-2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowDownFilledIcon, 'DocumentArrowDownFilled');

const DocumentArrowDownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-2.35-4.15a.5.5 0 0 1 .7-.7L5 15.29V12.5a.5.5 0 0 1 1 0v2.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.35.15.5.5 0 0 1-.35-.14l-2-2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowDownRegularIcon, 'DocumentArrowDownRegular');

const DocumentArrowLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L4.71 15H7.5a.5.5 0 0 0 0-1H4.7l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowLeftFilledIcon, 'DocumentArrowLeftFilled');

const DocumentArrowLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-6.85-.35a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L4.71 15H7.5a.5.5 0 0 0 0-1H4.7l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowLeftRegularIcon, 'DocumentArrowLeftRegular');

const DocumentArrowRightFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L6.29 15H3.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowRightFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowRightFilledIcon, 'DocumentArrowRightFilled');

const DocumentArrowRightRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm.35-2.15a.5.5 0 0 1-.7-.7L6.29 15H3.5a.5.5 0 0 1 0-1h2.8l-1.15-1.15a.5.5 0 0 1 .7-.7l2 2a.5.5 0 0 1 .15.35.5.5 0 0 1-.14.35l-2 2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowRightRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowRightRegularIcon, 'DocumentArrowRightRegular');

const DocumentArrowUpFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2.35-4.85a.5.5 0 1 1-.7.7L6 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2A.5.5 0 0 1 5.5 12a.5.5 0 0 1 .35.14l2 2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowUpFilledIcon, 'DocumentArrowUpFilled');

const DocumentArrowUpRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM5.5 19a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm2.35-4.85a.5.5 0 1 1-.7.7L6 13.71v2.79a.5.5 0 0 1-1 0v-2.8l-1.15 1.15a.5.5 0 1 1-.7-.7l2-2A.5.5 0 0 1 5.5 12a.5.5 0 0 1 .35.14l2 2Z",
    fill: primaryFill
  }));
};

export const DocumentArrowUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentArrowUpRegularIcon, 'DocumentArrowUpRegular');

const DocumentBorderFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 0 0 4 4.5v11A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13.5 2h-7ZM5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5v-11ZM6.75 4a.75.75 0 0 0-.75.75v10.5c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75V4.75a.75.75 0 0 0-.75-.75h-6.5Z",
    fill: primaryFill
  }));
};

export const DocumentBorderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBorderFilledIcon, 'DocumentBorderFilled');

const DocumentBorderRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 0 0 4 4.5v11A2.5 2.5 0 0 0 6.5 18h7a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13.5 2h-7ZM5 4.5C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 0 1 5 15.5v-11ZM6.75 4a.75.75 0 0 0-.75.75v10.5c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75V4.75a.75.75 0 0 0-.75-.75h-6.5ZM7 15V5h6v10H7Z",
    fill: primaryFill
  }));
};

export const DocumentBorderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBorderRegularIcon, 'DocumentBorderRegular');

const DocumentBorderPrintFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 0 0 4 4.5v11A2.5 2.5 0 0 0 6.5 18H11a2 2 0 0 1-1.73-1H6.5A1.5 1.5 0 0 1 5 15.5v-11C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V9h.5c.17 0 .34.02.5.05V4.5A2.5 2.5 0 0 0 13.5 2h-7Zm7 7h.5V4.75a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0-.75.75v10.5c0 .41.34.75.75.75H9v-2.5a2.5 2.5 0 0 1 2.04-2.46A2.5 2.5 0 0 1 13.5 9Zm0 1c-.83 0-1.5.67-1.5 1.5v.5h-.5c-.83 0-1.5.67-1.5 1.5V16a1 1 0 0 0 1 1h1v.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V17h1a1 1 0 0 0 1-1v-2.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2Zm2.5 2h-3v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v.5Zm-2.5 4h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentBorderPrintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBorderPrintFilledIcon, 'DocumentBorderPrintFilled');

const DocumentBorderPrintRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 2A2.5 2.5 0 0 0 4 4.5v11A2.5 2.5 0 0 0 6.5 18H11a2 2 0 0 1-1.73-1H6.5A1.5 1.5 0 0 1 5 15.5v-11C5 3.67 5.67 3 6.5 3h7c.83 0 1.5.67 1.5 1.5V9h.5c.17 0 .34.02.5.05V4.5A2.5 2.5 0 0 0 13.5 2h-7ZM14 4.75V9h-.5c-.17 0-.34.02-.5.05V5H7v10h2v1H6.75a.75.75 0 0 1-.75-.75V4.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75ZM13.5 10c-.83 0-1.5.67-1.5 1.5v.5h-.5c-.83 0-1.5.67-1.5 1.5V16a1 1 0 0 0 1 1h1v.5c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V17h1a1 1 0 0 0 1-1v-2.5c0-.83-.67-1.5-1.5-1.5H17v-.5c0-.83-.67-1.5-1.5-1.5h-2Zm2.5 2h-3v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v.5Zm-2.5 4h2c.28 0 .5.22.5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentBorderPrintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBorderPrintRegularIcon, 'DocumentBorderPrintRegular');

const DocumentBriefcaseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-3.55c.03-.16.05-.33.05-.5v-4a2.5 2.5 0 0 0-2.04-2.46A2.5 2.5 0 0 0 6.5 9h-2c-.17 0-.34.02-.5.05V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM3 11.5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H8v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5Zm1.5-.5h2c.28 0 .5.22.5.5v.5H4v-.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentBriefcaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBriefcaseFilledIcon, 'DocumentBriefcaseFilled');

const DocumentBriefcaseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.05c.16-.03.33-.05.5-.05H5V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3v.5c0 .17-.02.34-.05.5H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM3 11.5v.5h-.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h6c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5H8v-.5c0-.83-.67-1.5-1.5-1.5h-2c-.83 0-1.5.67-1.5 1.5Zm1.5-.5h2c.28 0 .5.22.5.5v.5H4v-.5c0-.28.22-.5.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentBriefcaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBriefcaseRegularIcon, 'DocumentBriefcaseRegular');

const DocumentBulletListFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm-4 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2-4c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm3-8V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListFilledIcon, 'DocumentBulletListFilled');

const DocumentBulletListRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 10.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM6 14.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM8.5 10a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM8 12.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6ZM5 4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm9.8 3h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListRegularIcon, 'DocumentBulletListRegular');

const DocumentBulletListArrowLeftFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.7a5.5 5.5 0 0 1 4.66.8h4.84a.5.5 0 0 1 0 1H9.74c.26.3.48.64.66 1h3.1a.5.5 0 0 1 0 1h-2.7c.08.32.15.66.18 1h2.52a.5.5 0 0 1 0 1h-2.52a5.48 5.48 0 0 1-1.24 3h4.76c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm1 0V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5ZM5.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L4.71 15H7.5a.5.5 0 0 0 0-1H4.7l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListArrowLeftFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListArrowLeftFilledIcon, 'DocumentBulletListArrowLeftFilled');

const DocumentBulletListArrowLeftRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 4v5.02c-.34.03-.68.1-1 .19V4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2H9.74c.26-.3.48-.64.66-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1Zm8.5 11h-2.52a5.59 5.59 0 0 0 0-1h2.52a.5.5 0 0 1 0 1Zm0-2h-2.7c-.1-.35-.24-.68-.4-1h3.1a.5.5 0 0 1 0 1Zm0-2H9.74a5.53 5.53 0 0 0-1.08-1h4.84a.5.5 0 0 1 0 1Zm1.3-4L11 3.2v3.3c0 .28.22.5.5.5h3.3ZM5.5 19a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm-2.35-4.85a.5.5 0 0 0-.15.35.5.5 0 0 0 .15.35l2 2a.5.5 0 0 0 .7-.7L4.71 15H7.5a.5.5 0 0 0 0-1H4.7l1.15-1.15a.5.5 0 0 0-.7-.7l-2 2Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListArrowLeftRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListArrowLeftRegularIcon, 'DocumentBulletListArrowLeftRegular');

const DocumentBulletListClockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h4.76a5.47 5.47 0 0 1-1.24-3H8.5a.5.5 0 0 1 0-1h.52c.03-.34.1-.68.19-1H8.5a.5.5 0 0 1 0-1h1.1c.18-.36.4-.7.66-1H8.5a.5.5 0 0 1 0-1h2.84A5.47 5.47 0 0 1 16 9.2V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm-4 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5 1.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M11 6.5V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-3a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H15v-2.5Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListClockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListClockFilledIcon, 'DocumentBulletListClockFilled');

const DocumentBulletListClockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v1.02c.34.03.68.1 1 .19V7.4c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM9 14.5c0-.17 0-.34.02-.5H8.5a.5.5 0 0 0 0 1h.52a5.57 5.57 0 0 1-.02-.5Zm.2-1.5c.1-.35.24-.68.4-1H8.5a.5.5 0 0 0 0 1h.7Zm1.06-2c.31-.38.67-.72 1.08-1H8.5a.5.5 0 0 0 0 1h1.76ZM6.5 10a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM6 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm0 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm13 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4-3a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1H15v-2.5Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListClockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListClockRegularIcon, 'DocumentBulletListClockRegular');

const DocumentBulletListCubeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.76l.1-.05a2 2 0 0 1 1.8 0l2.15 1.08A.5.5 0 0 1 8.5 10h5a.5.5 0 0 1 0 1H9.32a2 2 0 0 1 .62 1h3.56a.5.5 0 0 1 0 1H10v1h3.5a.5.5 0 0 1 0 1H10v1.5a2 2 0 0 1-.67 1.5h5.17c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm1 0V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Zm-2.55 5.1-3-1.5a1 1 0 0 0-.9 0l-3 1.5a1 1 0 0 0-.55.9v4a1 1 0 0 0 .55.9l3 1.5a1 1 0 0 0 .9 0l3-1.5a1 1 0 0 0 .55-.9v-4a1 1 0 0 0-.55-.9Zm-6.41 1.13a.5.5 0 0 1 .66-.26l2.3.99 2.3-1a.5.5 0 0 1 .4.93l-2.2.94V17a.5.5 0 1 1-1 0v-2.67l-2.2-.94a.5.5 0 0 1-.26-.66Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListCubeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListCubeFilledIcon, 'DocumentBulletListCubeFilled');

const DocumentBulletListCubeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 10a.5.5 0 0 0-.45.29l.84.42a2 2 0 0 1 .43.29h4.18a.5.5 0 0 0 0-1h-5ZM5 4v5a2 2 0 0 0-.9.21l-.1.05V4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2H9.33a2 2 0 0 0 .6-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1Zm8.5 11H10v-1h3.5a.5.5 0 0 1 0 1Zm0-2H10v-.5a2 2 0 0 0-.06-.5h3.56a.5.5 0 0 1 0 1Zm1.3-6L11 3.2v3.3c0 .28.22.5.5.5h3.3Zm-6.35 4.6-3-1.5a1 1 0 0 0-.9 0l-3 1.5a1 1 0 0 0-.55.9v4a1 1 0 0 0 .55.9l3 1.5a1 1 0 0 0 .9 0l3-1.5a1 1 0 0 0 .55-.9v-4a1 1 0 0 0-.55-.9Zm-6.41 1.13a.5.5 0 0 1 .66-.26l2.3.99 2.3-1a.5.5 0 0 1 .4.93l-2.2.94V17a.5.5 0 1 1-1 0v-2.67l-2.2-.94a.5.5 0 0 1-.26-.66Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListCubeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListCubeRegularIcon, 'DocumentBulletListCubeRegular');

const DocumentBulletListMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v11c0 .83.67 1.5 1.5 1.5H13a2 2 0 0 0 2-2V8h-4.5A1.5 1.5 0 0 1 9 6.5Zm-3 4a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm.5 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2-2a.5.5 0 0 1 0-1h4a.5.5 0 0 1 0 1h-4ZM8 12.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm2-6V2.25L14.75 7H10.5a.5.5 0 0 1-.5-.5ZM17 9a1 1 0 0 0-1-1v6a3 3 0 0 1-3 3H6a1 1 0 0 0 1 1h6.06A3.94 3.94 0 0 0 17 14.06V9Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListMultipleFilledIcon, 'DocumentBulletListMultipleFilled');

const DocumentBulletListMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 10a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM6 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2-2c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4ZM6 2a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h7a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 9.59 2H6ZM5 4a1 1 0 0 1 1-1h3v3.5c0 .83.67 1.5 1.5 1.5H14v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm5 2.5V3.2L13.8 7h-3.3a.5.5 0 0 1-.5-.5ZM16 8a1 1 0 0 1 1 1v5.06A3.94 3.94 0 0 1 13.06 18H7a1 1 0 0 1-1-1h7a3 3 0 0 0 3-3V8Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListMultipleRegularIcon, 'DocumentBulletListMultipleRegular');

const DocumentBulletListOffFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-1.16-1.16A1.5 1.5 0 0 1 14.5 18h-9A1.5 1.5 0 0 1 4 16.5V4.7Zm9.3 9.3H8.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .47-.32l-.68-.68Zm-1-1-1-1H8.5a.5.5 0 0 0 0 1h3.8Zm-2-2-1-1h-.8a.5.5 0 0 0 0 1h1.8Zm3.2 0h-.38L16 13.88V8h-4.5A1.5 1.5 0 0 1 10 6.5V2H5.5c-.38 0-.73.14-1 .38L12.12 10h1.38a.5.5 0 0 1 0 1ZM6 10.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm0 2a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm0 2a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm5-8V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListOffFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListOffFilledIcon, 'DocumentBulletListOffFilled');

const DocumentBulletListOffRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4.7 2.15 2.86a.5.5 0 1 1 .7-.7l15 15a.5.5 0 0 1-.7.7l-1.25-1.24A2 2 0 0 1 14 18H6a2 2 0 0 1-2-2V4.7Zm11 11-1.03-1.02a.5.5 0 0 1-.47.32h-5a.5.5 0 0 1 0-1h4.8l-1-1H8.5a.5.5 0 0 1 0-1h2.8l-1-1H8.5a.5.5 0 0 1 0-1h.8L5 5.7V16a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.3ZM12.12 10l1 1h.38a.5.5 0 0 0 0-1h-1.38ZM15 8v4.88l1 1V7.4c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6a2 2 0 0 0-1.35.53l.7.7A1 1 0 0 1 6 3h4v3.5c0 .83.67 1.5 1.5 1.5H15Zm-9 2.5a.5.5 0 1 0 1 0 .5.5 0 0 0-1 0Zm.5 1.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM6 14.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM14.8 7h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7Z",
    fill: primaryFill
  }));
};

export const DocumentBulletListOffRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentBulletListOffRegularIcon, 'DocumentBulletListOffRegular');

const DocumentCatchUpFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-9A1.5 1.5 0 0 1 4 16.5V13h1.5a1.5 1.5 0 0 0 1.34-.83l.04-.07 1.24 2.98a1.5 1.5 0 0 0 2.72.1L11.93 13h.57a1.5 1.5 0 0 0 0-3H11a1.5 1.5 0 0 0-1.34.83l-.04.07-1.24-2.98a1.5 1.5 0 0 0-2.72-.1L4.57 10H4V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM7.46 8.31a.5.5 0 0 0-.9-.03L5.18 11H3.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .45-.28l1-2.02 2.09 5a.5.5 0 0 0 .9.02L11.32 12h1.19a.5.5 0 0 0 0-1H11a.5.5 0 0 0-.45.28l-1 2.02-2.09-5Z",
    fill: primaryFill
  }));
};

export const DocumentCatchUpFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCatchUpFilledIcon, 'DocumentCatchUpFilled');

const DocumentCatchUpRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v4.5a.5.5 0 0 0 1 0V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-3H4v3c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM7.45 8.3a.5.5 0 0 0-.9-.02L5.18 11H3.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 .45-.28l1-2.02 2.09 5a.5.5 0 0 0 .9.02L11.32 12h1.19a.5.5 0 0 0 0-1H11a.5.5 0 0 0-.45.28l-1 2.02-2.09-5Z",
    fill: primaryFill
  }));
};

export const DocumentCatchUpRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCatchUpRegularIcon, 'DocumentCatchUpRegular');

const DocumentCheckmarkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const DocumentCheckmarkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCheckmarkFilledIcon, 'DocumentCheckmarkFilled');

const DocumentCheckmarkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.15-1.85a.5.5 0 0 0-.7 0L4.5 15.29l-.65-.64a.5.5 0 0 0-.7.7l1 1c.2.2.5.2.7 0l3-3a.5.5 0 0 0 0-.7Z",
    fill: primaryFill
  }));
};

export const DocumentCheckmarkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCheckmarkRegularIcon, 'DocumentCheckmarkRegular');

const DocumentChevronDoubleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7L3.21 14.5l1.14-1.15Zm2.3-.7a.5.5 0 0 0 0 .7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 0 0-.7 0Z",
    fill: primaryFill
  }));
};

export const DocumentChevronDoubleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentChevronDoubleFilledIcon, 'DocumentChevronDoubleFilled');

const DocumentChevronDoubleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-5.65-1.15a.5.5 0 0 0-.7-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 0 0 .7-.7L3.21 14.5l1.14-1.15Zm2.3-.7a.5.5 0 0 0 0 .7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 0 0-.7 0Z",
    fill: primaryFill
  }));
};

export const DocumentChevronDoubleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentChevronDoubleRegularIcon, 'DocumentChevronDoubleRegular');

const DocumentCopyFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 6.5V2H7.5C6.67 2 6 2.67 6 3.5v11c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 11 6.5Zm1 0V2.25L16.75 7H12.5a.5.5 0 0 1-.5-.5ZM4 5a1 1 0 0 1 1-1v10.5A2.5 2.5 0 0 0 7.5 17H15a1 1 0 0 1-1 1H7.55A3.55 3.55 0 0 1 4 14.45V5Z",
    fill: primaryFill
  }));
};

export const DocumentCopyFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCopyFilledIcon, 'DocumentCopyFilled');

const DocumentCopyRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4c0-1.1.9-2 2-2h3.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 11 6.5V3H8Zm4 .2v3.3c0 .28.22.5.5.5h3.3L12 3.2ZM4 5a1 1 0 0 1 1-1v10a3 3 0 0 0 3 3h7a1 1 0 0 1-1 1H7.94A3.94 3.94 0 0 1 4 14.06V5Z",
    fill: primaryFill
  }));
};

export const DocumentCopyRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCopyRegularIcon, 'DocumentCopyRegular');

const DocumentCssFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v7.67a3 3 0 0 1 1.38 1A2.5 2.5 0 0 1 9.5 12a2.5 2.5 0 0 1 4.5 1.5c0 .44-.2.84-.5 1.12.32.42.5.95.5 1.5v.38c0 .56-.19 1.08-.5 1.5h1c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm1 0V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5ZM3 12a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0 .5.5 0 0 0-1 0 1 1 0 1 1-2 0v-2a1 1 0 1 1 2 0 .5.5 0 0 0 1 0 2 2 0 0 0-2-2Zm8.5 0c-.83 0-1.5.67-1.5 1.5v.38c0 .57.32 1.09.83 1.34l.9.45a.5.5 0 0 1 .27.45v.38a.5.5 0 0 1-1 0 .5.5 0 0 0-1 0 1.5 1.5 0 0 0 3 0v-.38a1.5 1.5 0 0 0-.83-1.34l-.9-.45a.5.5 0 0 1-.27-.45v-.38a.5.5 0 0 1 1 0 .5.5 0 0 0 1 0c0-.83-.67-1.5-1.5-1.5ZM6 13.5a1.5 1.5 0 0 1 3 0 .5.5 0 0 1-1 0 .5.5 0 0 0-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 0 1-3 0 .5.5 0 0 1 1 0 .5.5 0 0 0 1 0v-.38a.5.5 0 0 0-.28-.45l-.9-.45A1.5 1.5 0 0 1 6 13.88v-.38Z",
    fill: primaryFill
  }));
};

export const DocumentCssFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCssFilledIcon, 'DocumentCssFilled');

const DocumentCssRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2h-.5c.22-.3.38-.63.45-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v7.76a3 3 0 0 0-1-.59V4Zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5ZM3 12a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0 .5.5 0 0 0-1 0 1 1 0 1 1-2 0v-2a1 1 0 1 1 2 0 .5.5 0 0 0 1 0 2 2 0 0 0-2-2Zm8.5 0c-.83 0-1.5.67-1.5 1.5v.38c0 .57.32 1.09.83 1.34l.9.45a.5.5 0 0 1 .27.45v.38a.5.5 0 0 1-1 0 .5.5 0 0 0-1 0 1.5 1.5 0 0 0 3 0v-.38a1.5 1.5 0 0 0-.83-1.34l-.9-.45a.5.5 0 0 1-.27-.45v-.38a.5.5 0 0 1 1 0 .5.5 0 0 0 1 0c0-.83-.67-1.5-1.5-1.5ZM6 13.5a1.5 1.5 0 0 1 3 0 .5.5 0 0 1-1 0 .5.5 0 0 0-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 0 1-3 0 .5.5 0 0 1 1 0 .5.5 0 0 0 1 0v-.38a.5.5 0 0 0-.28-.45l-.9-.45A1.5 1.5 0 0 1 6 13.88v-.38Z",
    fill: primaryFill
  }));
};

export const DocumentCssRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentCssRegularIcon, 'DocumentCssRegular');

const DocumentDataFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5ZM10 9c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0v-6c0-.28.22-.5.5-.5Zm-2.5 4c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5Zm5-2c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5ZM11 6.5V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentDataFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDataFilledIcon, 'DocumentDataFilled');

const DocumentDataRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 13.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2ZM10 9c.28 0 .5.22.5.5v6a.5.5 0 0 1-1 0v-6c0-.28.22-.5.5-.5Zm3 2.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4ZM4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6Zm5.5 4h3.3L11 3.2v3.3c0 .28.22.5.5.5Z",
    fill: primaryFill
  }));
};

export const DocumentDataRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDataRegularIcon, 'DocumentDataRegular');

const DocumentDataLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5V13h3.5c.74 0 1.43.23 2 .63V9.5a.5.5 0 0 1 1 0v5.2a3.48 3.48 0 0 1 .16 3.3h3.84c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm2.5 4.5c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5ZM11 6.5V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5ZM3.5 14a2.5 2.5 0 0 0 0 5H4a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3H4a.5.5 0 0 0 0-1h-.5ZM7 14a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H7a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H7Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentDataLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDataLinkFilledIcon, 'DocumentDataLinkFilled');

const DocumentDataLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 13.63c.4.28.75.64 1 1.07V9.5a.5.5 0 0 0-1 0v4.13ZM5 4v9H4V4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2h-3.34c.15-.31.25-.65.3-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1Zm8 7.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4ZM11.5 7h3.3L11 3.2v3.3c0 .28.22.5.5.5Zm-8 7a2.5 2.5 0 0 0 0 5H4a.5.5 0 0 0 0-1h-.5a1.5 1.5 0 0 1 0-3H4a.5.5 0 0 0 0-1h-.5ZM7 14a.5.5 0 0 0 0 1h.5a1.5 1.5 0 0 1 0 3H7a.5.5 0 0 0 0 1h.5a2.5 2.5 0 0 0 0-5H7Zm-4 2.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentDataLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDataLinkRegularIcon, 'DocumentDataLinkRegular');

const DocumentDatabaseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-4c.3-.43.5-.93.5-1.5V10.3c-.11-1.42-1.4-2.36-2.65-2.83A8.86 8.86 0 0 0 4 7.12V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM6.88 8.12c.4.07.78.17 1.12.3 1.2.45 2 1.21 2 2.08 0 1.38-2.01 2.5-4.5 2.5S1 11.88 1 10.5 3.01 8 5.5 8c.48 0 .94.04 1.38.12ZM5.5 14c1.38 0 2.68-.3 3.67-.86.3-.16.58-.36.83-.59v3.95c0 1.38-2.01 2.5-4.5 2.5S1 17.88 1 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85Z",
    fill: primaryFill
  }));
};

export const DocumentDatabaseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDatabaseFilledIcon, 'DocumentDatabaseFilled');

const DocumentDatabaseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v3.13c.32-.06.66-.1 1-.12V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.05c-.08.37-.24.7-.45 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM6.87 8.12c.4.07.78.17 1.12.3 1.2.45 2 1.21 2 2.08 0 1.38-2.01 2.5-4.5 2.5S1 11.88 1 10.5 3.01 8 5.5 8c.48 0 .94.04 1.38.12ZM5.5 14c1.38 0 2.68-.3 3.67-.86.3-.16.58-.36.83-.59v3.95c0 1.38-2.01 2.5-4.5 2.5S1 17.88 1 16.5v-3.95c.25.23.54.43.83.6 1 .54 2.29.85 3.67.85Z",
    fill: primaryFill
  }));
};

export const DocumentDatabaseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDatabaseRegularIcon, 'DocumentDatabaseRegular');

const DocumentDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM2.32 17.68a4.5 4.5 0 1 0 6.36-6.36 4.5 4.5 0 0 0-6.36 6.36Zm1.41-4.95c.2-.2.51-.2.7 0L5.5 13.8l1.06-1.06a.5.5 0 1 1 .7.7L6.22 14.5l1.06 1.06a.5.5 0 1 1-.71.7L5.5 15.22l-1.06 1.06a.5.5 0 1 1-.7-.71l1.05-1.06-1.06-1.06a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const DocumentDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDismissFilledIcon, 'DocumentDismissFilled');

const DocumentDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM8.67 17.68a4.5 4.5 0 1 0-6.36-6.36 4.5 4.5 0 0 0 6.36 6.36Zm-4.95-4.95c.2-.2.51-.2.7 0L5.5 13.8l1.06-1.06a.5.5 0 1 1 .7.7L6.22 14.5l1.06 1.06a.5.5 0 1 1-.71.7L5.5 15.22l-1.06 1.06a.5.5 0 1 1-.7-.71l1.05-1.06-1.06-1.06a.5.5 0 0 1 0-.7Z",
    fill: primaryFill
  }));
};

export const DocumentDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentDismissRegularIcon, 'DocumentDismissRegular');

const DocumentEditFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h2.72a1.86 1.86 0 0 1-.16-1.35l.37-1.5a3.2 3.2 0 0 1 .84-1.48l4.83-4.83c.53-.53 1.21-.8 1.9-.84h-4.5A1.5 1.5 0 0 1 10 6.5Zm1 0V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Zm6.45 3.05a1.87 1.87 0 0 0-2.64 0l-4.83 4.83a2.2 2.2 0 0 0-.58 1.02l-.37 1.5a.89.89 0 0 0 1.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83c.73-.73.73-1.91 0-2.64Z",
    fill: primaryFill
  }));
};

export const DocumentEditFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEditFilledIcon, 'DocumentEditFilled');

const DocumentEditRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 8H16v-.59a1.5 1.5 0 0 0-.06-.4V7a1.5 1.5 0 0 0-.38-.65l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h2.22l-.01-.03A1.86 1.86 0 0 1 8 17H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5Zm0-1a.5.5 0 0 1-.5-.5V3.2L14.8 7h-3.3Zm3.3 2.55a1.87 1.87 0 1 1 2.65 2.64l-4.83 4.83a2.2 2.2 0 0 1-1.02.58l-1.5.37a.89.89 0 0 1-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02l4.83-4.83Z",
    fill: primaryFill
  }));
};

export const DocumentEditRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEditRegularIcon, 'DocumentEditRegular');

const DocumentEndnoteFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H11v-6a2 2 0 0 0-2-2H4V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM3.5 11a.5.5 0 0 1 0 1h-1a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 17.5v-5c0-.83.67-1.5 1.5-1.5h1Zm4 7a.5.5 0 0 0 0 1h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 0 0 1h1c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-1ZM6 14.5a.5.5 0 0 0-1 0v3a.5.5 0 1 0 1 0v-3Zm0-2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z",
    fill: primaryFill
  }));
};

export const DocumentEndnoteFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEndnoteFilledIcon, 'DocumentEndnoteFilled');

const DocumentEndnoteRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v6h1V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3v1h3a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM3.5 11a.5.5 0 0 1 0 1h-1a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 1 17.5v-5c0-.83.67-1.5 1.5-1.5h1Zm4 7a.5.5 0 0 0 0 1h1c.83 0 1.5-.67 1.5-1.5v-5c0-.83-.67-1.5-1.5-1.5h-1a.5.5 0 0 0 0 1h1c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5h-1Zm-2-4c.27 0 .5.22.5.5v3a.5.5 0 1 1-1 0v-3c0-.28.22-.5.5-.5Zm0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
    fill: primaryFill
  }));
};

export const DocumentEndnoteRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentEndnoteRegularIcon, 'DocumentEndnoteRegular');

const DocumentErrorFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H9.74A5.5 5.5 0 0 0 4 9.2V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM5.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24Z",
    fill: primaryFill
  }));
};

export const DocumentErrorFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentErrorFilledIcon, 'DocumentErrorFilled');

const DocumentErrorRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-3.6c-.18.36-.4.7-.66 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM10 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM5.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5Zm0 5.13a.62.62 0 1 0 0-1.25.62.62 0 0 0 0 1.24Z",
    fill: primaryFill
  }));
};

export const DocumentErrorRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentErrorRegularIcon, 'DocumentErrorRegular');

const DocumentFitFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm1.5 3a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1C6 4.67 6.67 4 7.5 4h1a.5.5 0 0 1 0 1h-1Zm0 10h1a.5.5 0 0 1 0 1h-1A1.5 1.5 0 0 1 6 14.5v-1a.5.5 0 0 1 1 0v1c0 .28.22.5.5.5ZM13 5.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1 0-1h1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 1-1 0v-1Zm-.5 9.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 1 0v1c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 1 0-1h1Z",
    fill: primaryFill
  }));
};

export const DocumentFitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFitFilledIcon, 'DocumentFitFilled');

const DocumentFitRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6ZM5 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm2.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 1-1 0v-1C6 4.67 6.67 4 7.5 4h1a.5.5 0 0 1 0 1h-1Zm0 10a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 0-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 0 0 0-1h-1ZM13 5.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 1 0-1h1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 0 1-1 0v-1Zm-.5 9.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 1 1 0v1c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 0 1 0-1h1Z",
    fill: primaryFill
  }));
};

export const DocumentFitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFitRegularIcon, 'DocumentFitRegular');

const DocumentFlowchartFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v13c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm-4 1c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5H8v1.8L9.2 13H11v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H9.2l-1.35 1.35a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 0-.7L7 11.79V10h-.5a.5.5 0 0 1-.5-.5v-2Zm5-1V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentFlowchartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFlowchartFilledIcon, 'DocumentFlowchartFilled');

const DocumentFlowchartRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 7.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5H8v1.8L9.2 13H11v-.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V14H9.2l-1.35 1.35a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 0-.7L7 11.79V10h-.5a.5.5 0 0 1-.5-.5v-2ZM6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6ZM5 4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm9.8 3h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7Z",
    fill: primaryFill
  }));
};

export const DocumentFlowchartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFlowchartRegularIcon, 'DocumentFlowchartRegular');

const DocumentFolderFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a2 2 0 0 1 2 2v7h-.88L9 6.88A3 3 0 0 0 6.88 6H5a3 3 0 0 0-1 .17V4c0-1.1.9-2 2-2h6Zm3 9a3 3 0 0 1 1 .17V6a2 2 0 0 0-1-1.73V11ZM5 7a2 2 0 0 0-2 2v6.5A2.5 2.5 0 0 0 5.5 18h9a2.5 2.5 0 0 0 2.5-2.5V14a2 2 0 0 0-2-2h-1.88a1 1 0 0 1-.7-.3L8.28 7.6A2 2 0 0 0 6.88 7H5Z",
    fill: primaryFill
  }));
};

export const DocumentFolderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFolderFilledIcon, 'DocumentFolderFilled');

const DocumentFolderRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a2 2 0 0 1 2 2v8h1V4.27c.6.34 1 .99 1 1.73v6.27c.6.34 1 .99 1 1.73v1.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 15.5V9a2 2 0 0 1 1-1.73V4c0-1.1.9-2 2-2h6ZM5 7h1.88a2 2 0 0 1 1.41.59l4.12 4.12a1 1 0 0 0 .59.28V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3ZM4 9v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V14a1 1 0 0 0-1-1h-1.88a2 2 0 0 1-1.41-.59L7.59 8.3A1 1 0 0 0 6.88 8H5a1 1 0 0 0-1 1Z",
    fill: primaryFill
  }));
};

export const DocumentFolderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFolderRegularIcon, 'DocumentFolderRegular');

const DocumentFooterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm1 12h6a1 1 0 1 1 0 2H7a1 1 0 1 1 0-2Z",
    fill: primaryFill
  }));
};

export const DocumentFooterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterFilledIcon, 'DocumentFooterFilled');

const DocumentFooterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6ZM5 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm2 10a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
    fill: primaryFill
  }));
};

export const DocumentFooterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterRegularIcon, 'DocumentFooterRegular');

const DocumentFooterDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-3.8 0 1.15-1.15a.5.5 0 0 0-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L15.21 5.5Zm-.7 5.5a5.5 5.5 0 0 0 1.5-.2V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h4.26a5.5 5.5 0 0 0 4.24 9ZM7 14a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
    fill: primaryFill
  }));
};

export const DocumentFooterDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterDismissFilledIcon, 'DocumentFooterDismissFilled');

const DocumentFooterDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 5.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7L14.5 4.79l-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7L15.21 5.5l1.14-1.15ZM15 16v-5.02c.34-.03.68-.1 1-.19V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4c0-1.1.9-2 2-2h4.26c-.26.3-.48.64-.66 1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1Zm-8-2a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H7Z",
    fill: primaryFill
  }));
};

export const DocumentFooterDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentFooterDismissRegularIcon, 'DocumentFooterDismissRegular');

const DocumentHeaderFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm1 2h6a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderFilledIcon, 'DocumentHeaderFilled');

const DocumentHeaderRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6ZM5 4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm2 0a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderRegularIcon, 'DocumentHeaderRegular');

const DocumentHeaderArrowDownFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26A5.5 5.5 0 0 1 16 9.2V4a2 2 0 0 0-2-2H6Zm1 2h6a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2Zm12 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85 2.35a.5.5 0 0 0 .35.15.5.5 0 0 0 .35-.15l2-2a.5.5 0 0 0-.7-.7L15 15.29V12.5a.5.5 0 0 0-1 0v2.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderArrowDownFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderArrowDownFilledIcon, 'DocumentHeaderArrowDownFilled');

const DocumentHeaderArrowDownRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02c.34.03.68.1 1 .19V4a2 2 0 0 0-2-2H6Zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Zm12 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-4.85 2.35a.5.5 0 0 0 .35.15.5.5 0 0 0 .35-.15l2-2a.5.5 0 0 0-.7-.7L15 15.29V12.5a.5.5 0 0 0-1 0v2.8l-1.15-1.15a.5.5 0 0 0-.7.7l2 2Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderArrowDownRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderArrowDownRegularIcon, 'DocumentHeaderArrowDownRegular');

const DocumentHeaderDismissFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26A5.5 5.5 0 0 1 16 9.2V4a2 2 0 0 0-2-2H6Zm1 2h6a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2Zm12 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderDismissFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderDismissFilledIcon, 'DocumentHeaderDismissFilled');

const DocumentHeaderDismissRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h4.26a5.5 5.5 0 0 1-.66-1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5.02c.34.03.68.1 1 .19V4a2 2 0 0 0-2-2H6Zm1 2a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H7Zm12 10.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderDismissRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderDismissRegularIcon, 'DocumentHeaderDismissRegular');

const DocumentHeaderFooterFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2 1a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1Zm0 10a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H7a1 1 0 0 0-1 1Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderFooterFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderFooterFilledIcon, 'DocumentHeaderFooterFilled');

const DocumentHeaderFooterRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 10a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1ZM6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm8 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h8Z",
    fill: primaryFill
  }));
};

export const DocumentHeaderFooterRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeaderFooterRegularIcon, 'DocumentHeaderFooterRegular');

const DocumentHeartFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5V9c.7.03 1.4.25 2 .66a3.85 3.85 0 0 1 4.88 5.91L8.45 18h6.05c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm1 0V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5Zm-4.86 4.33a2.85 2.85 0 1 1 4.03 4.04l-3.82 3.81a.5.5 0 0 1-.7 0l-3.82-3.81a2.85 2.85 0 1 1 4.03-4.04l.14.14.14-.14Zm4.03 4.04-.36-.36Z",
    fill: primaryFill
  }));
};

export const DocumentHeartFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartFilledIcon, 'DocumentHeartFilled');

const DocumentHeartRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2H8.45l1-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v5.17c-.33-.1-.66-.15-1-.17V4Zm7-.8v3.3c0 .28.22.5.5.5h3.3L11 3.2ZM5.65 18.69a.5.5 0 0 0 .7 0l3.82-3.81a2.85 2.85 0 1 0-4.03-4.04l-.14.14-.13-.14a2.85 2.85 0 1 0-4.04 4.04l3.82 3.81Z",
    fill: primaryFill
  }));
};

export const DocumentHeartRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartRegularIcon, 'DocumentHeartRegular');

const DocumentHeartPulseFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H8.45l2.43-2.43A3.85 3.85 0 0 0 6 9.66c-.6-.41-1.3-.63-2-.66V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25Zm-.83 8.58a2.85 2.85 0 0 0-4.03 0l-.14.14-.14-.14A2.85 2.85 0 0 0 1 13h1.7l.55-.83a1.5 1.5 0 0 1 2.54.06l.35.59.16-.22a1.5 1.5 0 0 1 2.26-.16l.56.56H11a2.84 2.84 0 0 0-.83-2.17Zm-4.52 7.85L2.97 16h1.58l.16.27a1.5 1.5 0 0 0 2.49.13l.3-.4h1.53l-2.68 2.68a.5.5 0 0 1-.7 0ZM4.5 12.5c.17 0 .33.1.42.24l1.12 1.87L7.1 13.2a.5.5 0 0 1 .75-.05l.86.85H10a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.35-.15l-.6-.59L6.4 15.8a.5.5 0 0 1-.83-.04l-1.1-1.83-.55.85a.5.5 0 0 1-.42.22H2a.5.5 0 0 1 0-1h1.23l.85-1.28a.5.5 0 0 1 .43-.22Z",
    fill: primaryFill
  }));
};

export const DocumentHeartPulseFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartPulseFilledIcon, 'DocumentHeartPulseFilled');

const DocumentHeartPulseRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5c.34.02.67.07 1 .17V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1H9.45l-1 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7Zm-9.64 4.54A1.85 1.85 0 0 0 2 13H1a2.84 2.84 0 0 1 4.86-2.17l.13.14.14-.14A2.85 2.85 0 0 1 11 13h-1a1.85 1.85 0 0 0-3.15-1.46l-.5.5a.5.5 0 0 1-.7 0l-.5-.5ZM2.96 16h1.42L6 17.62 7.62 16h1.42l-2.68 2.68a.5.5 0 0 1-.71 0L2.97 16Zm1.54-4c.2 0 .36.1.45.28l1.14 2.27L7.1 13.2a.5.5 0 0 1 .76-.05l.85.85H10a.5.5 0 0 1 0 1H8.5a.5.5 0 0 1-.35-.15l-.6-.59L6.4 15.8a.5.5 0 0 1-.84-.08l-1.06-2.1-.55 1.1a.5.5 0 0 1-.45.28H2a.5.5 0 0 1 0-1h1.2l.86-1.72A.5.5 0 0 1 4.5 12Z",
    fill: primaryFill
  }));
};

export const DocumentHeartPulseRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentHeartPulseRegularIcon, 'DocumentHeartPulseRegular');

const DocumentJavascriptFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5V2H5.5C4.67 2 4 2.67 4 3.5v7.59c.32.1.59.33.77.6A2.5 2.5 0 0 1 9 13.5c0 .44-.2.84-.5 1.12.32.42.5.95.5 1.5v.38c0 .56-.19 1.08-.5 1.5h6c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 10 6.5Zm1 0V2.25L15.75 7H11.5a.5.5 0 0 1-.5-.5ZM3.5 12a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0V16a.5.5 0 0 0-1 0v.5a1.5 1.5 0 0 0 3 0v-4a.5.5 0 0 0-.5-.5ZM5 13.5a1.5 1.5 0 0 1 3 0 .5.5 0 0 1-1 0 .5.5 0 0 0-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 0 1-3 0 .5.5 0 0 1 1 0 .5.5 0 0 0 1 0v-.38a.5.5 0 0 0-.28-.45l-.9-.45A1.5 1.5 0 0 1 5 13.88v-.38Z",
    fill: primaryFill
  }));
};

export const DocumentJavascriptFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentJavascriptFilledIcon, 'DocumentJavascriptFilled');

const DocumentJavascriptRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h4.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V16a2 2 0 0 1-2 2H8.5c.22-.3.38-.63.45-1H14a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 10 6.5V3H6a1 1 0 0 0-1 1v7.5l-.23.2a1.5 1.5 0 0 0-.77-.61V4Zm7.5 3h3.3L11 3.2v3.3c0 .28.22.5.5.5Zm-8 5a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0V16a.5.5 0 0 0-1 0v.5a1.5 1.5 0 0 0 3 0v-4a.5.5 0 0 0-.5-.5ZM5 13.5a1.5 1.5 0 0 1 3 0 .5.5 0 0 1-1 0 .5.5 0 0 0-1 0v.38c0 .2.1.36.28.45l.9.45c.5.25.82.77.82 1.34v.38a1.5 1.5 0 0 1-3 0 .5.5 0 0 1 1 0 .5.5 0 0 0 1 0v-.38a.5.5 0 0 0-.28-.45l-.9-.45A1.5 1.5 0 0 1 5 13.88v-.38Z",
    fill: primaryFill
  }));
};

export const DocumentJavascriptRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentJavascriptRegularIcon, 'DocumentJavascriptRegular');

const DocumentLandscapeFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 10h-4.5A1.5 1.5 0 0 1 12 8.5V4H3.5C2.67 4 2 4.67 2 5.5v9c0 .83.67 1.5 1.5 1.5h13c.83 0 1.5-.67 1.5-1.5V10Zm-.25-1H13.5a.5.5 0 0 1-.5-.5V4.25L17.75 9Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeFilledIcon, 'DocumentLandscapeFilled');

const DocumentLandscapeRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h8.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14Zm-2 1a1 1 0 0 0 1-1v-4h-3.5A1.5 1.5 0 0 1 12 8.5V5H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12Zm-3-9.8v3.3c0 .28.22.5.5.5h3.3L13 5.2Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeRegularIcon, 'DocumentLandscapeRegular');

const DocumentLandscapeDataFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11ZM9 7a1 1 0 0 1 2 0v6a1 1 0 1 1-2 0V7Zm5 1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm-9 3a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0v-2Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeDataFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeDataFilledIcon, 'DocumentLandscapeDataFilled');

const DocumentLandscapeDataRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 4A2.5 2.5 0 0 0 2 6.5v7A2.5 2.5 0 0 0 4.5 16h11a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 15.5 4h-11ZM3 6.5C3 5.67 3.67 5 4.5 5h11c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5h-11A1.5 1.5 0 0 1 3 13.5v-7ZM6 10c-.83 0-1.5.67-1.5 1.5v1a1.5 1.5 0 0 0 3 0v-1c0-.83-.67-1.5-1.5-1.5Zm-.5 1.5a.5.5 0 0 1 1 0v1a.5.5 0 0 1-1 0v-1Zm3-4a1.5 1.5 0 1 1 3 0v5a1.5 1.5 0 0 1-3 0v-5ZM10 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 1 0v-5A.5.5 0 0 0 10 7Zm4 1c-.83 0-1.5.67-1.5 1.5v3a1.5 1.5 0 0 0 3 0v-3c0-.83-.67-1.5-1.5-1.5Zm-.5 1.5a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0v-3Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeDataRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeDataRegularIcon, 'DocumentLandscapeDataRegular');

const DocumentLandscapeSplitFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 8.5V4h-2v12h6a2 2 0 0 0 2-2v-4h-4.5A1.5 1.5 0 0 1 12 8.5ZM9 16H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h5v12Zm4-7.5V4.06c.24.07.47.2.65.38l3.91 3.91c.18.18.31.4.38.65H13.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitFilledIcon, 'DocumentLandscapeSplitFilled');

const DocumentLandscapeSplitRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 16a2 2 0 0 0 2-2V9.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 12.59 4H4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h12Zm1-2a1 1 0 0 1-1 1h-6V5h2v3.5c0 .83.67 1.5 1.5 1.5H17v4ZM9 5v10H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5Zm4 3.5V5.2L16.8 9h-3.3a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitRegularIcon, 'DocumentLandscapeSplitRegular');

const DocumentLandscapeSplitHintFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H4a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0V6Zm1 9a1 1 0 0 1-1-1v-.5a.5.5 0 0 0-1 0v.5c0 1.1.9 2 2 2h.5a.5.5 0 0 0 0-1H4ZM2.5 8c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0v-3c0-.28.22-.5.5-.5Zm4-4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2ZM6 15.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5Zm6-7V4h-1.5a.5.5 0 0 0-.5.5v11c0 .28.22.5.5.5H16a2 2 0 0 0 2-2v-4h-4.5A1.5 1.5 0 0 1 12 8.5Zm1 0V4.06c.24.07.47.2.65.38l3.91 3.91c.18.18.31.4.38.65H13.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitHintFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitHintFilledIcon, 'DocumentLandscapeSplitHintFilled');

const DocumentLandscapeSplitHintRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a1 1 0 0 1 1-1h.5a.5.5 0 0 0 0-1H4a2 2 0 0 0-2 2v.5a.5.5 0 0 0 1 0V6Zm6.5-2a.5.5 0 0 0-.5.5v11c0 .28.22.5.5.5H16a2 2 0 0 0 2-2V9.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 12.59 4H9.5Zm.5 11V5h2v3.5c0 .83.67 1.5 1.5 1.5H17v4a1 1 0 0 1-1 1h-6Zm3.5-6a.5.5 0 0 1-.5-.5V5.2L16.8 9h-3.3ZM3 14a1 1 0 0 0 1 1h.5a.5.5 0 0 1 0 1H4a2 2 0 0 1-2-2v-.5a.5.5 0 0 1 1 0v.5Zm0-5.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0v-3Zm3-4c0-.28.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM6.5 15a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
    fill: primaryFill
  }));
};

export const DocumentLandscapeSplitHintRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLandscapeSplitHintRegularIcon, 'DocumentLandscapeSplitHintRegular');

const DocumentLinkFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5h-3.26a4.5 4.5 0 0 0-3.74-7H4V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM5 12.5a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5Zm6 3A3.5 3.5 0 0 0 7.5 12h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5ZM7.5 15H4.41a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1Z",
    fill: primaryFill
  }));
};

export const DocumentLinkFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLinkFilledIcon, 'DocumentLinkFilled');

const DocumentLinkRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v7h1V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-2.26c-.12.36-.3.7-.5 1H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM5 12.5a.5.5 0 0 0-.5-.5h-.2a3.5 3.5 0 0 0 .2 7h.09a.5.5 0 0 0-.09-1h-.16a2.5 2.5 0 0 1 .16-5h.09a.5.5 0 0 0 .41-.5Zm6 3A3.5 3.5 0 0 0 7.5 12h-.09a.5.5 0 0 0 .09 1h.16a2.5 2.5 0 0 1-.16 5l-.1.01a.5.5 0 0 0 .1 1V19h.2a3.5 3.5 0 0 0 3.3-3.5ZM7.5 15H4.41a.5.5 0 0 0 .09 1h3.09a.5.5 0 0 0-.09-1Z",
    fill: primaryFill
  }));
};

export const DocumentLinkRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLinkRegularIcon, 'DocumentLinkRegular');

const DocumentLockFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H10v-4a2 2 0 0 0-1.5-1.94V12A3 3 0 0 0 4 9.4V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM3.5 12v1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const DocumentLockFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLockFilledIcon, 'DocumentLockFilled');

const DocumentLockRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.4c.3-.17.64-.3 1-.36V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-4v1h4a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM3.5 12v1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-1a2 2 0 1 0-4 0Zm1 1v-1a1 1 0 1 1 2 0v1h-2Zm1 2.25a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z",
    fill: primaryFill
  }));
};

export const DocumentLockRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentLockRegularIcon, 'DocumentLockRegular');

const DocumentMarginsFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2v-3.5a.5.5 0 0 1 1 0V18h6v-3.5a.5.5 0 0 1 1 0V18a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2v3.5a.5.5 0 0 1-1 0V2H7v3.5a.5.5 0 0 1-1 0V2Zm.5 11a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5Zm7 0a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5Z",
    fill: primaryFill
  }));
};

export const DocumentMarginsFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMarginsFilledIcon, 'DocumentMarginsFilled');

const DocumentMarginsRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 13a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5Zm7 0a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5ZM4 4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm3-1v2.5a.5.5 0 0 1-1 0V3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1v-2.5a.5.5 0 0 1 1 0V17h6v-2.5a.5.5 0 0 1 1 0V17a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1v2.5a.5.5 0 0 1-1 0V3H7Z",
    fill: primaryFill
  }));
};

export const DocumentMarginsRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMarginsRegularIcon, 'DocumentMarginsRegular');

const DocumentMentionFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2v4.5c0 .83.67 1.5 1.5 1.5H16v8.5c0 .83-.67 1.5-1.5 1.5H8.39l-.04-.18C9.95 17.63 11 16.1 11 14.5a5.5 5.5 0 0 0-7-5.3V3.5C4 2.67 4.67 2 5.5 2H10Zm1 .25V6.5c0 .28.22.5.5.5h4.25L11 2.25ZM10 14.5a4.5 4.5 0 1 0-3.14 4.29l.19-.06.06-.03a.54.54 0 0 0-.43-.99l-.14.05-.2.06a3.43 3.43 0 1 1 2.58-3.32c0 .74-.45 1.26-.9 1.26-.34 0-.54-.36-.54-1.26v-1.87a.54.54 0 0 0-1-.2 1.8 1.8 0 0 0-.98-.27c-1.22 0-1.98 1.1-1.98 2.34 0 1.25.76 2.34 1.98 2.34.55 0 1-.22 1.34-.58.26.37.66.58 1.18.58 1.09 0 1.98-1.04 1.98-2.34Zm-5.4 0c0-.72.38-1.26.9-1.26s.9.54.9 1.26-.38 1.26-.9 1.26-.9-.54-.9-1.26Z",
    fill: primaryFill
  }));
};

export const DocumentMentionFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMentionFilledIcon, 'DocumentMentionFilled');

const DocumentMentionRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 2a2 2 0 0 0-2 2v5.2c.32-.08.66-.15 1-.18V4a1 1 0 0 1 1-1h4v3.5c0 .83.67 1.5 1.5 1.5H15v8a1 1 0 0 1-1 1h-4c-.43.44-1 .74-1.65.82l.04.18H14a2 2 0 0 0 2-2V7.41c0-.4-.16-.78-.44-1.06l-3.91-3.91A1.5 1.5 0 0 0 10.59 2H6Zm8.8 5h-3.3a.5.5 0 0 1-.5-.5V3.2L14.8 7ZM6.67 17.71a.54.54 0 0 1 .43.99l-.06.03-.19.06A4.5 4.5 0 1 1 10 14.5c0 1.3-.89 2.34-1.98 2.34-.52 0-.92-.2-1.18-.58a1.8 1.8 0 0 1-1.38.58A1.82 1.82 0 0 1 4 16.07a2.66 2.66 0 0 1-.48-1.57c0-.6.17-1.15.48-1.57a1.84 1.84 0 0 1 2.47-.5.54.54 0 0 1 1 .2l.01.07v1.8c0 .9.2 1.26.54 1.26.45 0 .9-.52.9-1.26a3.42 3.42 0 1 0-2.59 3.32l.2-.06.15-.05ZM5 13.44c-.25.22-.4.6-.4 1.06 0 .46.15.84.4 1.06.14.13.31.2.5.2.52 0 .9-.54.9-1.26s-.38-1.26-.9-1.26a.74.74 0 0 0-.5.2Z",
    fill: primaryFill
  }));
};

export const DocumentMentionRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMentionRegularIcon, 'DocumentMentionRegular');

const DocumentMultipleFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v11c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 9 6.5Zm1 0V2.25L14.75 7H10.5a.5.5 0 0 1-.5-.5ZM17 9a1 1 0 0 0-1-1v6a3 3 0 0 1-3 3H6a1 1 0 0 0 1 1h6.06A3.94 3.94 0 0 0 17 14.06V9Z",
    fill: primaryFill
  }));
};

export const DocumentMultipleFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleFilledIcon, 'DocumentMultipleFilled');

const DocumentMultipleRegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4c0-1.1.9-2 2-2h3.59c.4 0 .78.16 1.06.44l3.91 3.91c.28.28.44.67.44 1.06V14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V8h-3.5A1.5 1.5 0 0 1 9 6.5V3H6Zm4 .2v3.3c0 .28.22.5.5.5h3.3L10 3.2ZM17 9a1 1 0 0 0-1-1v6a3 3 0 0 1-3 3H6a1 1 0 0 0 1 1h6.06A3.94 3.94 0 0 0 17 14.06V9Z",
    fill: primaryFill
  }));
};

export const DocumentMultipleRegular = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultipleRegularIcon, 'DocumentMultipleRegular');

const DocumentMultiplePercentFilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 6.5V2H5.5C4.67 2 4 2.67 4 3.5v5.67a3 3 0 0 1 2 2.71l1.44-1.44a1.5 1.5 0 0 1 2.12 2.12L8.12 14a3 3 0 0 1 2.7 2h2.68c.83 0 1.5-.67 1.5-1.5V8h-4.5A1.5 1.5 0 0 1 9 6.5ZM5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-1.15 5.85a.5.5 0 0 1-.7-.7l6-6a.5.5 0 0 1 .7.7l-6 6Zm10.21.15h-2.23a3 3 0 0 0 .17-1h2a3 3 0 0 0 3-3V8a1 1 0 0 1 1 1v5.06A3.94 3.94 0 0 1 13.06 18ZM8 15a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm-1 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm3-10.5V2.25L14.75 7H10.5a.5.5 0 0 1-.5-.5Z",
    fill: primaryFill
  }));
};

export const DocumentMultiplePercentFilled = /*#__PURE__*/wrapIcon( /*#__PURE__*/DocumentMultiplePercentFilledIcon, 'DocumentMultiplePercentFilled');